<template>
 <div class="reveal">
  <div class="slides">

    <section :id="filtered_chapter_id(3)">
      <h1 id="doc_chapter" v-html="filtered_chapter_title(3)">
      </h1>
    </section>

    <!--
    <section>
      <section :id="filtered_section_id(0, 1)">
        <h2 id="doc_section" v-html="filtered_section_title(0, 1)">
        </h2>
      </section>
      --> 

      <section>
         <span v-if="seminar_hosted==false && seminar_joined==false">
	   <h2>Host Seminar</h2>
         </span>
         <span v-else-if="seminar_hosted==true">
	   <h2>Hosting Seminar Room</h2>
         </span>
         <span v-else-if="seminar_joined==true">
	   <h2>Joined in Seminar Room</h2>
         </span>
         <div id="div_seminar_host">
	   <div>password: <input type="password" id="password" style="font-size:70%;"></div>
	   <div>click <a id="host" href="#"><i class="fa fa-users"></i></a> to host the seminar</div>
         </div>
         <div id="div_seminar_close">
          click 
          <a id="close" href="#"><i class="fa fa-window-close"></i></a> 
          to close the seminar room
         </div>
      </section>

      <section>
         <span v-if="seminar_hosted==false && seminar_joined==false">
	   <h2>No Seminar Room</h2>
         </span>
         <span v-else-if="seminar_hosted==true">
	   <h2>Invite Clients</h2>
         </span>
         <span v-else-if="seminar_joined==true">
	   <h2>Seminar Room</h2>
         </span>
         <span v-else>
	   <h2></h2>
         </span>
	 <div id="div_seminar_room">
	   <div>
	     <canvas id="qrcode" style="width:300px;height:300px;"></canvas>
	   </div>				
	   <a id="room"></a>
         </div>
      </section>

    <!--
    </section>
      --> 

    <section>

      <section :id="filtered_section_id(3, 1)">
        <h2 id="doc_section" v-html="filtered_section_title(3, 1)">
        </h2>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlhist}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlhist01" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlhist}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlhist02" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlhist}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlhist03" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlhist}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlhist04" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlhist}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlhist05" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlhist}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlhist06" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlfeat}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlfeat" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section data-markdown>
        <textarea data-template v-for="item in cardcont_ch03_sqlfun">
          {{item}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template v-for="item in cardcont_ch03_sqlform01">
          {{item}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template v-for="item in cardcont_ch03_sqlform02">
           {{item}}
        </textarea>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlform}}            
              <!--
              <el-button class="button" text>Operation button</el-button>
                -->
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlform03" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section data-markdown>
        <textarea data-template v-for="item in cardcont_ch03_sqlform04">
           {{item}}
        </textarea>
      </section>

    </section>

    <section>

      <section :id="filtered_section_id(3, 2)">
        <h2 id="doc_section" v-html="filtered_section_title(3, 2)">
        </h2> 
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlcreateuser}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlusertab}}
           <style type="text/css"> img[alt=mysqlusertab] { width: 85%; } </style> 
           &emsp; ![mysqlusertab]({{cardcont_ch03_imgmysqlusertab}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqldeluser}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlrnuser}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlchuserpwd}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlforgetuserpwd}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlrole}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlgrant02}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlgrant03}}
        </textarea>
      </section>

      <section data-background-color="white">
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_mysqlaccobjs}}            
              <!--
              <el-button class="button" text>Operation button</el-button>
                -->
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="item in cardcont_ch03_mysqlaccobjs">
              {{item}}
            </div>
	    <!--
            <div style="display: block; ">
              <img :src="cardcont_ch02_imgoptexample0203" style="width: 85%;" />
            </div>
	      --> 
          </div>
        </el-card>
      </section>

      <section data-background-color="white">
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_mysqlaccobjs01}}            
              <!--
              <el-button class="button" text>Operation button</el-button>
                -->
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="item in cardcont_ch03_mysqlaccobjs01">
              {{item}}
            </div>
	    <!--
            <div style="display: block; ">
              <img :src="cardcont_ch02_imgoptexample0203" style="width: 85%;" />
            </div>
	      --> 
          </div>
        </el-card>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlgrantexample}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlrevoke}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_mysqlrevokeexample}}
        </textarea>
      </section>

      <section data-background-color="white">
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_mysqlflushpriv}}            
              <!--
              <el-button class="button" text>Operation button</el-button>
                -->
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="item in cardcont_ch03_mysqlflushpriv">
              {{item}}
            </div>
	    <!--
            <div style="display: block; ">
              <img :src="cardcont_ch02_imgoptexample0203" style="width: 85%;" />
            </div>
	      --> 
          </div>
        </el-card>
      </section>

    </section>

    <section>

      <section :id="filtered_section_id(3, 3)">
        <h2 id="doc_section" v-html="filtered_section_title(3, 3)">
        </h2>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlddl01}}            
              <!--
              <el-button class="button" text>Operation button</el-button>
                -->
            </div>
          </template>
          <div> 
            <div style="display: block; ">
              <img :src="cardcont_ch03_imgsqlddl01" style="width: 90%;" />
            </div>
          </div>
        </el-card>
      </section>

      <!--
      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlform05}}
           <style type="text/css"> img { width: 80%; } </style> 
           ![]({{cardcont_ch03_imgsqlddl01}})
           {{cardcont_ch03_sqlform05}}
        </textarea>
      </section>
	-->

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlddl02}}            
            </div>
          </template>
          <div> 
            <div style="display: block; ">
              <img :src="cardcont_ch03_imgsqlddl02" style="width: 80%;" />
            </div>
          </div>
        </el-card>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlddl03}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlddl03" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section data-markdown>
        <textarea data-template v-for="item in cardcont_ch03_sqlddl04">
           {{item}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template v-for="item in cardcont_ch03_sqlddl05">
           {{item}}
        </textarea>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlddl06}}            
            </div>
          </template>
          <div> 
            <div class="card-body" v-for="(value, key) in cardcont_ch03_sqlddl06" v-html="value">
            </div>
          </div>
        </el-card>
      </section>

      <section>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              {{cardname_ch03_sqlddl07}}            
            </div>
          </template>
          <div> 
            <div style="display: block; ">
              <img :src="cardcont_ch03_imgsqlddl07" style="width: 100%;" />
            </div>
          </div>
        </el-card>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl08}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl09}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl10}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl11}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl12}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl13}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl14}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl15}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl16}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl16_01}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl16_02}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl17}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl18}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl19}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl20}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl21}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl21_01}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl21_02}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl21_03}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl22}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl22_01}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl23}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl24}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl25}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl26}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl27}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl28}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl29}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl30}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl31}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl32}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl33}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl34}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl35}} 
           <style type="text/css"> img[alt=ddl35] { width: 60%; } </style> 
           &emsp; ![ddl35]({{cardcont_ch03_imgsqlddl35}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl36}} 
           <style type="text/css"> img[alt=ddl36] { width: 60%; } </style> 
           &emsp; ![ddl36]({{cardcont_ch03_imgsqlddl36}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl37}} 
           <style type="text/css"> img[alt=ddl37] { width: 30%; } </style> 
           &emsp; ![ddl37]({{cardcont_ch03_imgsqlddl37}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl38}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl39}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl40}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl41}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl41_01}}
           <style type="text/css"> img[alt=ddl41_01] { width: 80%; } </style> 
           &emsp; ![ddl41_01]({{cardcont_ch03_imgsqlddl41_01}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl41_02}}
           <style type="text/css"> img[alt=ddl41_01] { width: 80%; } </style> 
           &emsp; ![ddl41_01]({{cardcont_ch03_imgsqlddl41_02}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl42}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl43}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl44}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl45}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl46}}
           <style type="text/css"> img[alt=ddl46] { width: 40%; } </style> 
           &emsp; ![ddl46]({{cardcont_ch03_imgsqlddl37}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl47}}
           <style type="text/css"> img[alt=ddl47_01] { width: 60%; } </style> 
           &emsp; ![ddl47_01]({{cardcont_ch03_imgsqlddl41_01}})
           <style type="text/css"> img[alt=ddl47_02] { width: 70%; } </style> 
           &emsp; ![ddl47_02]({{cardcont_ch03_imgsqlddl47}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl48}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl49}}
           <style type="text/css"> img[alt=ddl49] { width: 40%; } </style> 
           &emsp; ![ddl49]({{cardcont_ch03_imgsqlddl49}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl50}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl51}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           <style type="text/css">
             .ddl52 ol li { list-style-type: lower-alpha; }
	   </style>
           {{cardcont_ch03_sqlddl52}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           <style type="text/css">
             .ddl53 ol li { list-style-type: lower-alpha; }
	   </style>
           {{cardcont_ch03_sqlddl53}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlddl54}}
        </textarea>
      </section>

    </section>

    <section>

      <section :id="filtered_section_id(3, 4)">
        <h2 id="doc_section" v-html="filtered_section_title(3, 4)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint01}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint02}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint03}}
           <style type="text/css"> img[alt=int03] { width: 75%; } </style> 
           &emsp; ![int03]({{cardcont_ch03_imgsqlint03}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint04}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint05}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint06}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint07}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint08}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint09}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint10}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint11}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint12}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint13}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint14}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint15}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint16}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint17}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint18}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint19}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint20}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint21}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint22}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqlint23}}
        </textarea>
      </section>

    </section>

    <section>

      <section :id="filtered_section_id(3, 5)">
        <h2 id="doc_section" v-html="filtered_section_title(3, 5)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml01}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml02}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml03}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml04}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml05}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml06}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml07}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml08}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml09}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml10}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldml11}}
        </textarea>
      </section>

    </section>

    <section data-background-color="white">

      <section :id="filtered_section_id(3, 6)">
        <h2 id="doc_section" v-html="filtered_section_title(3, 6)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql01}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql02}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_dreamHome}}
           {{cardcont_ch03_dreamHomeBranch}}
	   {{cardcont_ch03_dreamHomeStaff}}
	   {{cardcont_ch03_dreamHomePropertyForRent}}	
	   {{cardcont_ch03_dreamHomeClient}}	
	   {{cardcont_ch03_dreamHomePrivateOwner}}	
	   {{cardcont_ch03_dreamHomeViewing}}	
	   {{cardcont_ch03_dreamHomeRegistration}}	
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
          {{cardcont_ch03_studentCourse}} <div style="text-align: left; display: grid; grid-template-columns: 58% 42%;"> <div>
	      {{cardcont_ch03_tabStudent}} {{cardcont_ch03_tabSelCourse}} </div> <div>  
	      {{cardcont_ch03_tabCourse}} </div> </div>
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql03}}
           <style type="text/css"> img[alt=dql03] { width: 55%; } </style> 
           &emsp; ![dql03]({{cardcont_ch03_imgdql03}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql04}}
           <style type="text/css"> img[alt=dql04] { width: 55%; } </style> 
           &emsp; ![dql04]({{cardcont_ch03_imgdql04}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql05}}
           <style type="text/css"> img[alt=dql05] { width: 20%; } </style> 
           &emsp; ![dql05]({{cardcont_ch03_imgdql05}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql06}}
           <style type="text/css"> img[alt=dql06] { width: 50%; } </style> 
           &emsp; ![dql06]({{cardcont_ch03_imgdql06}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql07}}
           <style type="text/css"> img[alt=dql07] { width: 70%; } </style> 
           &emsp; ![dql07]({{cardcont_ch03_imgdql07}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql08}}
           <style type="text/css"> img[alt=dql08] { width: 70%; } </style> 
           &emsp; ![dql08]({{cardcont_ch03_imgdql08}})
        </textarea>
      </section>
      
      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql09}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql10}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql11}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql12}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql13}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql14}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql15}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql16}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql17}}
           <style type="text/css"> img[alt=dql17] { width: 60%; } </style> 
           &emsp; ![dql17]({{cardcont_ch03_imgdql17}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql18}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql19}}
           <style type="text/css"> img[alt=dql19] { width: 20%; } </style> 
           &emsp; ![dql19]({{cardcont_ch03_imgdql19}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql20}}
           <style type="text/css"> img[alt=dql20] { width: 15%; } </style> 
           &emsp; ![dql20]({{cardcont_ch03_imgdql20}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql21}}
           <style type="text/css"> img[alt=dql21] { width: 30%; } </style> 
           &emsp; ![dql21]({{cardcont_ch03_imgdql21}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql22}}
           <style type="text/css"> img[alt=dql22] { width: 30%; } </style> 
           &emsp; ![dql22]({{cardcont_ch03_imgdql22}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql23}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql24}}
           <style type="text/css"> img[alt=dql24] { width: 35%; } </style> 
           &emsp; ![dql24]({{cardcont_ch03_imgdql24}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql25}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql26}}
           <style type="text/css"> img[alt=dql26] { width: 40%; } </style> 
           &emsp; ![dql26]({{cardcont_ch03_imgdql26}})
        </textarea>
      </section>

    </section>

    <section data-background-color="white">

      <section :id="filtered_section_id(3, 7)">
        <h2 id="doc_section" v-html="filtered_section_title(3, 7)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0201}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0202}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0203}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0204}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0205}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0206}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0207}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0208}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0209}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0210}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0211}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0212}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0213}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0214}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0215}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0216}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0217}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0218}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0219}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0220}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0221}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0222}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0223}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0224}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0225}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0226}} <div style="display: grid; grid-template-columns: 50% 50%;"> <div>
	      {{cardcont_ch03_sqldql0226_code01}}  </div> <div>  
	      {{cardcont_ch03_sqldql0226_code02}} </div> </div>
	   {{cardcont_ch03_sqldql0226_01}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0227}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0228}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0229}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>

<div class="boxbody">

### 子查询
****

<span style="font-size: 80%"> 

带EXISTS谓词的子查询

</span>
<span style="font-size: 55%"> 

用NOT EXISTS谓词定义完整性断言约束

例 请用SQL的断言机制定义完整性约束：学生必须在选修‘数学’课后，才能选修其他课程。

</span>
<span style="font-size: 90%"> 

```
CREATE ASSERTION AsseMath01 CHECK ( 
 NOT EXISTS ( 
  SELECT sno FROM StuCourse 
  WHERE cno IN ( 
   SELECT cno FROM Course
   WHERE cname &lt;> '数学'
  )
  AND sno NOT IN ( 
   SELECT sno FROM StuCourse
    WHERE cno IN ( 
     SELECT cno FROM Course WHERE cname='数学'
    )
  )
 )
);
```

</span>

</div>

<!--

<div class="boxbody">

### 子查询
****

<span style="font-size: 80%"> 

带EXISTS谓词的子查询

</span>
<span style="font-size: 55%"> 

用NOT EXISTS谓词定义完整性断言约束

例 请用SQL的断言机制定义完整性约束：学生必须在选修‘数学’课后，才能选修其他课程。

</span>
<span style="font-size: 90%"> 

```
CREATE ASSERTION AsseMath02 CHECK (
 NOT EXISTS ( 
  SELECT * FROM StuCourse AS StuCourseA 
  WHERE NOT EXISTS (
   SELECT * FROM StuCourse AS StuCourseB, Course 
   WHERE StuCourseA.sno＝StuCourseB.sno 
    AND StuCourseB.cno＝Course.cno AND Course.cname&lt;>'数学'
  )
 )
);
```

</span>

</div>
-->

        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0230}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0231}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0232}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0233}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0234}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0235}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0236}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0237}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0238}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0239}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0240}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0241}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0242}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0243}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0244}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0245}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0246}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0247}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0247_01}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0247_02}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0247_03}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0247_04}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0247_05}}
           <style type="text/css"> img[alt=dql0247_05] { width: 60%; } </style> 
           &emsp; ![dql0247_05]({{cardcont_ch03_imgdql0247_05}})
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0247_06}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0247_07}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0248}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0249}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0250}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0251}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0252}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0253}} <span style = 'font-size: 50%;'> 	
           {{cardcont_ch03_tabCourse01}} </span>	
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_sqldql0254}}
        </textarea>
      </section>

    </section>

    <section data-background-color="white">

      <section :id="filtered_section_id(3, 8)">
        <h2 id="doc_section" v-html="filtered_section_title(3, 8)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_procfunsynax}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_procexample}}
        </textarea>
      </section>

      <section data-markdown>
        <textarea data-template>
           {{cardcont_ch03_funcexample}}
        </textarea>
      </section>

    </section>

    <section data-background-color="white">

      <section :id="filtered_section_id(3, 9)">
        <h2 id="doc_section" v-html="filtered_section_title_thanks(3, 9)">
        </h2>
      </section>

    </section>

  </div>
 </div>
</template>


<script>
  import { isProxy, toRaw } from 'vue';
  import { reactive } from "vue";
  import VueHead from 'vue-head';
 
  import config from '../config.js';

  // import Reveal from 'reveal.js/dist/reveal.esm.js';
  // import Reveal from 'reveal.js';
  import Reveal from 'reveal.js/dist/reveal.js';
  import RevealMath from "reveal.js/plugin/math/math.esm";
  // import RevealSearch from "reveal.js/plugin/search/plugin.js";
  import speakerViewHTML from '@/assets/html/speaker-view.html';

  import { ElMessage } from 'element-plus';
  import { axios } from "axios";

  import { EditorState } from "@codemirror/state";
  import { EditorView, lineNumbers, highlightActiveLine} from "@codemirror/view";
  import { defaultKeymap } from "@codemirror/commands";
  import { bracketMatching, defaultHighlightStyle, syntaxHighlighting} from '@codemirror/language';
  import { python } from "@codemirror/lang-python";
  import { sql } from "@codemirror/lang-sql";
  import { bbedit } from '@uiw/codemirror-theme-bbedit';

  import { marked } from 'marked';
  import { mangle } from "marked-mangle";
  import { gfmHeadingId } from "marked-gfm-heading-id";

  import { io } from "socket.io-client";
  
  import QRious from "qrious";    

  import Chart from 'chart.js/auto'; 

  import links_html from '@/viewsslidescn/outline_db_03sql.html';
  // import example_md from '@/viewsslidescn/example.md';

  export default {
    name: "slides_iframe_db_chap03",

    /*
    components: {
       AudioPlayer,
    },
     */
	
    data(){
      return {
	Reveal: 0, 
    
        // example_md,

        g_slide_id: 'dmdb',
        g_reveal_theme: "white",
        links_html,

        whu_logo: require('../assets/db/dm/whu_logo.svg'),

        eraser_src: require('../assets/imgs/chalkboard/sponge.png'),
        boardmarker_black: require('../assets/imgs/chalkboard/boardmarker-black.png'),
        boardmarker_blue: require('../assets/imgs/chalkboard/boardmarker-blue.png'),
        boardmarker_red: require('../assets/imgs/chalkboard/boardmarker-red.png'),
        boardmarker_green: require('../assets/imgs/chalkboard/boardmarker-green.png'),
        boardmarker_orange: require('../assets/imgs/chalkboard/boardmarker-orange.png'),
        boardmarker_purple: require('../assets/imgs/chalkboard/boardmarker-purple.png'),
        boardmarker_yellow: require('../assets/imgs/chalkboard/boardmarker-yellow.png'),
        chalk_white: require('../assets/imgs/chalkboard/chalk-white.png'),
        chalk_blue: require('../assets/imgs/chalkboard/chalk-blue.png'),
        chalk_red: require('../assets/imgs/chalkboard/chalk-red.png'),
        chalk_green: require('../assets/imgs/chalkboard/chalk-green.png'),
        chalk_orange: require('../assets/imgs/chalkboard/chalk-orange.png'),
        chalk_purple: require('../assets/imgs/chalkboard/chalk-purple.png'),
        chalk_yellow: require('../assets/imgs/chalkboard/chalk-yellow.png'),
        blackboard_png: require('../assets/imgs/chalkboard/blackboard.png'),
        whiteboard_png: require('../assets/imgs/chalkboard/whiteboard.png'),
        // chalkboard_src: require('../assets/chalkboard/chalkboard.json'),

        seminar_hosted: false, 
        seminar_joined: false, 

        chapter_titles:
          [
           'Course Overview',
	   '数据库简介',
	   '关系数据模型<br />与关系代数',
	   '结构化查询<br />语言SQL',			
	   '数据库设计与应用',			
	   '关系模式规范化',
	   '事务管理与<br />并发控制',	
          ],

        chapter_ids:
          [
           'overview',
	   'intro',
	   'relation',
	   'sql',			
	   'dbdesing',			
	   'normal',
	   'tran',	
	   'nosql',
           'review',	
          ],

        sections_titles:
          [
           [		
           'General Information',
           'Reference and Resources',
           'Grading',
           'Course Contents',
           'Thank You! <br />Any Questions?',
           ],
           [
           '信息与数据',
           '数据管理',
           '数据库系统发展',
           '数据库系统需求',
           '数据库系统组成结构',
           '常用数据库系统',
	   'Thank You! <br />Any Questions?',	
           ],
           [
		'关系数据模型',
		'关系完整性约束',
		'关系代数',
		'查询优化',
		'about key-value database',
		'Thank You! <br />Any Questions?',	
           ],
           [
		'SQL概述',
		'SQL访问控制',
		'SQL数据定义',
		'SQL定义完整性',
		'SQL数据操作',
		'简单查询',
		'复杂查询',
		'SQL过程与函数',
		'Thank You! <br />Any Questions?',	
           ],
          ],

        sections_ids:
          [
           [		
            'geninfo',
            'ref',
            'grade', 
            'content',
            'thanks',
           ],
           [
            'infodata',
            'infomgm',
            'dbsysdev',
            'dbsysreq',
            'dbsyscomp',
            'dbsyslist',
	    'thanks',	
           ],
           [
		'rmod',
		'rint',
		'ralg',
		'queopt',
		'aboutkvdb',
		'thanks',
           ],
           [
		'sql_intro',
		'acc_ctl',
		'ddl',
		'def_int',
		'dml',
		'simp_que',
		'cplx_que',
		'fun_proc',
		'thanks',
           ],
           [
           ],
           [
           ],
           [
           ],
           [
           ],
           [
           ],
          ],

        cardname_ch03_sqlhist: 'SQL历史',
        cardcont_ch03_sqlhist01:
                [
			'关系模型起源于1970年IBM San Jose研究室E. F. Codd发表的论文 "A Relational Model of Data for Large Shared Data Banks"',
			'1974年, IBM San Jose研究室的D. Chamberlin定义了一种称为SQL的结构化英语查询语言，或称为SEQUEL，76年其修改版本SEQUEL/2出现',
			'SQL读为"see-quel", 官方读法"S-Q-L"', 
                ],
        cardcont_ch03_sqlhist02:
                [
			'SQL-86	SQL-87, First formalized by ANSI', 
			'SQL-89	FIPS 127-1, Minor revision that added integrity constraints',
			'SQL-92	SQL2, FIPS 127-2, Major revision (ISO 9075)',
                ],
        cardcont_ch03_sqlhist03:
                [
			'SQL:1999 SQL3, Added regular expression matching, recursive queries (e.g., transitive closure), triggers, support for procedural and control-of-flow statements, nonscalar types (arrays), and some object-oriented features (e.g., structured types), support for embedding SQL in Java (SQL/OLB) and vice versa (SQL/JRT)',  
			'SQL:2003, Introduced XML-related features (SQL/XML), window functions, standardized sequences, and columns with autogenerated values (including identity columns)',
                ],
        cardcont_ch03_sqlhist04:
                [
			'SQL:2006, ISO/IEC 9075-14:2006 defines ways that SQL can be used with XML. It defines ways of importing and storing XML data in an SQL database, manipulating it within the database, and publishing both XML and conventional SQL data in XML form. In addition, it lets applications integrate queries into their SQL code with XQuery, the XML Query Language published by the World Wide Web Consortium (W3C), to concurrently access ordinary SQL-data and XML documents.',
                ],
        cardcont_ch03_sqlhist05:
                [
			'SQL:2008, Legalizes ORDER BY outside cursor definitions. Adds INSTEAD OF triggers, TRUNCATE statement, FETCH clause',
			'SQL:2011, Adds temporal data (PERIOD FOR). Enhancements for window functions and FETCH clause.',
			'SQL:2016, Adds row pattern matching, polymorphic table functions, operations on JSON data stored in character string fields',
                ],
        cardcont_ch03_sqlhist06:
                [
			'SQL:2019-2020, Adds Part 15, multidimensional arrays (MDarray type and operators)',
			'SQL:2023, Adds data type JSON (SQL/Foundation); Adds Part 16, Property Graph Queries (SQL/PGQ)',
                ],

        cardname_ch03_sqlfeat: 'SQL特点',
        cardcont_ch03_sqlfeat:
                [
			'简洁易学, SQL命令由标准英语单词所组成',
			'是一个非过程性语言，用户只需要描述所需的信息 (what)，不需给出获取该信息的具体过程 (how), 面向集合操作',
			'SQL集定义、操作、查询和控制为一体', 
			'两种使用方式，统一的语法结构',
                ],

        cardname_ch03_sqlfun: 'SQL功能',
        cardcont_ch03_sqlfun:
                [
           		'<style type="text/css"> .reveal p { text-align: left; } .reveal ul { display: block; } .reveal ol { display: block; } </style> \n ## SQL功能 \n - 数据定义 DDL (Data Define Language): <br /> CREATE, DROP, ALTER \n - 数据操纵 DML (Data Manipulation Language): INSERT, UPDAT, DELETE \n  - 数据查询 DQL (Data Query Language): <br /> SELECT \n - 数据控制 DCL (Data Control Language): <br /> GRANT, REVOKE', ],

        cardname_ch03_sqlform: 'SQL格式约定',
        cardcont_ch03_sqlform01:
                [
			'<style type="text/css"> .reveal p { text-align: left; } .reveal ul { display: block; } .reveal ol { display: block; } </style> \n ## SQL格式约定 \n - SQL是一种自由格式语言：它对每一行的字符数不作限定，也不要求一个SQL语句一定分成几行来写 \n - 以分号结束语句 \n - SQL的编译器不区分大小写 (字符常量除外)',
                ],
        cardcont_ch03_sqlform02:
                [
			'<style type="text/css"> .reveal p { text-align: left; } .reveal ul { display: block; } .reveal ol { display: block; } </style> \n ## SQL格式约定 \n 增强SQL语句的可读性 \n - 用**分行**、**对齐**和**缩进**方法 \n     - 分行: 每一个子句在新的一行开始书写 \n     - 对齐: 各子句的开始处在同一列上 \n    - 缩进: 如果子句由几个部分组成，则它们应当出现在不同的行，并在开始处使用缩进方式表示这种关系 \n- SQL的保留字使用大写',
                ],
        cardcont_ch03_sqlform03:
                [
			'保留字: SQL语言的固定部分，有固定含义, 必须准确拼写',
			'用户自定义字: 用于命名表、列、视图、索引等',
                ],
        cardcont_ch03_sqlform04:
                [
			'<style type="text/css"> .reveal p { text-align: left; } .reveal ul { display: block; } .reveal ol { display: block; } </style> \n ## SQL格式约定 \n 用扩展的巴克斯范式(Backus Naur Form, BNF)<br />定义SQL语句 \n - 大写字母用于表示保留字 \n - 小写字母用于表示用户自定义字 \n - 竖线|用于表示从选项中进行选择 \n - 大括号{}用于表示所需元素 \n - 中括号[]用于表示可选择元素 \n - 省略号$\\ldots$用于表示选择项可重复0到多次', 
                ],

        cardname_ch03_sqlddl01: 'SQL DDL 主要语句',
        cardcont_ch03_imgsqlddl01: require('../assets/db/ch03/sqlddl01.svg'),

        cardname_ch03_sqlddl02: 'SQL DDL对数据库三级模式的支持',
        cardcont_ch03_imgsqlddl02: require('../assets/db/ch03/sqlddl_3schs.svg'),

        cardname_ch03_sqlddl03: '创建和删除数据库(模式)',
        cardcont_ch03_sqlddl03:
                [
			'标准并不指定如何创建数据库, 每种具体实现都有各自不同的方式.',
			'不同数据库产品的数据库创建过程截然不同的. 创建数据库的权限通常为DBA保留.',
			'可以创建一个或多个模式, 模式中所有对象有相同的所有者并且共享一些默认值.',
                ],
        cardcont_ch03_sqlddl04:
                [
			'## 创建数据库 \n <span style="font-size: 200%;"> \n \n ``` \n CREATE SCHEMA database-name \n AUTHORIZATION user-identifier; \n ``` \n \n </span> \n \n 例 \n \n <span style="font-size: 200%;"> \n \n ``` \n CREATE SCHEMA library_db \n AUTHORIZATION Guoqing; \n ``` \n \n </span>',
                ],
        cardcont_ch03_sqlddl05:
                [
			'## 删除数据库 \n <span style="font-size: 130%;"> \n \n ``` \n DROP SCHEMA database-name [RESTRICT | CASCADE]; \n ``` \n \n </span> \n \n <span style="font-size: 70%;"> \n \n  - `RESTRICT` \ \n 模式内没有对象时，才删除该模式 \n - `CASCADE` \ \n 强制删除模式及其所有对象的内容和定义 \n \n </span> \n \n 例 \n \n <span style="font-size: 140%;"> \n \n ``` \n DROP SCHEMA library RESTRICT; \n ``` \n \n </span>',
                ],

        cardname_ch03_sqlddl06: 'SQL标识符',
        cardcont_ch03_sqlddl06: 
	[
		'标识符用于标识数据库中的对象，如表名、视图名、列名等', 
		'标识符所用的字符必须在字符集中存在, 默认的字符集包括大写字符A到Z、小写字符a到z，数字0到9和下划线字符', 
		'标识符有下列限制: 不能长于128个字符, 必须以字母开头, 不能有空格', 
	], 

        cardname_ch03_sqlddl07: 'ISO SQL数据类型',
        cardcont_ch03_imgsqlddl07: require('../assets/db/ch03/sql_datatype.svg'),

        cardcont_ch03_sqlddl08:
		'## ISO SQL数据类型 \n - 布尔型 `BOOLEAN` \ \n 值为`TRUE`、`FALSE`或`UNKNOWN` \n - 字符型 \n     - `CHAR(n)` 定长字符串 \n     - `VARCHAR(n)` 变长字符串 \n - 位类型 \ \n 二进制位串, `BIT(n)`, `BIT VARYING(n)`',

        cardcont_ch03_sqlddl09:
		'## ISO SQL数据类型 \n - 精确数字 \n      - `NUMERIC [precision[, scale]]` \n          - `precision` 数的全部位数 \n          - `scale` 小数部分的位数 \n      - `DECIMAL [precision[, scale]]` \ \n allows more than the stated precision \n      - `INTEGER` 较大的正负整数 \n      - `SMALLINT` 较小的正负整数', 

        cardcont_ch03_sqlddl10:
		'## ISO SQL数据类型 \n - 非精确数字 \n      - `FLOAT [precision]` \n     - `REAL` \n      -  `DOUBLE PRECISION`',    

        cardcont_ch03_sqlddl11:
		'## ISO SQL数据类型 \n - 日期时间型 \n      - `DATE` YEAR, MONTH, DAY \n     - `TIME [timePrecision] [WITH TIME ZONE]` \ \n HOUR, MINUTE, SECOND \n      -  `TIMESTAMP [timePrecision] [WITH TIME ZONE]`',    

        cardcont_ch03_sqlddl12:
		'## ISO SQL数据类型 \n \n <span style="font-size: 80%;"> \n \n - 时间区间型 \ \n `INTERVAL {{startField TO endField} singleDatetimeField}` \n     - `startField = YEAR | MONTH | DAY | HOUR | MINUTE [(intervalLeadingFieldPrecision)]` \n     - `endField  = YEAR | MONTH | DAY | HOUR | MINUTE | SECOND [(fractionalSecondsPrecision)]` \n      - `singleDatetimeField = startField | SECOND [(intervalLeadingFieldPrecision [, fractionalSecondsPrecision])]` \n \n </span>',    

        cardcont_ch03_sqlddl13:
		"## ISO SQL数据类型 \n  时间区间型 举例 \n \n <span style='font-size: 130%;'> \n \n ``` \nINTERVAL '145 23:12:19.345' DAY(3) TO SECOND(3) \n INTERVAL '3503:12:19.345' HOUR TO SECOND(3) \n          /* equal to the first value */ \n INTERVAL '19.345' SECOND(4,3) \n          /* maximum number of digits for the \n &ensp; &ensp; &ensp; &ensp; &ensp; &ensp; second value is 4, and each value \n         &nbsp;   is expressed with three fraction \n        &nbsp;    digits. */ \n INTERVAL '-23-10' YEAR(2) TO MONTH\n ``` \n \n </span>",   
 
        cardcont_ch03_sqlddl14:
		"## ISO SQL数据类型 \n - 大对象型 \n      - `CHARACTER LARGE OBJECT` 字符大对象 \n      - `BINARY LARGE OBJECT` 二进制大对象",    

        cardcont_ch03_sqlddl15:
		"## 创建域 \n 域为列的合法值的集合 \n \n 语法 \n \n <span style='font-size: 160%;'> \n \n ```\nCREATE DOMAIN DomainName [AS] dataType \n [DEFAULT defaultOption] \n [CHECK (searchCondition)] \n ``` \n \n </span> \n \n - 给域一个域名`DomainName`，一个数据类型，一个可选的默认值，一个可选的`CHECK`约束",    

        cardcont_ch03_sqlddl16:
		"## 创建域 \n 举例 \n \n <span style='font-size: 160%;'> \n \n ```\n CREATE DOMAIN genType AS CHAR \n DEFAULT 'M' \n CHECK (VALUE IN ('M', 'F')); \n gen genType NOT NULL; \n ``` \n \n </span>",    

        cardcont_ch03_sqlddl16_01:
		"## 修改域 \n 语法 \n \n <span style='font-size: 100%;'> \n \n ```\n ALTER DOMAIN name \n  {SET DEFAULT expression | DROP DEFAULT}; \n ALTER DOMAIN name \n  {SET | DROP} NOT NULL; \n ALTER DOMAIN name \n  ADD constraint [NOT VALID]; \n ALTER DOMAIN name \n  DROP CONSTRAINT [IF EXISTS] constraintn [RESTRICT | CASCADE]; \n ALTER DOMAIN name \n  RENAME CONSTRAINT constraintn TO new_constraintn; \n ALTER DOMAIN name \n  VALIDATE CONSTRAINT constraint_name; \n``` \n \n </span>",    
        cardcont_ch03_sqlddl16_02:
		"## 修改域 \n 语法 \n \n <span style='font-size: 100%;'> \n \n ```\n ALTER DOMAIN name \n  OWNER TO {new_owner | CURRENT_ROLE | \n         &nbsp;  CURRENT_USER | SESSION_USER}; \n ALTER DOMAIN name \n  RENAME TO new_name; \n ALTER DOMAIN name \n  SET SCHEMA new_schema; \n``` \n \n </span>",    

        cardcont_ch03_sqlddl17:
		"## 删除域 \n \n 语法 \n \n <span style='font-size: 140%;'> \n \n ```\n DROP DOMAIN DomainName [RESTRICT | CASCADE]; \n ``` \n \n </span> \n \n - `RESTRICT`, 若域用于现有表中, 则删除失败 \n - `CASCADE`, 基于域的任一表中的列都会自动改变为基本域类型, 该域的CHECK约束或默认值都会被列的约束或默认值代替 \n \n 举例 \n \n <span style='font-size: 140%;'> \n \n ```\n DROP DOMAIN genType; \n``` \n \n </span>",    

        cardcont_ch03_sqlddl18:
		"## 创建表 \n 创建表时，需要明确 \n - 表名是什么 \n - 表包括哪些列, 各列名是什么 \n - 各列的数据类型和长度是什么 \n - 列是否允许为空值 \n - 列是否取唯一值 \n - 哪些列组成表的主键 \n - 外键及被参照的关系",   
 
        cardcont_ch03_sqlddl19:
		"## 创建表 \n 语法 \n \n <span style='font-size: 125%;'> \n \n ```\n CREATE TABLE tableName ( \n  {columnName dataType [NOT NULL] [UNIQUE] \n   [DEFAULT defaultOption] \n   [CHECK (searchCondition)]}[, ...] \n  [PRIMARY KEY (listOfColumns),] \n  {[UNIQUE (listOfColumns)][, ...]} \n  {[FOREIGN KEY (listOfFKColumns) \n    REFERENCES parentTableName [(listOfCKColumns)] \n     [ON UPDATE referentialAction] \n     [ON DELETE referentialAction]][, ...]} \n  {[CHECK (searchConditions)][, ...]} \n ); \n``` \n \n </span>",    

        cardcont_ch03_sqlddl20:
		"## 创建表 \n 举例 \n \n <span style='font-size: 120%;'> \n \n ```\n CREATE DOMAIN OwnerNumber AS VARCHAR(5) \n CHECK (VALUE IN (SELECT ownerNo FROM PrivateOwner)); \n CREATE DOMAIN StaffNumber AS VARCHAR(5) \n CHECK (VALUE IN (SELECT staffNo FROM Staff)); \n CREATE DOMAIN PNumber AS VARCHAR(5); \n CREATE DOMAIN PRooms AS SMALLINT \n CHECK(VALUE BETWEEN 1 AND 15); \n CREATE DOMAIN PRent AS DECIMAL(6, 2) \n CHECK(VALUE BETWEEN 0 AND 9999.99); \n``` \n \n </span>",    

        cardcont_ch03_sqlddl21:
		"## 创建表 \n 举例 \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE TABLE PropertyForRent ( \n  propertyNo PNumber NOT NULL, \n  rooms PRooms NOT NULL DEFAULT 4, \n  rent PRent NOT NULL DEFAULT 600, \n  ownerNo OwnerNumber	NOT NULL, \n  staffNo StaffNumber NOT NULL, \n  branchNo BranchNumber NOT NULL, \n  PRIMARY KEY (propertyNo), \n  FOREIGN KEY (staffNo) REFERENCES Staff \n   ON DELETE SET NULL \n   ON UPDATE CASCADE \n ); \n``` \n \n </span>",  
 
        cardcont_ch03_sqlddl21_01:
		"## 创建表 \n 参照完整性语法 \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE TABLE tableName ( \n  ... \n  {[FOREIGN KEY (listOfFKColumns) \n    REFERENCES parentTableName [(listOfCKColumns)] \n     [ON UPDATE CASCADE|SET DEFAULT|SET NULL|NO ACTION] \n     [ON DELETE CASCADE|SET DEFAULT|SET NULL|NO ACTION]] \n   [, ...]} \n  ...  \n ); \n``` \n \n </span>",   
 
        cardcont_ch03_sqlddl21_02:
		"## 创建表 \n 参照完整性语法 \n \n <span style='font-size: 85%;'> \n \n - 在子表(参照表)中`INSERT`或`UPDATE`与父表(被参照表)中键值不匹配的外键值时 \n     - 拒绝对子表进行的操作 \n - 在父表中`DELETE`或`UPDATE`与子表有匹配行的键值时 \n      - `CASCADE`: 删除父表中的行, 且删除子表中匹配的行 \n      - `SET DEFAULT`: 删除父表中的行, 且自动设置子表中的外键值为缺省值, 前提是在创建子表时对外键属性指定了`DEFAULT`值 \n      - `SET NULL`: 删除父表中的行, 且自动设置子表中的外键值为`NULL` \n      - `NO ACTION`: 拒绝对父表进行的操作, 默认动作 \n \n </span>",
 
        cardcont_ch03_sqlddl21_03:
		"## 创建表 \n 举例 \n \n <span style='font-size: 100%;'> \n \n ```\n CREATE TABLE employees ( \n  employee_id INT PRIMARY KEY, \n  employee_number INT NOT NULL, \n  last_name VARCHAR(50) NOT NULL, \n  first_name VARCHAR(50), \n  salary MONEY, \n  CONSTRAINT employees_unique UNIQUE (last_name, first_name) \n ); \n``` \n ```\n CREATE TABLE Persons ( \n  ID int NOT NULL, \n  LastName varchar(255) NOT NULL, \n  FirstName varchar(255), \n  Age int, \n  City varchar(255), \n  CONSTRAINT CHK_Person CHECK (Age>=18 AND City='Sandnes') \n ); \n``` \n \n </span>",    

        cardcont_ch03_sqlddl22:
		"## 创建表 \n 举例 创建学生表S \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE TABLE S ( \n  S# CHAR(8) NOT NULL UNIQUE, \n  SN CHAR(8) UNIQUE, \n  GE CHAR(1), \n  SA SMALLINT, \n  SD CHAR(4), \n  PRIMARY KEY (S#) \n ); \n``` \n \n </span>",   

        cardcont_ch03_sqlddl22_01:
		"## 创建表 \n 举例 创建课程表C \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE TABLE C ( \n  C# CHAR (8) NOT NULL, \n  CN VARCHAR(256), \n  CP# CHAR (8), \n  CC SMALLINT, \n  PRIMARY KEY (C#), \n  FOREIGN KEY CP# REFERENCES C (C#) \n );  \n``` \n \n </span>",    
 
        cardcont_ch03_sqlddl23:
		"## 创建表 \n 举例 创建选课表SC \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE TABLE SC ( \n  S# CHAR (8) NOT NULL, \n  C# CHAR (8) NOT NULL, \n  G SMALLINT, \n  PRIMARY KEY (S#, C#), \n  FOREIGN KEY S# REFERENCES S, \n  FOREIGN KEY C# REFERENCES C \n );  \n``` \n \n </span>",    
        cardcont_ch03_sqlddl24:
		"## 删除表 \n \n 语法 \n \n <span style='font-size: 140%;'> \n \n ```\n DROP TABLE tableName [RESTRICT | CASCADE]; \n``` \n \n </span> \n \n &ensp; &nbsp; 既删除表的结构定义, 也删除表中的数据 \n - `RESTRICT` (缺省), 若有其它对象依赖于该表, 则删除失败 \n - `CASCADE`, 级联删除表及所有依赖于该表的对象 \n \n 举例 \n \n <span style='font-size: 140%;'> \n \n ```\n DROP TABLE PropertyForRent; \n``` \n \n </span>",    

        cardcont_ch03_sqlddl25:
		"## 修改表 \n \n 语法 \n \n <span style='font-size: 140%;'> \n \n ```\n ALTER TABLE tableName \n  [ADD newColumnName dataType] \n  [ADD constraint] \n  [DROP COLUMN columnName] \n  [DROP constraint] \n  [MODIFY columnName dataType]; \n``` \n \n </span> \n \n - 新增加的列为空值 \n - 修改列定义可能破坏已有数据",   

        cardcont_ch03_sqlddl26:
		"## 修改表 举例 \n \n <span style='font-size: 120%;'> \n \n ```\n ALTER TABLE Customers \n ADD Email varchar(255); \n``` \n ```\n ALTER TABLE Persons \n ADD PRIMARY KEY (ID); \n``` \n ```\n ALTER TABLE Persons \n ADD UNIQUE (ID); \n``` \n ```\n ALTER TABLE Orders \n ADD FOREIGN KEY (PersonID) \n  REFERENCES Persons(PersonID); \n``` \n ```\n ALTER TABLE Persons \n ADD CHECK (Age>=18); \n``` \n \n </span>",   
 
        cardcont_ch03_sqlddl27:
		"## 修改表 举例 \n \n <span style='font-size: 120%;'> \n \n ```\n ALTER TABLE Persons \n ADD CONSTRAINT PK_Person \n  PRIMARY KEY (ID,LastName);\n``` \n ```\n ALTER TABLE Persons \n ADD CONSTRAINT CHK_PersonAge \n  CHECK (Age>=18 AND City='Sandnes'); \n``` \n \n </span>",  
 
        cardcont_ch03_sqlddl28:
		"## 修改表 举例 \n \n <span style='font-size: 120%;'> \n \n ```\n ALTER TABLE Customers \n DROP COLUMN ContactName; \n``` \n ```\n ALTER TABLE Persons \n DROP PRIMARY KEY; \n``` \n ```\n ALTER TABLE Persons \n DROP CHECK CHK_PersonAge; \n``` \n ```\n ALTER TABLE Persons \n DROP CONSTRAINT PK_Person;\n``` \n \n </span>",   

        cardcont_ch03_sqlddl29:
		"## 创建索引 \n \n 语法 \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE [UNIQUE] [CLUSTER] INDEX indexName \n ON tabName(colName [ASC|DESC][, colName[ASC|DESC]] ...); \n``` \n \n </span> \n \n - 一条语句建立一个索引 \n - 排列次序缺省为`ASC` \n - `UNIQUE`, 每个索引值对应唯一一条数据记录 \n - `CLUSTER`, 聚簇索引, 即索引项的顺序与表中记录的物理顺序一致 \n - 索引有维护代价",

        cardcont_ch03_sqlddl30:
		"## 创建索引 \n \n 举例 \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE UNIQUE INDEX indS_S# ON S(S#); \n``` \n ```\n CREATE UNIQUE INDEX indSC_S#C# ON SC(S# ASC, C# DESC); \n``` \n \n </span>",

        cardcont_ch03_sqlddl31:
		"## 删除索引 \n \n 语法 \n \n <span style='font-size: 140%;'> \n \n ```\n DROP INDEX indexName; \n``` \n \n </span> \n \n 举例 \n \n <span style='font-size: 140%;'> \n \n ```\n DROP INDEX indS_S#; \n``` \n \n </span>",

        cardcont_ch03_sqlddl32:
		"## 视图 \n - 视图是虚关系：无需另外存在于数据库中, 根据某个特定需求而生成的虚关系 \n - 视图的内容基于一个或多个基本关系的查询 \n - 视图是动态结果：对一个或多个基本关系进行关系操作得到的动态结果",

        cardcont_ch03_sqlddl33:
		"## 创建视图 \n \n 视图可以从一张表、几张表或其他视图中创建 \n \n 语法 \n \n <span style='font-size: 120%;'> \n \n ```\n CREATE VIEW viewName \n [(columnName1 [, columnName2] ...)] \n AS SELECT sentence \n [WITH CHECK OPTION]; \n``` \n \n </span> \n \n - 若视图名后的列名表与`SELECT`语句里的列名表相同，则视图名后的列名表可以省略 \n - 若使用`WITH CHECK OPTION`，则对视图进行`INSERT`和`UPDATE`操作时，保证行满足视图定义中的`WHERE`子句指定的条件",
        cardcont_ch03_sqlddl34:
		"## 视图分类 \n - 水平视图 \ \n 从单个基本表导出，去掉了基本表的某些行 \n - 垂直视图 \ \n 从单个基本表导出，去掉了基本表的某些列 \n - 分组视图 \ \n 用`GROUP BY`子句定义的视图 \n - 连接视图 \ \n 用连接运算得到的视图",

        cardcont_ch03_sqlddl35:
		"## 创建视图 \n \n 举例: 创建一个水平视图，让分支机构B003的经理只看到他所在分支机构的职员的信息 \n \n <span style='font-size: 120%;'> \n \n ```\n CREATE VIEW Manager3Staff \n AS SELECT * \n    FROM Staff \n    WHERE branchNo = 'B003'; \n``` \n ```\n Staff (staffNo, fName, lName, position, \n        gender, DOB, salary, branchNo) \n``` \n \n </span> \n", 
        cardcont_ch03_imgsqlddl35: require('../assets/db/ch03/manager3_staff.svg'),

        cardcont_ch03_sqlddl36:
		"## 创建视图 \n \n 举例: 创建一个垂直视图, 包含分支机构B003职员信息但不包括工资信息 \n \n <span style='font-size: 120%;'> \n \n ```\n CREATE VIEW Manager3Staff \n AS SELECT staffNo, fName, lName, position, gender \n    FROM Staff \n    WHERE branchNo = 'B003'; \n``` \n \n </span> \n", 
        cardcont_ch03_imgsqlddl36: require('../assets/db/ch03/manager3_staff_nosalary.svg'),

        cardcont_ch03_sqlddl37:
		"## 创建视图 \n \n 举例: 创建分组、连接视图, 包含职员所在分支机构的编号、职员编号和他们管理的房产的数量 \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE VIEW StaffPropCnt (branchNo, staffNo, cnt) \n AS SELECT s.branchNo, s.staffNo, COUNT(*) \n    FROM Staff s, PropertyForRent p \n    WHERE s.staffNo = p.staffNo \n    GROUP BY s.branchNo, s.staffNo; \n``` \n ```\n PropertyForRent (propertyNo, street, city, postcode, \n    type, rooms, rent, ownerNo, staffNo, branchNo) \n``` \n \n </span> \n", 
        cardcont_ch03_imgsqlddl37: require('../assets/db/ch03/staff_prop_cnt.svg'),

        cardcont_ch03_sqlddl38:
		"## 查询视图 \n - 创建视图后，用户可以象对基本表一样对视图进行查询 \n - 视图消解(View Resolution), 执行对视图的查询时, 从数据字典中取出视图的定义, 将定义中的子查询和用户的查询结合起来, 转换成等价的对基本表的查询 \n - 不同关系数据库系统对视图消解的支持有差异",
 
        cardcont_ch03_sqlddl39:
		"## 查询视图 \n ```\n SELECT staffNo, cnt \n FROM StaffPropCnt \n WHERE branchNo = 'B003' \n ORDER BY staffNo; \n``` \n ```\n CREATE VIEW StaffPropCnt (branchNo, staffNo, cnt) \n AS SELECT s.branchNo, s.staffNo, COUNT(*) \n    FROM Staff s, PropertyForRent p \n    WHERE s.staffNo = p.staffNo \n    GROUP BY s.branchNo, s.staffNo; \n``` \n ```\n SELECT s.staffNo AS staffNo, COUNT(*) AS cnt \n FROM Staff s, PropertyForRent p \n WHERE s.staffNo = p.staffNo AND branchNo = 'B003' \n GROUP BY s.branchNo, s.staffNo \n ORDER BY s.staffNo; \n``` ",
 
        cardcont_ch03_sqlddl40:
		"## 查询视图 \n \n 有些情况下，视图消解里的查询转换不能直接进行 \ \n 举例 创建视图S_G \n \n <span style='font-size: 120%;'> \n \n ```\n CREATE VIEW S_G (S#, Gavg) \n AS SELECT S#, AVG(G) \n    FROM SC \n    GROUP BY S#; \n``` \n \n </span> \n \n 在S_G视图中查询平均成绩在90分以上的学生学号和平均成绩 \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT * \n FROM S_G \n WHERE Gavg >= 90; \n``` \n \n </span>", 

        cardcont_ch03_sqlddl41:
		"## 查询视图 \n \n 直接转换 \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT S#, AVG(G) \n FROM SC \n WHERE AVG(G) >= 90 \n GROUP BY S#; \n``` \n \n </span> \n \n 正确转换 \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT S#, AVG(G) \n FROM SC \n GROUP BY S# \n HAVING AVG(G) >= 90; \n``` \n \n </span>", 

        cardcont_ch03_sqlddl41_01:
		"## 查询视图 \n \n 下列SQL语句的执行结果是什么？\n \n <span style='font-size: 150%;'> \n \n ```\n SELECT COUNT(*) \n FROM Staff; \n``` \n \n </span> \n", 
        cardcont_ch03_imgsqlddl41_01: require('../assets/db/ch03/staff_tab_data.svg'),

        cardcont_ch03_sqlddl41_02:
		"## 查询视图 \n \n 下列SQL语句的执行结果是什么？\n \n <span style='font-size: 150%;'> \n \n ```\n SELECT COUNT(*) \n FROM Manager3Staff; \n``` \n \n </span> \n", 
        cardcont_ch03_imgsqlddl41_02: require('../assets/db/ch03/manager3staff_view_data.svg'),

        cardcont_ch03_sqlddl42:
		 "## 查询视图 \n \n ISO标准对创建和查询视图施加了一些重要约束 \n - 如果视图中某列是基于集合函数的, 那么, 该列只能出现在访问视图的`SELECT`和`ORDER BY`子句中, 但不能作为集合函数的参数, 该列不能出现在`WHERE`子句中 \n - 分组视图不能与基本表或视图进行连接操作",

        cardcont_ch03_sqlddl43:
		 "## 查询视图 \n \n 约束举例 \n \n <span style='font-size: 150%;'> \n \n ```\n SELECT COUNT(cnt) \n FROM StaffPropCnt; \n``` \n ```\n SELECT * \n FROM StaffPropCnt \n WHERE cnt > 2; \n``` \n \n </span>",

        cardcont_ch03_sqlddl44:
		 "## 更新视图 \n - 更新视图的语法与更新基本表一样 \n - 对基本表的所有更新应该立即反映到涉及该表的所有视图中 \n - 如果一个视图被更新, 该视图涉及到的基本表也应该能反映这种变化 \n - 视图都可以更新吗？",

        cardcont_ch03_sqlddl45:
		 "## 更新视图 \n \n <span style='font-size: 150%;'> \n \n ```\n CREATE VIEW Manager3Staff \n AS SELECT * \n    FROM Staff \n    WHERE branchNo = 'B003' \n WITH CHECK OPTION; \n``` \n \n </span> \n \n 下列SQL语句的执行结果是什么？\n \n <span style='font-size: 130%;'> \n \n ```\n INSERT INTO Manager3Staff(staffNo, branchNo) \n VALUE ('SG50', 'B002'); \n``` \n ```\n UPDATE Manager3Staff \n SET branchNo = 'B007' \n WHERE staffNo = 'SG37'; \n``` \n \n </span>",

        cardcont_ch03_sqlddl46:
		 "## 更新视图 \n \n 举例: 将分支机构B003的职员SG5管理两处房产的记录插入视图StaffPropCnt \n \n <span style='font-size: 150%;'> \n \n ```\n INSERT INTO StaffPropCnt \n VALUES ('B003', 'SG5', 2); \n``` \n \n </span> \n",

        cardcont_ch03_sqlddl47:
		 "## 更新视图 \n \n 举例 \n",
        cardcont_ch03_imgsqlddl47: require('../assets/db/ch03/propertyforrent_tab_data.svg'),

        cardcont_ch03_sqlddl48:
		 "## 更新视图 \n \n 举例 \n \n <span style='font-size: 105%;'> \n \n ```\n CREATE TABLE PropertyForRent ( \n  propertyNo PNumber NOT NULL, \n  rooms PRooms NOT NULL DEFAULT 4, \n  rent PRent NOT NULL DEFAULT 600, \n  ownerNo OwnerNumber  NOT NULL, \n  staffNo StaffNumber NOT NULL, \n  branchNo BranchNumber NOT NULL, \n  PRIMARY KEY (propertyNo), \n  FOREIGN KEY (staffNo) REFERENCES Staff \n   ON DELETE SET NULL \n   ON UPDATE CASCADE \n ); \n``` \n ```\n CREATE VIEW StaffPropList (branchNo, staffNo, propertyNo) \n AS SELECT  branchNo, staffNo, propertyNo \n    FROM PropertyForRent; \n``` \n \n </span>",

        cardcont_ch03_sqlddl49:
		 "## 更新视图 \n \n 举例 \n \n <span style='font-size: 105%;'> \n \n ```\n INSERT INTO StaffPropList \n VALUES ('B003', 'SG5', 'PG19'); \n``` \n \n </span> \n",
        cardcont_ch03_imgsqlddl49: require('../assets/db/ch03/staffproplist_view_data.svg'),

        cardcont_ch03_sqlddl50:
		 "## 更新视图 \n \n 举例: 将信息系学生视图IS_S中学号为'95002'的学生姓名改为'刘辰' \n \n <span style='font-size: 130%;'> \n \n ```\n UPDATE IS_S \n SET SN = '刘辰' \n WHERE S# = '95002'; \n``` \n \n </span> \n \n 转换后的更新语句 \n \n <span style='font-size: 130%;'> \n \n ```\n UPDATE S \n SET SN = '刘辰' \n WHERE S# = '95002' AND SD = 'IS'; \n``` \n \n </span>",

        cardcont_ch03_sqlddl51:
		 "## 更新视图 \n \n 有些视图更新不能有意义地转换成对基本表的更新 \n \n <span style='font-size: 130%;'> \n \n ```\n CREATE VIEW S_G (S#, Gavg) \n AS SELECT S#, AVG(G) \n    FROM SC \n    GROUP BY S#; \n``` \n \n </span> \n \n 将视图S_G中学号'95001'的学生的平均成绩改为90分 \n \n <span style='font-size: 130%;'> \n \n ```\n UPDATE S_G \n SET Gavg = 90 \n WHERE S# = '95001'; \n``` \n \n </span>",

        cardcont_ch03_sqlddl52:
		 "## 更新视图 \n \n ISO标准给出的视图可更新的条件 \n \n <span class=ddl52> \n \n 1. 创建视图`SELECT`没有指定`DISTINCT`, 即重复元组未从查询结果中消除 \n 2. 创建视图`SELECT`列表中的每个元素均为列名, 而不是常量、表达式或集合函数, 且列名不能出现多于一次 \n 3. 创建视图`SELECT` `FROM`子句只能指定一个表，且用户有请求该表的权限。如果源表本身就是一个视图，那么视图须排除了连接、并、交或差等操作 \n \n </span>",

        cardcont_ch03_sqlddl53:
		 "## 更新视图 \n \n ISO标准给出的视图可更新的条件 \n \n <span class=ddl53> \n \n 4. 创建视图`SELECT` `WHERE子`句不能包括任何引用了`FROM`子句中的表的嵌套`SELECT`操作 \n 5. 创建视图`SELECT`不能有`GROUP BY`或`HAVING`子句 \n \n </span> \n \n另外, 添加到视图中的每一行不能违反基本表的完整性约束 ",

        cardcont_ch03_sqlddl54:
		"## 视图的优缺点 \n \n 优点 \n - 数据独立性 \n - 提高了安全性 \n \n 缺点 \n - 更新的局限性 \n - 性能 \n \n      - 视图物化(View Materialization): 把第一次访问视图的结果存储为临时表, 比每次重新计算要快", 

        cardcont_ch03_sqlint01:
		"## SQL定义完整性约束 \n - 非过程性完整性约束 \n     - 值约束 \ \n `CREATE DOMAIN DEFAULT, CHECK` \ \n `CREATE TABLE&ensp; DEFAULT, CHECK, \ \n &ensp; &ensp; NOT NULL, UNIQUE`  \n      - 实体完整性约束 \ \n `CREATE TABLE&ensp; PRIMARY KEY` \n      - 参照完整性约束 \ \n `CREATE TABLE&ensp; FOREIGN KEY`",
 
        cardcont_ch03_sqlint02:
		"## SQL定义完整性约束 \n - 非过程性完整性约束 \n     - 一般约束 断言 \ \n `CREATE ASSERTION` \n - 过程性完整性约束 触发器 \ \n `CREATE TRIGGER`", 

        cardcont_ch03_sqlint03:
		"## 参照完整性约束 \n 影响参照完整性操作举例", 
        cardcont_ch03_imgsqlint03: require('../assets/db/ch03/S_C_SC.svg'),

        cardcont_ch03_sqlint04:
		"## 参照完整性约束 \n 影响参照完整性操作举例 \n \n 删除学号为'95002'的学生的信息 \n \n <span style='font-size: 150%;'> \n \n ```\n DELETE FROM S \n WHERE S# = '95002'; \n``` \n ```\n DELETE FROM SC \n WHERE S# = '95002'; \n``` \n \n </span> \n \n &ensp; &ensp;SQL删除命令顺序不合适会破坏参照完整性",
 
        cardcont_ch03_sqlint05:
		"## 参照完整性约束 \n 影响参照完整性操作举例 \n \n 删除学号为'95002'的学生的信息 \n \n <span style='font-size: 150%;'> \n \n ```\n DELETE FROM SC \n WHERE S# = '95002'; \n``` \n ```\n DELETE FROM S \n WHERE S# = '95002'; \n``` \n \n </span> \n \n &ensp; &ensp;正确的SQL删除命令顺序", 

        cardcont_ch03_sqlint06:
		"## 参照完整性约束 \n 影响参照完整性操作举例 \n \n 插入选课信息('95005', 'C8', 85) \n \n <span style='font-size: 150%;'> \n \n ```\n INSERT INTO S \n VALUES ('95005', NULL, NULL, NULL, NULL); \n``` \n ```\n INSERT INTO C \n VALUES ('C8', NULL, NULL); \n``` \n ```\n INSERT INTO SC \n VALUES ('95005', 'C8', 85); \n``` \n \n </span> \n \n &ensp; &ensp;SQL插入命令顺序不合适会破坏参照完整性", 

        cardcont_ch03_sqlint07:
		"## 参照完整性约束 \n 影响参照完整性操作举例 \n \n 修改学号'95001'的学生的学号为'95008' \n \n <span style='font-size: 150%;'> \n \n ```\n UPDATE S \n SET S# = '95008' \n WHERE S# = '95001'; \n``` \n ```\n UPDATE SC \n SET S# = '95008' \n WHERE S# = '95001'; \n``` \n \n </span> \n \n &ensp; &ensp;会破坏参照完整性", 

        cardcont_ch03_sqlint08:
		"## 参照完整性约束 \n 影响参照完整性操作举例 \n \n 修改学号'95001'的学生的学号为'95008' \n \n <span style='font-size: 150%;'> \n \n ```\n UPDATE SC \n SET S# = '95008' \n WHERE S# = '95001'; \n``` \n ```\n UPDATE S \n SET S# = '95008' \n WHERE S# = '95001'; \n``` \n \n </span> \n \n &ensp; &ensp;会破坏参照完整性", 

        cardcont_ch03_sqlint09:
		"## 一般约束 断言 \n 断言约束可以涉及多个表 \n \n 创建断言 语法 \n \n <span style='font-size: 150%;'> \n \n ```\n CREATE ASSERTION assertionName \n CHECK (searchCondition); \n``` \n \n </span>",

        cardcont_ch03_sqlint10:
		"## 一般约束 断言 \n 创建断言 举例 \n \n <span style='font-size: 130%;'> \n \n ```\n CREATE ASSERTION StaffNotHandlingTooMuch \n CHECK (\n  NOT EXISTS ( \n   SELECT * \n   FROM PropertyForRent \n   GROUP BY staffNo \n   HAVING COUNT(*) > 100 \n  ) \n ); \n``` \n \n </span>",

        cardcont_ch03_sqlint11:
		"## 一般约束 断言 \n 创建断言 举例 \ \n 每门课程最多只允许100个学生选修 \n \n <span style='font-size: 130%;'> \n \n ```\n CREATE ASSERTION spercEl100 \n CHECK (\n  ALL ( \n   SELECT COUNT(SN) \n   FROM SC \n   GROUP BY CN \n  ) <= 100 \n ); \n``` \n \n </span>",

        cardcont_ch03_sqlint12:
		"## 一般约束 断言 \n 创建断言 举例 \ \n 不允许信息学院的学生选修019号课程 \n \n <span style='font-size: 130%;'> \n \n ```\n CREATE ASSERTION noIsStuSel019 \n CHECK (\n  NOT EXISTS ( \n   SELECT * \n   FROM S, SC \n   WHERE S.SN = SC.SN \n    AND S.SD = 'IS' \n    AND SC.CN = '019' \n  ) \n ); \n``` \n \n </span>",

        cardcont_ch03_sqlint13:
		"## 一般约束 断言 \n 删除断言 语法 \n \n <span style='font-size: 150%;'> \n \n ```\n DROP ASSERTION assertionName; \n``` \n \n </span>",

        cardcont_ch03_sqlint14:
		"## 约束检测时机 \n 约束监测时机可以是事务结束时或者每一条SQL语句执行完成时 \n \n 指定约束检测时机 语法 \n \n <span style='font-size: 150%;'> \n \n ```\n SET CONSTRAINTS \n {ALL|constraintName[, ...]} \n {DEFERRED|IMMEDIATE}; \n``` \n \n </span> \n \n - `DEFERRED` \n  事物结束时检查 \n - `IMMEDIATE` \ \n 缺省值, 每一条SQL语句执行完成即检查",

        cardcont_ch03_sqlint15:
		"## 约束检测时机 \n 指定约束检测时机 举例 \n \n <span style='font-size: 130%;'> \n \n ```\n CREATE TABLE dept ( \n  deptNo CHAR(5), \n  deptName CHAR(20), \n  payroll DECIMAL(15,2), \n  CONSTRAINT payEqSumsal CHECK ( \n   payroll = \n   SELECT SUM(Salary) \n   FROM EMPLOYEE e \n   WHERE e.deptNo = dept.deptNo \n  ) \n ); \n``` \n \n </span>",

        cardcont_ch03_sqlint16:
		"## 约束检测时机 \n 指定约束检测时机 举例 \n \n <span style='font-size: 130%;'> \n \n ```\n SET CONSTRAINTS payEqSumsal DEFERRED; \n``` \n ```\n UPDATE employee \n SET salary = salary + 100 \n WHERE empNo = '123'; \n \n UPDATE dept d \n SET payroll = payroll + 100 \n WHERE d.deptNo = ( \n   SELECT e.DeptNo \n   FROM employee e \n   WHERE e.empNo = '123' \n  ); \n``` \n \n </span>",

        cardcont_ch03_sqlint17:
		"## 触发器 \n 触发器Trigger是一类靠事件驱动的特殊过程, 一旦由用户创建, 任何触发该触发器的事件发生且满足条件时, 系统自动激活相应的触发器, 执行相应动作 \n \n 触发器定义 \n - 触发事件 \n - 触发时机 \n - 触发条件 \n - 触发动作", 

        cardcont_ch03_sqlint18:
		"## 触发器 \n 创建触发器 语法 \n \n <span style='font-size: 120%;'> \n \n ```\n CREATE TRIGGER trigger_name \n {BEFORE|AFTER} \n {INSERT|DELETE|UPDATE [OF colname[, colname ...]]} \n ON tabname \n [REFERENCING corr_name_def[, corr_name_def ...]] \n [FOR EACH ROW|FOR EACH STATEMENT] \n  [WHEN (search_condition)] \n   {statement \n   |BEGIN ATOMIC \n     statement; [statement; ...] \n    END}; \n``` \n \n </span>", 

        cardcont_ch03_sqlint19:
		"## 触发器 \n 创建触发器 语法 \n \n `corr_name_def`定义 \n \n <span style='font-size: 120%;'> \n \n ```\n {OLD [ROW] [AS] old_row_corr_name \n |NEW [ROW] [AS] new_row_corr_name \n |OLD TABLE [AS] old_table_corr_name \n |NEW TABLE [AS] new_table_corr_name} \n``` \n \n </span>", 

        cardcont_ch03_sqlint20:
		"## 触发器 \n 非过程性约束 \n - 直接为系统所知 \n - 难以给出约束不满足时的相应动作 \n \n 触发器实现过程性约束 \n - 给出约束不满足时的相应动作 \n - 可以使另一些操作在一个执行之后自动发生, 保证一致性", 

        cardcont_ch03_sqlint21:
		"## 触发器 \n 定义触发器动作, 各DBMS有自己特定的过程性语言 \n \n 大部分DBMS都提供过程性语言扩展 \n - 常驻内存变量 \n - if-then-else逻辑 \n - 循环控制 ", 

        cardcont_ch03_sqlint22:
		"## 触发器 \n 创建触发器 举例 \ \n 在更新表selectCourse中的成绩grade后, 确保修改后成绩不能低于修改前成绩 \n \n <span style='font-size: 120%;'> \n \n ```\n CREATE TRIGGER triggerGrade \n AFTER UPDATE OF grade ON seclectCourse \n REFERENCING OLD AS oldRow, NEW as newRow \n FOR EACH ROW \n  WHEN (oldRow.grade > newRow.grade) \n   UPDATE seclectCourse \n   SET grade = oldRow.grade \n   WHERE sno = newRow.sno; \n``` \n \n </span>", 

        cardcont_ch03_sqlint23:
		"## 触发器 \n 创建触发器 举例 \ \n 当帐户透支时, 将帐户余额设为0, 并建一笔贷款, 其金额为透支额 \n \n <span style='font-size: 95%;'> \n \n ```\n CREATE TRIGGER triggerOverdraft \n AFTER UPDATE ON account \n REFERENCING NEW ROW AS newRow \n FOR EACH ROW \n  WHEN (newRow.balance < 0) \n   BEGIN ATOMIC \n    INSERT INTO borrower VALUES ( \n     SELECT customerName, accountNo \n     FROM depositor \n     WHERE newRow.accountNo = depositor.accountNo); \n    INSERT INTO loan VALUES ( \n     newRrw.accountNo, newRow.branchName, – newRow.balance); \n    UPDATE account SET balance = 0 \n    WHERE account.accountNo = newRow.accountNo; \n   END; \n``` \n \n </span>", 

        cardcont_ch03_mysqlcreateuser:
			"## MySQL Create User \n \n <span style='font-size: 120%;'> \n \n ```\n mysql -u root -p \n``` \n ```\n CREATE USER 'u1'@'172.16.11.99' IDENTIFIED BY '123'; \n CREATE USER 'u1'@'172.16.12.24' IDENTIFIED BY '123'; \n CREATE USER 'u2'@'%' IDENTIFIED BY '123'; \n``` \n \n </span>", 		
        cardcont_ch03_mysqlusertab:
			"## MySQL User Table \n \n <span style='font-size: 140%;'> \n \n ```\n SELECT * FROM mysql.user; \n``` \n \n </span> \n", 	
        cardcont_ch03_imgmysqlusertab: require('../assets/db/ch03/mysqlusertab.svg'),

        cardcont_ch03_mysqldeluser:
			"## MySQL Delete User \n \n <span style='font-size: 130%;'> \n \n ```\n USE mysql; \n DELETE FROM user \n WHERE User='u1' AND Host='172.16.11.99'; \n FLUSH PRIVILEGES; \n``` \n \n </span> \n", 
	
        cardcont_ch03_mysqlrnuser:
			"## MySQL Rename User \n 语法 \n \n <span style='font-size: 130%;'> \n \n ```\n RENAME USER old_user TO new_user \n  [, old_user TO new_user] ...; \n``` \n \n </span> \n \n 举例 \n \n <span style='font-size: 130%;'> \n \n ```\n RENAME USER 'u1'@'172.16.12.24' TO \n  'win.user'@'172.16.12.24';\n RENAME USER 'u2'@'%' TO 'back'@'127.0.0.1'; \n``` \n \n </span>",

        cardcont_ch03_mysqlchuserpwd:
			"## MySQL Change User Password \n \n <span style='font-size: 130%;'> \n \n ```\n ALTER USER 'userName'@'host' \n IDENTIFIED BY 'auth_string'; \n``` \n ```\n SET PASSWORD [FOR user] auth_option \n  [REPLACE 'current_auth_string'] \n  [RETAIN CURRENT PASSWORD]; \n auth_option: { \n  = 'auth_string' \n  | TO RANDOM \n } \n``` \n \n </span> \n \n - 默认为当前用户设定口令",
 
        cardcont_ch03_mysqlforgetuserpwd:
		"## Forget MySQL Password \n \n <span class=ddl52 style = 'font-size: 90%'> \n \n 1. 先关闭`mysqld` \n 2. 修改`/etc/my.cnf`文件，注释掉口令策略参数 \n 3. 安全启动`mysqld` \ \n `mysqld_safe --skip-grant-tables &` \n 4. 无口令登录 \ \n `mysql -u root` \n 5. `FLUSH PRIVILEGES` \n 6. 修改口令，重启数据库 \n \n </span>",

        cardcont_ch03_mysqlrole:
		"## MySQL Role \n \n <span style='font-size: 110%;'> \n \n ```\n CREATE ROLE [IF NOT EXISTS] role[, role] ... \n \n CREATE ROLE 'admin', 'developer'; \n CREATE ROLE 'webapp'@'localhost'; \n``` \n ```\n DROP ROLE [IF EXISTS] role[, role] ... \n \n DROP ROLE 'admin', 'developer'; \n DROP ROLE 'webapp'@'localhost'; \n``` \n \n </span>",

        cardcont_ch03_mysqlgrant02:
		"## MySQL授权 \n 语法 \n \n <span style='font-size: 110%;'> \n \n ```\n GRANT privType [(colList)][, privType [(colList)]] ... \n ON [objectType] privLevel \n TO user|role[, user|role] ... \n [WITH GRANT OPTION] \n [AS user [WITH ROLE DEFAULT|NONE|ALL \n     &ensp;     |ALL EXCEPT role[, role] ... \n     &ensp;     |role[, role] ...] \n ];  \n``` \n ```\n GRANT PROXY ON user|role \n TO user|role[, user|role] ... \n [WITH GRANT OPTION]; \n``` \n \n </span> \n \n <span style='font-size: 70%;'> \n \n - `WITH GRANT OPTION`, 允许授权转让 \n - 代理用户权限保存在mysql.proxies_priv表中 \n \n </span>",

        cardcont_ch03_mysqlgrant03:
		"## MySQL授权 \n 语法 \n \n <span style='font-size: 110%;'> \n \n ```\n GRANT role[, role] ... \n TO user|role[, user|role] ... \n [WITH ADMIN OPTION]; \n``` \n \n </span> \n \n <span style='font-size: 70%;'> \n \n &emsp; &nbsp; `WITH ADMIN OPTION` \ \n &emsp; &nbsp; is allowed to grant the role to other users or roles \n \n &ensp; &emsp; `privType`: \ \n &ensp; &emsp; \n <a href='https://dev.mysql.com/doc/refman/8.3/en/privileges-provided.html' target='_blank'>https://dev.mysql.com/doc/refman/8.3/en/privileges-provided.html</a> \n \n </span> \n \n <span style='font-size: 110%;'> \n \n ```\n objectType: {TABLE|FUNCTION|PROCEDURE} \n``` \n ```\n privLevel: {*|*.*|dbName.* \n         &ensp;    |dbName.tblName|tblName|dbName.routineName} \n``` \n \n </span>",

        cardname_ch03_mysqlaccobjs: 'MySQL Privilege Level',
        cardcont_ch03_mysqlaccobjs:
                [
			"*.*, 全局权限Global Privileges, 应用到所有数据库上, 保存在mysql.user表中",
			"dbName.*, 数据库权限Database Privileges, 应用到某个特定数据库的所有对象上, 保存在mysql.db表中",	
			"dbName.tblName, 表权限Table Privileges, 应用到某个特定表的所有列上, 保存在mysql.tables_priv表中",
                ],
        cardname_ch03_mysqlaccobjs01: 'MySQL Privilege Level (Continue)',
        cardcont_ch03_mysqlaccobjs01:
                [
			'在权限种类后面跟小括号，其中写上列名, 列权限Column Privileges, 应用到某个特定表的单个列上, 保存在mysql.columns_priv表中',
			'dbName.routineName, 存储例程权限Stored Routine Privileges, 应用到存储过程和函数上, 保存在mysql.procs_priv表中',
                ],

        cardcont_ch03_mysqlgrantexample:
		"## MySQL授权举例 \n \n <span style='font-size: 120%;'> \n \n ```\n GRANT SELECT ON TABLE *.* TO 'u1'@'172.16.12.24'; \n GRANT INSERT ON TABLE test.* TO 'u1'@'172.16.12.24'; \n GRANT ALL ON TABLE test.t1 TO 'u2'@'%'; \n GRANT SELECT (id) ON TABLE test.t1 TO 'u2'@'%'; \n``` \n ```\n CREATE VIEW viewABj AS \n  SELECT * FROM tableA WHERE city = 'Beijing'; \n GRANT SELECT ON viewABj to PUBLIC; \n``` \n \n </span>",

        cardcont_ch03_mysqlrevoke:
		"## MySQL Revoke \n 语法 \n \n <span style='font-size: 90%;'> \n \n ```\n REVOKE [IF EXISTS] privType [(colList)][, privType [(colList)]] ... \n ON [objectType] privLevel \n FROM user|role[, user|role] ... \n [IGNORE UNKNOWN USER]; \n``` \n ```\n REVOKE [IF EXISTS] ALL [PRIVILEGES], GRANT OPTION \n FROM user|role[, user|role] ... \n [IGNORE UNKNOWN USER]; \n``` \n ```\n REVOKE [IF EXISTS] PROXY ON user|role \n FROM user|role[, user|role] ... \n [IGNORE UNKNOWN USER]; \n``` \n ```\n REVOKE [IF EXISTS] role[, role ] ... \n FROM user|role[, user|role] ... \n [IGNORE UNKNOWN USER]; \n``` \n \n </span>",

        cardcont_ch03_mysqlrevokeexample:
		"## MySQL Revoke \n 举例 \n \n <span style='font-size: 120%;'> \n \n ```\n REVOKE INSERT ON *.* FROM 'jeffrey'@'localhost'; \n REVOKE SELECT ON world.* FROM 'role3'; \n REVOKE 'role1', 'role2' \n  FROM 'user1'@'localhost', 'user2'@'localhost'; \n``` \n \n </span>", 

        cardname_ch03_mysqlflushpriv: 'MySQL Flush Privileges',
        cardcont_ch03_mysqlflushpriv:
                [
			'使用DML操作权限表，会导致权限数据跟内存中的权限数据不一致',
			'使用FLUSH PRIVILEGES重建内存数据，达到权限一致状态', 
                ],

        cardcont_ch03_sqldml01:
		"## INSERT语句 \n 语法 \n \n <span style='font-size: 110%;'> \n \n ```\n INSERT INTO tblName [(colName1[, colName2] ...)] \n VALUES (value1[, value2] ...); \n``` \n ```\n INSERT INTO tbl1Name [(tbl1ColName1[, tbl1ColName2] ...)] \n  SELECT *|tbl2ColName1[, tbl2ColName2] ... \n  FROM tbl2Name \n  WHERE condition; \n``` \n \n </span>",
 
        cardcont_ch03_sqldml02:
		"## INSERT语句 \n 举例: 插入一条选课记录('95020', 'C1') \n \n <span style='font-size: 130%;'> \n \n ```\n INSERT INTO selectCourse (sNo, cNo) \n VALUES ('95020', ‘c1'); \n``` \n \n </span> \n \n <span style='font-size: 70%;'> \n \n - 属性grade为空值 \n \n </span> \n \n 举例: 插入一条选课记录('95020', 'c1', 80) \n \n <span style='font-size: 130%;'> \n \n ```\n INSERT INTO selectCourse \n VALUES ('95020', ‘c1', 80); \n``` \n \n </span> \n \n <span style='font-size: 70%;'> \n \n - INTO子句中没有指定列名 \n \n </span>", 

        cardcont_ch03_sqldml03:
		"## INSERT语句 \n 举例: \ \n 对每个系, 求学生的平均年龄, 并把结果存入数据库 \n \n <span style='font-size: 130%;'> \n \n ```\n CREATE TABLE deptAvgAge \n  (deptName CHAR(15), avgAge SMALLINT); \n \n INSERT INTO deptAvgAge (deptName, avgAge) \n  SELECT deptName, AVG(age) \n  FROM student \n  GROUP BY deptName; \n``` \n \n </span>", 

        cardcont_ch03_sqldml04:
		"## UPDATE语句 \n 一条UPDATE语句在某一时刻只能更新一张表, 但可以更新一张表中的多列, 也可以更新多行数据 \n \n 语法 \n \n <span style='font-size: 140%;'> \n \n ```\n UPDATE tableName \n SET column1 = value1[, column2 = value2] ... \n [WHERE condition]; \n``` \n \n </span> \n \n <span style='font-size: 80%;'> \n \n - WHERE子句决定需要更新的行 \n - 列名决定需要更新的列 \n \n </span>", 

        cardcont_ch03_sqldml05:
		"## UPDATE语句 \n 举例: 将学生95001的年龄改为22岁 \n \n <span style='font-size: 140%;'> \n \n ```\n UPDATE student \n SET age = 22 \n WHERE sNo = '95001'; \n``` \n \n </span>", 

        cardcont_ch03_sqldml06:
		"## UPDATE语句 \n 举例: 将所有学生的年龄增加1岁 \n \n <span style='font-size: 140%;'> \n \n ```\n UPDATE student \n SET age = age + 1; \n``` \n \n </span>", 

        cardcont_ch03_sqldml07:
		"## UPDATE语句 \n 举例: 将信息系全体学生的成绩置零 \n \n <span style='font-size: 140%;'> \n \n ```\n UPDATE selectCourse \n SET grade = 0 \n WHERE 'information' = ( \n  SELECT deptName \n  FROM student \n  WHERE student.sNo = selectCourse.sNo \n ); \n``` \n \n </span>", 

        cardcont_ch03_sqldml08:
		"## DELETE语句 \n 一条DELETE语句可以从表中删除一行或多行整行数据, 不能从特定的列中删除数据 \n \n 语法 \n \n <span style='font-size: 140%;'> \n \n ```\n DELETE FROM tableName \n [WHERE condition]; \n``` \n \n </span>", 

        cardcont_ch03_sqldml09:
		"## DELETE语句 \n 举例: 删除学号为95001的学生记录 \n \n <span style='font-size: 140%;'> \n \n ```\n DELETE FROM student \n WHERE sNo = '95001'; \n``` \n \n </span>", 

        cardcont_ch03_sqldml10:
		"## DELETE语句 \n 举例: 删除所有学生的选课记录 \n \n <span style='font-size: 140%;'> \n \n ```\n DELETE FROM selectCourse; \n``` \n \n </span>", 

        cardcont_ch03_sqldml11:
		"## DELETE语句 \n 举例: 删除信息系全体学生的选课记录 \n \n <span style='font-size: 140%;'> \n \n ```\n DELETE FROM selectCourse \n WHERE 'information' = ( \n  SELECT deptName \n  FROM student \n  WHERE student.sNo = selectCourse.sNo \n ); \n``` \n \n </span>", 

        cardcont_ch03_sqldql01:
		"## SELECT语句基本语法 \n \n <span style='font-size: 140%;'> \n \n ```\n SELECT [ALL|DISTINCT] \n  {*|[colExpr [AS newName]][, ...]} \n FROM tblName [alias][, ...] \n [WHERE condition] \n [GROUP BY colList [HAVING condition]] \n [ORDER BY colList [ASC|DESC]]; \n``` \n \n </span>", 

        cardcont_ch03_sqldql02:
		"## SELECT语句含义 \n \n <span style='font-size: 90%;'> \n \n 根据`WHERE`子句中的条件表达式，从`FROM`子句中的基本表或视图中找出满足条件的元组, 可完成关系代数中的选择、投影、连接等运算 \n - `SELECT`子句, 必须, 列出目标字段, 选出元组中的分量 \n - `FROM`子句, 必须, 指明所访问的表或视图 \n - `WHERE`子句, 可选, 查询条件, 可以有多个 \n - `GROUP BY`子句, 可选, 将结果按字段分组，每个组产生结果表中的一个元组 \n - `HAVING`子句, 可选, 每组应满足的条件 \n - `ORDER BY`子句, 可选, 按指定的字段的值, 以升序或降序排列查询结果 \n \n </span>",

        cardcont_ch03_dreamHome:
		"## DreamHome租赁数据库 \n 部分关系模式", 
        cardcont_ch03_dreamHomeBranch:
		"\n \n <span style='font-size: 70%;'> \n \n \$\\texttt{Branch}($<u>branchNo</u>, $\\textsf{street}, \\textsf{city}, \\mathsf{postcode})\$ \n \n </span> \n \n", 
        cardcont_ch03_dreamHomeStaff:
		"\n \n <span style='font-size: 70%;'> \n \n \$\\mathtt{Staff}$(<u>staffNo</u>, fName, lName, position, gender, birthday, salary, branchNo) \n \n </span> \n \n", 
        cardcont_ch03_dreamHomePropertyForRent:
		"\n \n <span style='font-size: 70%;'> \n \n \$\\mathtt{PropertyForRent}\$(<u>propertyNo</u>, street, city, postcode, type, rooms, rent, ownerNo, staffNo, branchNo) \n \n </span> \n \n", 
        cardcont_ch03_dreamHomeClient:
		"\n \n <span style='font-size: 70%;'> \n \n $\\texttt{Client}$(<u>clientNo</u>, fName, lName, telNo, prefType, maxRent) \n \n </span> \n \n", 
        cardcont_ch03_dreamHomePrivateOwner:
		"\n \n <span style='font-size: 70%;'> \n \n $\\texttt{PrivateOwner}$(<u>ownerNo</u>, fName, lName, address, telNo) \n \n </span> \n \n", 
        cardcont_ch03_dreamHomeViewing:
		"\n \n <span style='font-size: 70%;'> \n \n $\\texttt{Viewing}$(<u>clientNo</u>, <u>propertyNo</u>, viewDate, comment) \n \n </span> \n \n", 
        cardcont_ch03_dreamHomeRegistration:
		"\n \n <span style='font-size: 70%;'> \n \n $\\texttt{Registration}$(<u>clientNo</u>, <u>branchNo</u>, <u>staffNo</u>, dateJoined) \n \n </span> \n \n", 

        cardcont_ch03_studentCourse:
		"\n \n ## 学生-课程-选课数据库 \n \n", 
        cardcont_ch03_tabStudent: 
		"\n \n <span style = 'font-size: 60%;'> \n \n | sno | sname | gender | age | depart | \n | -------- | ------- | ------- | ------- | ------- | \n | 95001 | 李勇 | 男 |20 | computer | \n | 95002 | 刘晨 | 女 | 19 | information | \n | 95003 | 王敏 | 女 | 18 | philosophy | \n | 95004 | 张立 | 男 | 19 | information | \n | | | **Student** | | |\n \n </span> \n \n", 
        cardcont_ch03_tabCourse: 
		"\n \n <span style = 'font-size: 60%;'> \n \n | cno | cname | pcno | credit | \n | -------- | ------- | ------- | ------ | \n | C1 | 数据库 | C5 | 2.5 | \n | C2 | 数学 | &nbsp; | 3 | \n | C3 | 信息系统 | C1 | 3 | \n | C4 | 操作系统 | C6 | 3 | \n | C5 | 数据结构 | C7 | 3 | \n | C6 | 数据处理 |  | 2 | \n | C7 | 程序设计 | C6 | 3 | \n | | **Course** | | | \n \n </span> \n \n", 
        cardcont_ch03_tabCourse01: 
		"\n | cno | cname | pcno | credit | \n | -------- | ------- | ------- | ------ | \n | C1 | 数据库 | C5 | 2.5 | \n | C2 | 数学 | &nbsp; | 3 | \n | C3 | 信息系统 | C1 | 3 | \n | C4 | 操作系统 | C6 | 3 | \n | C5 | 数据结构 | C7 | 3 | \n | C6 | 数据处理 |  | 2 | \n | C7 | 程序设计 | C6 | 3 | \n | | **Course** | | | \n \n", 
        cardcont_ch03_tabSelCourse: 
		"\n \n <span style = 'font-size: 60%;'> \n \n | sno | cno | grade | \n | -------- | ------- | ------- | \n | 95001 | C1 | 92 | \n | 95001 | C2 | 85 | \n | 95001 | C3 | 88 | \n | 95002 | C2 | 90 | \n | 95002 | C3 | 80 | \n | | **SelCourse** | |\n \n </span> \n \n", 
 
        cardcont_ch03_sqldql03:
		"## 检索表中所有列和所有行 \n \n 例 列举所有职员的信息 \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT staffNo, fName, lName, address, position, \n        gender, birthday, salary, branchNo \n FROM Staff; \n \n SELECT * \n FROM Staff; \n``` \n \n </span> \n \n <span style='font-size: 80%;'> \n \n - 用星号`*`代替所有列 \n \n </span> \n", 
        cardcont_ch03_imgdql03: require('../assets/db/ch03/select_staff_01.svg'),

        cardcont_ch03_sqldql04:
		"## 检索表所有行中指定列 \n \n 例 列举所有职员的工资信息, 只包括职员编号、姓名及工资 \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT staffNo, fName, lName, salary\n FROM Staff; \n``` \n \n </span> \n ", 
        cardcont_ch03_imgdql04: require('../assets/db/ch03/select_staff_02.svg'),

        cardcont_ch03_sqldql05:
		"## 使用`ALL|DISTINCT` \n \n <span style='font-size: 70%;'> \n \n `ALL`, 缺省值  \n \n `DISTINCT`, 消除结果中的重复行 \n - 使用导致系统性能下降 \n - 如果能确认结果行中没有重复行，就避免使用`DISTINCT` \n \n 例 列出被查看过的所有房产的编号 \n \n </span> \n \n <span style='font-size: 100%;'> \n \n ```\n SELECT ALL propertyNo \n FROM Viewing; \n \n SELECT DISTINCT propertyNo \n FROM Viewing; \n``` \n \n </span> \n ", 
        cardcont_ch03_imgdql05: require('../assets/db/ch03/select_viewing_01.svg'),

        cardcont_ch03_sqldql06:
		"## 计算列 \n \n <span style='font-size: 80%;'> \n \n 例 列出所有职员的月工资信息, 只包括职员编号、姓名及工资 \n \n </span> \n \n <span style='font-size: 110%;'> \n \n ```\n SELECT staffNo, fName, lName, salary/12 \n  FROM Staff; \n SELECT staffNo, fName, lName, salary/12 AS monthlySalary \n FROM Staff; \n``` \n \n </span> \n \n <span style='font-size: 80%;'> \n \n - `AS`, 为列重命名 \n \n </span> \n \n", 
        cardcont_ch03_imgdql06: require('../assets/db/ch03/select_staff_03.svg'),

        cardcont_ch03_sqldql07:
		"## 比较运算作为查找条件 \n \n <span style='font-size: 100%;'> \n \n 例 查询工资高于10,000英镑的所有职员 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT staffNo, fName, lName, position, salary \n FROM Staff \n WHERE salary > 10000; \n``` \n \n </span> \n ", 
        cardcont_ch03_imgdql07: require('../assets/db/ch03/select_staff_04.svg'),

        cardcont_ch03_sqldql08:
		"## 复合比较运算作为查找条件 \n \n <span style='font-size: 95%;'> \n \n 例 列出位于London或Glasgow的所有分支机构的地址 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT * \n FROM Branch \n WHERE city = 'London' OR city = 'Glasgow'; \n``` \n \n </span> \n ", 
        cardcont_ch03_imgdql08: require('../assets/db/ch03/select_branch_01.svg'),

        cardcont_ch03_sqldql09:
		"## 范围作为查找条件 \n \n <span style='font-size: 95%;'> \n \n `BETWEEN  AND / NOT BETWEEN  AND` \ \n `BETWEEN`并不能增强SQL的功能, \ \n 等同于`>= AND <=` \n \n 例 列出工资在20000和30000英镑之间的所有职员 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT staffNo, fName, lName, position, salary \n FROM Staff \n WHERE salary BETWEEN 20000 AND 30000; \n \n SELECT staffNo, fName, lName, position, salary \n FROM Staff \n WHERE salary >= 20000 AND salary <= 30000; \n``` \n \n </span> \n ",

         cardcont_ch03_sqldql10:
               "## 集合成员测试作为查找条件 \n \n <span style='font-size: 95%;'> \n \n `IN / NOT IN` \ \n  测试数据是否在/不在集合中 \ \n `IN`并不能增强SQL的功能, 但条件表达更简洁 \n \n 例 列出所有的经理与主管 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT staffNo, fName, lName, position \n FROM Staff \n WHERE position IN ('Manager', 'Supervisor'); \n \n SELECT staffNo, fName, lName, position \n FROM Staff \n WHERE position = 'Manager' OR \n       position = 'Supervisor'; \n``` \n \n </span> \n ", 

         cardcont_ch03_sqldql11:
               "## 模式匹配作为查找条件 \n \n <span style='font-size: 95%;'> \n \n `LIKE / NOT LIKE` \n \n SQL中有两种特殊的模式匹配符 \n - %: 百分号表示零或多个字符序列 \n - _: 下划线表示任意单个字符 \n \n 例 找出地址中含有字符串'Glasgow'的所有房主 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT ownerNo, fName, lName, address, telNo \n FROM PrivateOwner \n WHERE address LIKE '%Glasgow%'; \n``` \n \n </span> \n ", 

         cardcont_ch03_sqldql12:
               "## 模式匹配作为查找条件 \n \n <span style='font-size: 95%;'> \n \n `ESCAPE`, 定义转义符 \n \n 若查找的字符串本身包含特殊模式匹配符, 用转义符 \n \n 例 查询学号的第二个字符不是'%'的学生信息 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT * \n FROM Student \n WHERE sno NOT LIKE '_\\%%' ESCAPE '\\'; \n``` \n \n </span> \n ", 

         cardcont_ch03_sqldql13:
               "## 空值作为查找条件 \n \n <span style='font-size: 85%;'> \n \n `IS NULL / IS NOT NULL` \n - `NULL`表示值未知, 不是常量, 不能作为操作数, \ \n `IS`不能用等号`=`代替, \ \n `IS NOT`不能用不等号`!=`或`<>`代替 \n - `NULL`不能用来表示缺省值 \n - 大部分聚集函数忽略空值 \n - 尽量少用空值 \n \n 例 列出查看过编号为PG4的房产但没有留下意见的客户信息 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT clientNo, viewDate \n FROM Viewing \n WHERE propertyNo = 'PG4' AND comment IS NULL; \n``` \n \n </span> \n ",
 
         cardcont_ch03_sqldql14:
               "## 空值作为查找条件 \n \n <span style='font-size: 85%;'> \n \n `IS NULL / IS NOT NULL` \n \n 例 某些学生选修某门课程后没有参加考试, 所以有选课记录, 但没有考试成绩, 查找缺少成绩的学生的学号和相应的课程号 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT sno, cno \n FROM selCourse \n WHERE grade IS NULL; \n``` \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查找所有有成绩的记录的学生学号和课程号 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT sno, cno \n FROM selCourse \n WHERE grade IS NOT NULL; \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql15:
               "## 排序 \n \n <span style='font-size: 100%;'> \n \n `ORDER BY`子句 语法 \n \n </span> \n \n <span style='font-size: 150%;'> \n \n ```\n ORDER BY columnList [ASC│DESC][, ...] \n``` \n \n </span> \n \n <span style='font-size: 90%;'> \n \n - `ASC`, 升序(缺省); `DESC`, 降序 \n - 第一项相同时，再按照第二项进行排序 \n - ORDER BY子句须是SELECT语句的最后一个子句 \n \n </span> \n", 

         cardcont_ch03_sqldql16:
               "## 单列排序 \n \n <span style='font-size: 100%;'> \n \n 可使用列名或者表中相应列的序号 \n \n 例 按工资降序的方式查找列出所有职工的工资信息 </span> \n \n <span style='font-size: 150%;'> \n \n ```\n SELECT staffNo, fName, lName, salary \n FROM Staff \n ORDER BY salary DESC; \n \n SELECT staffNo, fName, lName, salary \n FROM Staff \n ORDER BY 4 DESC; \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql17:
               "## 多列排序 \n \n <span style='font-size: 100%;'> \n \n 例 产生按类型和租金排序的一个房产简要报表 </span> \n \n <span style='font-size: 150%;'> \n \n ```\n SELECT propertyNo, type, rooms, rent \n FROM PropertyForRent \n ORDER BY type, rent DESC; \n``` \n \n </span> \n", 
         cardcont_ch03_imgdql17: require('../assets/db/ch03/select_propertyforrent_01.svg'),

         cardcont_ch03_sqldql18:
               "## 聚合函数 \n \n <span style='font-size: 100%;'> \n \n ISO标准定义了五个聚合函数 </span> \n \n <span style='font-size: 70%;'> \n \n | 名称 | 参数列数据类型 | 结果类型 | 描述 | \n | ------ | ------ | ------ | ------ | \n | `COUNT` | 任意, 可以是* | 数值型 | 列中数据计数 | \n | `SUM` | 数值型 | 数值型 | 列中数据总和 | \n | `AVG` | 数值型 | 数值型 | 列中数据平均值 | \n | `MAX` | 字符型或数值型 | 同参数列类型一样 | 列中数据最大值 | \n | `MIN` | 字符型或数值型 | 同参数列类型一样 | 列中数据最小值 | \n \n </span> \n \n <span style='font-size: 90%;'> \n \n - 只能用于SELECT列表和HAVING子句中 \n - 只对表中单个列的数据进行操作, 返回一个值 \n \n </span> \n", 

         cardcont_ch03_sqldql19:
               "## `COUNT`的使用 \n \n <span style='font-size: 100%;'> \n \n 例 每月租金超过350英镑的房产有多少 </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT COUNT(*) AS myCount \n FROM PropertyForRent \n WHERE rent > 350; \n``` \n \n </span> \n", 
         cardcont_ch03_imgdql19: require('../assets/db/ch03/select_propertyforrent_count.svg'),

         cardcont_ch03_sqldql20:
               "## `COUNT(DISTINCT )`的使用 \n \n <span style='font-size: 100%;'> \n \n 例 5月份有多少处不同的房产被看过 </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT COUNT(DISTINCT propertyNo) AS myCount \n FROM Viewing \n WHERE viewDate BETWEEN '1-May-04' AND '31-May-04'; \n``` \n \n </span> \n", 
         cardcont_ch03_imgdql20: require('../assets/db/ch03/select_viewing_count.svg'),

         cardcont_ch03_sqldql21:
               "## `SUM`的使用 \n \n <span style='font-size: 100%;'> \n \n 例 找出经理的总人数, 并计算他们工资的总和 </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT COUNT(staffNo) AS myCount, \n        SUM(salary) AS mySum \n FROM Staff \n WHERE position = 'Manager'; \n``` \n \n </span> \n", 
         cardcont_ch03_imgdql21: require('../assets/db/ch03/select_staff_count_sum.svg'),

         cardcont_ch03_sqldql22:
               "## `MIN`、`MAX`和`AVG`的使用 \n \n <span style='font-size: 100%;'> \n \n 例 找出所有职员工资的最小、最大和平均值 </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT MIN(salary) AS myMin, \n        MAX(salary) AS myMax, \n        AVG(salary) AS myAvg \n FROM Staff; \n``` \n \n </span> \n", 
         cardcont_ch03_imgdql22: require('../assets/db/ch03/select_staff_minmaxavg.svg'),

         cardcont_ch03_sqldql23:
               "## 分组 \n \n <span style='font-size: 100%;'> \n \n `GROUP BY`子句 语法 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n GROUP BY columnName[, ...] [HAVING condition] \n``` \n \n </span> \n \n <span style='font-size: 90%;'> \n \n - 将查询结果按指定列名的取值分组; 并选取满足HAVING中的聚合函数表达式所指定条件的组 \n - SELECT子句仅可包含列名、聚合函数、常量、组合前述各项的表达式 \n - SELECT子句中除集合函数外, 列须在GROUP BY子句中出现 \n - 应用GROUP BY时, 两个空值是相等的 \n \n </span> \n", 

         cardcont_ch03_sqldql24:
               "## 分组 \n \n <span style='font-size: 100%;'> \n \n 例 找出工作在每一个分支机构的职员人数和他们的工资总和 </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT branchNo, \n        COUNT(staffNo) AS myCount, \n        SUM(salary) AS mySum \n FROM Staff \n GROUP BY branchNo; \n``` \n \n </span> \n", 
         cardcont_ch03_imgdql24: require('../assets/db/ch03/select_staff_group.svg'),

         cardcont_ch03_sqldql25:
               "## 分组约束 \n <span style='font-size: 100%;'> \n \n `HAVING`子句 </span> \n \n <span style='font-size: 90%;'> \n \n - 包含在`GROUP BY`子句中, 不可单独使用, 约束哪些分组出现在最终查询结果中 \n - `WHERE`子句将单行过滤到查询结果中; 而`HAVING`子句则将分组过滤到查询结果中 \n - `HAVING`子句使用的列名必须已出现在`GROUP BY`子句列表中或者包括在聚合函数中 \n - 实践中, `HAVING`子句的条件表达式至少包括一个聚合函数, 否则可把条件移到`WHERE`子句中先过滤单行 \n \n </span> \n", 

         cardcont_ch03_sqldql26:
               "## 分组约束 \n \n <span style='font-size: 100%;'> \n \n 例 对于职员人数多于1人的分支机构, 计算出每一个分支机构的职员人数和他们的工资总和 </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT branchNo, \n        COUNT(staffNo) AS myCount, \n        SUM(salary) AS mySum \n FROM Staff \n GROUP BY branchNo HAVING COUNT(staffNo) > 1 \n ORDER BY branchNo; \n``` \n \n </span> \n", 
         cardcont_ch03_imgdql26: require('../assets/db/ch03/select_staff_group_having.svg'),

         cardcont_ch03_sqldql0201: 
		"## 连接查询 \n <span style='font-size: 100%;'> \n \n 当查询的结果列来自多个表时, 完成查询要求多个表进行连接操作 </span> \n \n <span style='font-size: 90%;'> \n \n - 在`FROM`子句中出现多个表, 表名之间用逗号分隔, 形成指定表的笛卡尔积 \n - 如果存在`WHERE`子句，对笛卡尔积运用查找条件进行行过滤 \n - 如果指定`DISTINCT`, 则消除结果中的冗余行 \n \n </span> \n", 

         cardcont_ch03_sqldql0202: 
		"## 连接查询 \n <span style='font-size: 100%;'> \n \n 简单连接 \n \n </span> \n \n <span style='font-size: 100%;'> \n \n 例 列出查看过房产的所有客户的姓名及所提的意见 \n \n </span> \n \n <span style='font-size: 140%;'> \n \n ```\n SELECT c.clientNo, fName, lName, \n        propertyNo, comment \n FROM Client c, Viewing v \n WHERE c.clientNo = v.clientNo; \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql0203: 
		"## 连接查询 \n <span style='font-size: 100%;'> \n \n 排序连接结果 \n \n </span> \n \n <span style='font-size: 100%;'> \n \n 例 对每一个分支机构, 列出管理房产的职员的姓名、编号及其正在管理的房产 \n \n </span> \n \n <span style='font-size: 140%;'> \n \n ```\n SELECT s.branchNo, s.staffNo, \n        fName, lName, propertyNo \n FROM Staff s, PropertyForRent p \n WHERE s.staffNo = p.staffNo \n ORDER BY s.branchNo, s.staffNo, propertyNo; \n``` \n \n </span> \n",
 
         cardcont_ch03_sqldql0204: 
		"## 连接查询 \n <span style='font-size: 100%;'> \n \n 按多个列分组 \n \n </span> \n \n <span style='font-size: 100%;'> \n \n 例 找出每一位职员管理的房产的数量 \n \n </span> \n \n <span style='font-size: 140%;'> \n \n ```\n SELECT s.branchNo, s.staffNo, \n        COUNT(*) AS myCount \n FROM Staff s, PropertyFoRent p \n WHERE s.staffNo = p.staffNo \n GROUP BY s.branchNo, s.staffNo \n ORDER BY s.branchNo, s.staffNo; \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql0205: 
		"## 连接查询 \n <span style='font-size: 100%;'> \n \n 等值连接 \n \n </span> \n \n <span style='font-size: 100%;'> \n \n 例 查询每个学生及其选修课程的情况 \n \n </span> \n \n <span style='font-size: 140%;'> \n \n ```\n SELECT Student.*, SelCourse.* \n FROM Student, SelCourse \n WHERE Student.sno = SelCourse.sno; \n \n SELECT Student.*, \n        SelCourse.cno, SelCourse.grade \n FROM Student, SelCourse \n WHERE Student.sno = SelCourse.sno; \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql0206: 
		"## 连接查询 \n <span style='font-size: 100%;'> \n \n 自身连接 \n \n </span> \n \n <span style='font-size: 100%;'> \n \n 例 查询每一门课的间接先修课 \n \n </span> \n \n <span style='font-size: 140%;'> \n \n ```\n SELECT First.cno, Second.pcno \n FROM Course First, Course Second \n WHERE First.pcno = Second.cno; \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql0207: 
		"## 连接查询 \n <span style='font-size: 100%;'> \n \n 自身连接 \n \n </span> \n \n <span style='font-size: 90%;'> \n \n 例 查询选修了'95001'所选修的某门课程的学生的学号 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT DISTINCT SelCourse1.sno \n FROM SelCourse SelCourse1, SelCourse SelCourse2 \n WHERE SelCourse1.cno = SelCourse2.cno AND \n       SelCourse2.sno = '95001'; \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql0208: 
		"## 连接查询 \n \n <span style='font-size: 92%;'> \n \n 例 按平均成绩的降序给出所有课程都及格的学生学号、姓名及其平均成绩，成绩统计时不包括008号考查课 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT Student.sno, sname, \n        AVG(grade) AS avgGrade \n FROM Student, SelCourse \n WHERE Student.sno = SelCourse.sno AND \n       cno <> '008' \n GROUP BY sno HAVING MIN(grade) >= 60 \n ORDER BY avgGrage DESC;  \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql0209: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 一个`SELECT`语句之内嵌有另一个`SELECT`语句 \n \n </span> \n \n <span style='font-size: 90%;'> \n \n 例 查询选修了课程'C1'的学生的学号和姓名 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT sno \n FROM SelCourse \n WHERE cno = 'C1'; \n -- 将查询结果放在表TempTab中 \n \n SELECT Student.sno, sname \n FROM Student, TempTab \n WHERE Student.sno = TempTab.sno; \n``` \n \n </span> \n \n </span> \n \n <span style='font-size: 75%;'> \n \n - 可以将生成TempTab的`SELECT`语句嵌入第二个`SELECT`语句吗? \n \n </span> \n",
 
         cardcont_ch03_sqldql0210: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 子查询出现在什么位置 \n \n </span> \n \n <span style='font-size: 80%;'> \n \n - 不能任意地将一个`SELECT`语句嵌入另一个`SELECT`语句, `FROM`子句中的表不能是`SELECT`语句的结果 \n - 不能用在`ORDER BY`子句中 \n - 子查询可以使用在`SELECT`语句的`WHERE`和`GROUP BY HAVING`子句中 \n - 子查询一般跟在`IN`、`SOME(ANY)`、`ALL`或`(NOT) EXISTS`等谓词后面 \n - 子查询也可以出现在`INSERT`、`UPDATE`和`DELETE`语句中 \n \n </span> \n \n ", 

         cardcont_ch03_sqldql0211: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 不相关子查询 \n \n </span> \n \n <span style='font-size: 95%;'> \n \n 例 查询与'刘晨'在同一个系学习的学生 \n \n 分步法 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n --1) 确定'刘晨'所在系 \n SELECT depart \n FROM Student \n WHERE sname = '刘晨'; \n \n --2) 查找所有在information系学习的学生 \n SELECT sno, sname, depart \n FROM Student \n WHERE depart = 'information'; \n``` \n \n </span> \n", 

         cardcont_ch03_sqldql0212: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 不相关子查询 \n \n </span> \n \n <span style='font-size: 80%;'> \n \n 例 查询与'刘晨'在同一个系学习的学生 \n \n 嵌套子查询法 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT sno, sname, depart \n FROM Student \n WHERE depart IN ( \n  SELECT depart \n  FROM Student \n  WHERE sname = '刘晨' \n ); \n``` \n \n </span> \n \n <span style='font-size: 75%;'> \n \n - 当子查询是比较表达式中的一个操作数时, \ \n 子查询须出现在表达式的右边 \n \n </span> \n \n", 

         cardcont_ch03_sqldql0213: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 不相关子查询 \n \n </span> \n \n <span style='font-size: 95%;'> \n \n - 内层子查询完全独立于外层`SELECT`语句, 子查询不接收外层查询的任何输入数据, 向外层`SELECT`语句传递一个行集 \n - 概念性执行顺序: 先执行内层子查询, 然后执行外层 \n \n </span> \n", 

         cardcont_ch03_sqldql0214: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 不相关子查询 \n \n </span> \n \n <span style='font-size: 95%;'> \n \n 例 查询选修了课程C1的学生的学号和姓名 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT sno, sname \n FROM Student \n WHERE sno IN ( \n  SELECT sno \n  FROM SelCourse \n  WHERE cno = 'C1' \n ); \n``` \n \n </span> \n",

         cardcont_ch03_sqldql0215: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 相关子查询 \n \n </span> \n \n <span style='font-size: 65%;'> \n \n - 内层子查询使用外层`SELECT`语句的列X, \ \n 对于X的每一个取值x, 都执行一次内层子查询 \n \n 例 使用另一种方法实现查询选修了课程C1的学生学号和姓名 \n \n </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT DISTINCT sno, sname \n FROM Student \n WHERE 'C1' IN ( \n  SELECT cno \n  FROM SelCourse \n  WHERE Student.sno = SelCourse.sno \n ); \n``` \n \n </span> \n \n <span style='font-size: 65%;'> \n \n - 默认情况下，子查询中列名取自子查询FROM子句中给定的表, \ \n 也可通过限定列名的办法指定取自外查询`FROM`子句中的表 \n \n </span> \n \n ", 

         cardcont_ch03_sqldql0216: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 相关子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询所有选修了课程C1的学生姓名 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sname \n FROM Student \n WHERE EXISTS ( \n  SELECT * \n  FROM SelCourse \n  WHERE sno = Student.sno AND cno = 'C1' \n ); \n \n SELECT sname \n FROM Student, SelCourse \n WHERE Student.sno = SelCourse.sno AND cno = 'C1'; \n``` \n \n </span> \n \n <span style='font-size: 65%;'> \n \n - 子查询`SELECT`列表须是单个列名或表达式, 除非使用了谓词`EXISTS` \n \n </span> \n \n", 

         cardcont_ch03_sqldql0217: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n `IN`谓词子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 父查询与子查询之间用`IN`进行连接, 判断某个属性列值是否在子查询的结果中 \n \n 例 查询选修了2学分课程的学生号、成绩 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sno, grade \n FROM SelCourse \n WHERE cno IN ( \n  SELECT cno \n  FROM Course \n  WHERE credit = 2 \n ); \n``` \n \n </span> \n \n ", 
         cardcont_ch03_sqldql0218: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n `IN`谓词子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询选修了数据库课程的学生学号、成绩 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sno, grade \n FROM SelCourse \n WHERE cno IN ( \n  SELECT cno \n  FROM Course \n  WHERE cname = '数据库' \n ); \n \n SELECT sno, grade \n FROM SelCourse, Course \n WHERE SelCourse.cno = Course.cno AND \n       cname = '数据库'; \n``` \n \n </span> \n \n ", 

         cardcont_ch03_sqldql0219: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带有比较运算符的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 子查询返回单值时可以用比较运算符 \n \n 通用形式 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n expr <|<=|=|<>|>|>= (Subquery) \n``` \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询与'刘晨'在同一个系学习的学生 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sno, sname, depart \n FROM Student \n WHERE depart = ( \n  SELECT depart \n  FROM Student \n  WHERE sname = '刘晨' \n ); \n``` \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0220: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带有比较运算符的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 找出年龄超过平均年龄的学生姓名 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sname \n FROM Student \n WHERE age ＞ ( \n  SELECT AVG(age) \n  FROM Student \n ); \n``` \n \n </span> \n \n", 

         cardcont_ch03_sqldql0221: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带有量化比较谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 通用形式 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n expr <|<=|=|<>|>|>= {SOME|ANY|ALL} (Subquery) \n``` \n \n </span> \n \n <span style='font-size: 70%;'> \n \n - `expr` $\\theta$ `SOME|ANY (Subquery)`为真, \ \n 当且仅当至少存在一个由子查询返回的元素$s$, `expr` $\\theta$ $s$为真 \ \n `SOME`与`ANY`含义相同 \n - `expr` $\\theta$ `ALL (Subquery)`为真, \ \n 当且仅当对每一个由子查询返回的元素$s$, `expr` $\\theta$ $s$为真 \n \n </span> \n \n",

         cardcont_ch03_sqldql0222: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带有量化比较谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询其他系比信息系某一学生年龄小的学生的姓名和年龄 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sname, age \n FROM Student \n WHERE age < SOME ( \n  SELECT age \n  FROM Student \n  WHERE depart = 'information' \n ) \n AND depart <> 'information'; \n``` \n \n </span> \n \n ",

         cardcont_ch03_sqldql0223: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带有量化比较谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询其他系比信息系任一(任意)学生年龄小的学生名单 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sname, age \n FROM Student \n WHERE age < ( \n  SELECT MIN(age) \n  FROM Student \n  WHERE depart = 'information' \n ) \n AND depart <> 'information'; \n``` \n \n </span> \n \n ",

         cardcont_ch03_sqldql0224: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带有量化比较谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询有一门课程成绩在90分以上的学生的姓名 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sname \n FROM Student \n WHERE sno = SOME ( \n  SELECT DISTINCT sno \n  FROM SelCourse \n  WHERE grade > 90 \n ); \n``` \n \n </span> \n \n ",

         cardcont_ch03_sqldql0225: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带有量化比较谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询其他系比信息系所有学生年龄小的学生的姓名和年龄 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sname \n FROM Student \n WHERE age < ALL ( \n  SELECT age \n  FROM Student \n  WHERE depart = 'information' \n ) \n AND depart <> 'information'; \n``` \n \n </span> \n \n ",

         cardcont_ch03_sqldql0226: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带有量化比较谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 找出平均成绩最高的学生的学号 \n \n </span> \n \n ",
         cardcont_ch03_sqldql0226_code01: 
		"<span style='font-size: 115%;'> \n \n ```\n SELECT sno \n FROM SelCourse \n WHERE AVG(grade) >= ALL ( \n  SELECT AVG(grade) \n  FROM SelCourse \n  GROUP BY sno \n ); \n``` \n \n </span> \n \n ",
         cardcont_ch03_sqldql0226_code02: 
		"<span style='font-size: 115%;'> \n \n ```\n SELECT sno \n FROM SelCourse \n GROUP BY sno \n HAVING AVG(grade) >= ALL ( \n  SELECT AVG(grade) \n  FROM SelCourse \n  GROUP BY sno \n ); \n``` \n \n </span> \n \n ",
         cardcont_ch03_sqldql0226_01: 
		" <span style='font-size: 85%;'> \n \n - 哪一种写法正确？\n \n </span> \n \n ",

         cardcont_ch03_sqldql0227: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带EXISTS谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 通用形式 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n [NOT] EXISTS (Subquery) \n``` \n \n </span> \n \n <span style='font-size: 70%;'> \n \n - `EXISTS (Subquery)`为真, \ \n 当且仅当子查询返回一个非空的集合 \n - `NOT EXISTS (Subquery)`为真, \ \n 当且仅当子查询返回的集合为空 \n - 一些带`EXISTS`的子查询不能被其他形式的子查询等价替换 \n - 所有带`IN`、比较运算符、`SOME(ANY)`和`ALL`谓词的子查询都能用带`[NOT] EXISTS`的子查询等价替换 \n \n </span> \n \n",

         cardcont_ch03_sqldql0228: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带EXISTS谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询所有选修了'C1'号课程的学生的姓名 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sname \n FROM Student \n WHERE EXISTS ( \n  SELECT * \n  FROM SelCourse \n  WHERE sno = Student.sno AND cno = 'C1' \n ); \n``` \n \n </span> \n \n ",
 
         cardcont_ch03_sqldql0229: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 带EXISTS谓词的子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 用`NOT EXISTS`谓词实现关系代数的差运算 \n \n 例 查询没有选修'C1'号课程的学生的姓名 \n \n </span> \n \n <span style='font-size: 115%;'> \n \n ```\n SELECT sname \n FROM Student \n WHERE NOT EXISTS ( \n  SELECT * \n  FROM SelCourse \n  WHERE sno = Student.sno AND cno = 'C1' \n ); \n``` \n \n </span> \n \n ", 

         cardcont_ch03_sqldql0230: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 用`NOT EXISTS`实现全称量词子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n - SQL语言不支持全称量词 \n - 全称量词可以转换为等价的带有存在量词的谓词 \ \n $(\\forall x)P \\equiv \\neg \\big( \\exists x ( \\neg P) \\big)$ \n - 用`NOT EXISTS`实现全称量词查询, 实现关系代数除运算 \n \n </span> \n \n ",
 
         cardcont_ch03_sqldql0231: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 用`NOT EXISTS`实现全称量词子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询选修了全部课程的学生姓名 \n \n 形式化 \n - $P$: 学生$s$选修了课程$c$ \n - $\\forall(c) P$: 对所有课程而言, 学生$s$都选修了 \n - 谓词演算转换: $\\forall(c) P \\equiv \\neg \\big( \\exists c ( \\neg P) \\big)$ \n \n 语义转换: 查询这样的学生$s$, 不存在一门课程$c$是$s$没有选修的 \n \n </span> \n \n ", 

         cardcont_ch03_sqldql0232: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 用`NOT EXISTS`实现全称量词子查询 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n 例 查询选修了全部课程的学生姓名 \n \n </span> \n \n <span style='font-size: 100%;'> \n \n ```\n -- query student s \n SELECT sname \n FROM Student \n -- no course c exists \n WHERE NOT EXISTS ( \n  SELECT * \n  FROM Course \n  -- student s does not select course c \n  WHERE NOT EXISTS ( \n   SELECT ﹡\n   FROM SelCourse \n   WHERE sno = Student.sno AND cno = Course.cno \n  ) \n ); \n``` \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0233: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 用`NOT EXISTS`实现全称量词子查询 \n \n </span> \n \n <span style='font-size: 80%;'> \n \n 例 查询至少选修了学生95002选修的全部课程的学生的学号 \n \n 形式化 \n - $P$: 学生95002选修了课程$c$ \n - $Q$: 学生$s$选修了课程$c$ \n - $\\forall(c) P \\rightarrow Q$: \ \n 对所有课程而言, 学生95002选修了, 学生$s$也选修了 \n - 谓词演算转换: $\\forall(c) P \\rightarrow Q \\equiv \\neg \\big( \\exists c ( \\neg ( P \\rightarrow Q) ) \\big) \\equiv \\neg \\big( \\exists c ( P \\wedge \\neg Q ) \\big)$ \n \n 语义转换: 查询这样的学生$s$, 不存在一门课程$c$, 学生95002选修了, 而$s$没有选修 \n \n </span> \n \n ",
 
         cardcont_ch03_sqldql0234: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 用`NOT EXISTS`实现全称量词子查询 \n \n </span> \n \n <span style='font-size: 80%;'> \n \n 例 查询至少选修了学生95002选修的全部课程的学生的学号 \n \n </span> \n \n <span style='font-size: 85%;'> \n \n ```\n -- query student s \n SELECT sno FROM Student \n -- no course c exists \n WHERE NOT EXISTS ( \n  SELECT * FROM Course \n  -- student 95002 select course c \n  WHERE EXISTS ( \n   SELECT ﹡FROM SelCourse SelCourseX \n   WHERE SelCourseX.cno = Course.cno AND SelCourseX.sno = '95002' \n  ) \n  -- student s does not select course c \n  AND NOT EXISTS ( \n    SELECT * FROM SelCourse SelCourseY \n    WHERE SelCourseY.cno = Course.cno AND SelCourseX.sno = Student.sno \n  ) \n ); \n``` \n \n </span> \n \n ", 

         cardcont_ch03_sqldql0235: 
		"## 子查询 \n <span style='font-size: 100%;'> \n \n 用`NOT EXISTS`实现全称量词子查询 \n \n </span> \n \n <span style='font-size: 80%;'> \n \n 例 查询至少选修了学生95002选修的全部课程的学生的学号 \n \n </span> \n \n <span style='font-size: 95%;'> \n \n ```\n -- query student s \n SELECT DISTINCT sno FROM SelCourse SelCourseX \n -- no course c selected by student 95002 \n WHERE NOT EXISTS ( \n  SELECT * FROM SelCourse SelCourseY \n  WHERE SelCourseY.sno = '95002' \n  -- student s does not select course c \n  AND NOT EXISTS ( \n   SELECT * FROM SelCourse SelCourseZ \n   WHERE SelCourseZ.sno = SelCourseX.sno AND \n         SelCourseZ.cno = SelCourseY.cno \n  ) \n ); \n``` \n \n </span> \n \n ", 

         cardcont_ch03_sqldql0236:
		"## 扩展SQL语句 \n 并、交、差运算 \n \n <span style='font-size: 120%;'> \n \n ```\n Query1 {UNION|INTERSECT|EXCEPT [ALL] Query2} \n``` \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0237:
		"## 扩展SQL语句 \n 并运算 \n \n <span style='font-size: 90%;'> \n \n 例 查询计算机系的学生及年龄大于19岁的学生 \n \n </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT * FROM Student \n WHERE depart = 'computer' \n UNION \n SELECT * FROM Student \n WHERE age > 19; \n``` \n \n </span> \n \n <span style='font-size: 90%;'> \n \n - `UNION`的结果中去掉两个子查询中重复的行 \n </span> \n \n", 

         cardcont_ch03_sqldql0238:
		"## 扩展SQL语句 \n 并运算 \n \n <span style='font-size: 90%;'> \n \n 例 查询计算机系的学生及年龄大于19岁的学生 \n \n </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT * FROM Student \n WHERE depart = 'computer' \n UNION ALL \n SELECT * FROM Student \n WHERE age > 19; \n``` \n \n </span> \n \n <span style='font-size: 90%;'> \n \n - `UNION`的结果中保留两个子查询中重复的行 \n </span> \n \n", 

         cardcont_ch03_sqldql0239:
		"## 扩展SQL语句 \n 交运算 \n \n <span style='font-size: 90%;'> \n \n 例 查询既选修了课程'C1'又选修了'C2'的学生学号与姓名 \n \n </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT Student.sno, sname FROM Student, SelCourse \n WHERE Student.sno = SelCourse.sno AND cno = 'C1' \n INTERSECT \n SELECT Student.sno, sname FROM Student, SelCourse \n WHERE Student.sno = SelCourse.sno AND cno = 'C2'; \n``` \n \n </span> \n \n", 

         cardcont_ch03_sqldql0240:
		"## 扩展SQL语句 \n 交运算 `INTERSECT ALL` \n \n <span style='font-size: 140%;'> \n \n ```\n Q:= Q1 INTERSECT [ALL] Q2 \n``` \n \n </span> \n \n <span style='font-size: 80%;'> \n \n 假定$x$在Q1结果中出现$m$次，在Q2结果中出现$n$次 \n - `INTERSECT` \n      - 若$m$或$n$为$0$, 则Q中$x$出现的次数为$0$; 否则为$1$ \n - `INTERSECT ALL` \n      - Q中$x$出现的次数为$\\min(m, n)$ \n \n 例 $Q1 := \\lbrace a, a, a, b, b, c, d \\rbrace$, $Q2 := \\lbrace a, a, b, b, b, c, e \\rbrace$ \ \n &emsp; $Q1 \\ \\mathtt{INTERSECT} \\ Q2 = \\lbrace a, b, c \\rbrace$ \ \n &emsp; $Q1 \\ \\mathtt{INTERSECT \\ ALL} \\ Q2 = \\lbrace a, a, b, b, c \\rbrace$ \n \n </span> \n \n", 

         cardcont_ch03_sqldql0241:
		"## 扩展SQL语句 \n 差运算 \n \n <span style='font-size: 90%;'> \n \n 例 查询没选修'95001'所选修的任何课程的学生的学号 \n \n </span> \n \n <span style='font-size: 120%;'> \n \n ```\n SELECT sno FROM Student \n EXCEPT \n SELECT SelCourse1.sno \n FROM SelCourse SelCourse1, SelCourse SelCourse2 \n WHERE SelCourse1.cno = SelCourse2.cno AND \n       SelCourse2.sno = '95001'; \n``` \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0242:
		"## 扩展SQL语句 \n 差运算 `EXCEPT ALL` \n \n <span style='font-size: 140%;'> \n \n ```\n Q:= Q1 EXCEPTT [ALL] Q2 \n``` \n \n </span> \n \n <span style='font-size: 80%;'> \n \n 假定$x$在Q1结果中出现$m$次，在Q2结果中出现$n$次 \n - `EXCEPTT` \n      - 若$m$不为$0$且$n$为$0$, 则Q中$x$出现的次数为$1$; 否则为$0$ \n - `EXCEPT ALL` \n      - Q中$x$出现的次数为$m - n$; 若$m - n < 0$, 则次数为$0$ \n \n 例 $Q1 := \\lbrace a, a, a, b, b, c, d \\rbrace$, $Q2 := \\lbrace a, a, b, b, b, c, e \\rbrace$ \ \n &emsp; $Q1 \\ \\mathtt{EXCEPT} \\ Q2 = \\lbrace d \\rbrace$ \ \n &emsp; $Q1 \\ \\mathtt{EXCEPT \\ ALL} \\ Q2 = \\lbrace a, d \\rbrace$ \n \n </span> \n \n", 

         cardcont_ch03_sqldql0243:
		"## 扩展SQL语句 \n 扩展`FROM`子句 语法 \n \n <span style='font-size: 100%;'> \n \n ```\n FROM tableref[, tableref ...] \n \n tableref: \n   tablename [[AS] corr_name [(colname[, colname ...])]] \n | (subquery) [AS] corr_name [(colname[, colname ...])] \n | tableref1 [INNER|{LEFT|RIGHT|FULL}][OUTER]] JOIN tableref2 \n    ON search_condition | USING (colname [, colname ...]) \n``` \n \n </span> \n \n", 

         cardcont_ch03_sqldql0244:
		"## 扩展SQL语句 \n 扩展`FROM`子句 为列重命名 \n \n <span style='font-size: 100%;'> \n \n 例 查询年龄大于19岁的学生学号和姓名 \n \n </span> \n \n <span style='font-size: 110%;'> \n \n ```\n SELECT student_number, student_name \n FROM Student AS Student1 (student_number, student_name) \n WHERE age > 19; \n``` \n \n </span> \n \n", 

         cardcont_ch03_sqldql0245:
		"## 扩展SQL语句 \n 扩展`FROM`子句 子查询当作表使用 \n \n <span style='font-size: 100%;'> \n \n 例 查询至少有30人选修的课程的信息 \n \n </span> \n \n <span style='font-size: 110%;'> \n \n ```\n SELECT Course.cno, cname, pcno, credit \n FROM ( \n  SELECT cno \n  FROM SelCourse \n  GROUP BY cno HAVING COUNT(sno) >= 30 \n ) TabTemp, C \n WHERE TabTemp.cno = Course.cno; \n``` \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0246:
		"## 扩展SQL语句 \n 扩展`FROM`子句 子查询当作表使用 \n \n <span style='font-size: 100%;'> \n \n 例 查询学生的最高成绩的平均值 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT AVG(TabTemp.maxGrade) \n FROM ( \n  SELECT sno, MAX(grade) AS maxGrade \n  FROM SelCourse \n  GROUP BY sno \n ) TabTemp; \n``` \n \n </span> \n \n", 

         cardcont_ch03_sqldql0247:
		"## 扩展SQL语句 \n 扩展`FROM`子句 特殊的连接结果当作表使用 \n \n <span style='font-size: 100%;'> \n \n - `ON search_condition`, 指定所要参加连接的列之间应满足的条件 \n - `USING`, 指定两表中参加连接的列名集合 例 查询选修过课程的学生学号、姓名、课程号及成绩 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT Student.sno, sname, cno, grade \n FROM Student JOIN SelCourse \n  ON Student.sno = SelCourse.sno; \n \n SELECT Student.sno, sname, cno, grade \n FROM Student JOIN SelCourse USING (sno); \n``` \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0247_01:
		"## CTE与递归查询 \n \n <span style='font-size: 100%;'> \n \n 非递归CTE (Common Table Expression) 语法 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n WITH cte_name AS ( \n  cte_query \n ) \n \n SELECT * \n FROM cte_name; \n``` \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0247_02:
		"## CTE与递归查询 \n \n <span style='font-size: 100%;'> \n \n 递归CTE (Common Table Expression) 语法 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n WITH cte_name AS ( \n  anchor_cte_query \n  UNION \n  recursive_cte_query \n ) \n \n SELECT * \n FROM cte_name; \n``` \n \n </span> \n \n", 

         cardcont_ch03_sqldql0247_03:
		"## CTE与递归查询 \n \n <span style='font-size: 85%;'> \n \n 例 有航班表$\\mathtt{Flight}(\\mathsf{airline}, \\mathsf{start}, \\mathsf{end}, \\mathsf{depart}, \\mathsf{arrive})$, \ \n 请写SQL语句查询能从一个城市飞到另一个城市的城市对集合, 含直接到达和间接中转到达 \n \n 分析: 定义从一个城市$s$能飞到的城市集合为$\\mathtt{Reach}(s)$  \n - 直接到达 \ \n $\\mathtt{Reach}(s) = \\big\\lbrace e \\vert \\mathtt{Flight}(a, s, e, d, r) \\big\\rbrace$ \n - 间接到达 \ \n $\\mathtt{Reach}(s) = \\big\\lbrace e \\vert \\mathtt{Flight}(a, s, e^{\\prime}, d, r) \\wedge e \\in \\mathtt{Reach}(e^{\\prime}) \\big\\rbrace$ \n \n </span> \n \n ", 

         cardcont_ch03_sqldql0247_04:
		"## CTE与递归查询 \n \n <span style='font-size: 100%;'> \n \n 例 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n WITH RECURSIVE Reach(from, to) AS \n  (SELECT from, to \n   FROM Flight) \n  UNION \n  (SELECT Flight.from, Reach.to \n   FROM Flight，Reach \n   WHERE Flight.to = Reach.from) \n SELECT * FROM Reach; \n``` \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0247_05:
		"## CTE与递归查询 \n \n <span style='font-size: 90%;'> \n \n 例 有下图中所示的一颗二叉树, 将树中所有父子节点对存储在表$\\mathtt{Tree}(\\mathsf{key}, \\mathsf{pkey}, \\mathsf{value})$中, 请写SQL语句查询该树中除根结点$k$以外的所有后代结点的集合 \n \n </span> \n \n ", 
         cardcont_ch03_imgdql0247_05: require('../assets/db/ch03/tree_tab.svg'),

         cardcont_ch03_sqldql0247_06:
		"## CTE与递归查询 \n \n <span style='font-size: 70%;'> \n \n 例 \n \n 分析: 定义根节点$\\langle 1, k \\rangle$所有后代的集合为$\\mathtt{Desc}(1)$  \n - 子女 \ \n $\\mathtt{Desc}(1) = \\big\\lbrace \\langle \\mathsf{key}, \\mathsf{value} \\rangle \\vert \\mathtt{Tree}(\\mathsf{key}, \\mathsf{pkey}, \\mathsf{value}) \\wedge \\mathsf{pkey} = 1 \\big\\rbrace$ \n - 其他后代 \ \n $ \\mathtt{Desc}(1) = \\big\\lbrace \\langle \\mathsf{key}, \\mathsf{value} \\rangle \\vert \\mathtt{Tree}(\\mathsf{key}, \\mathsf{pkey}, \\mathsf{value}) \\wedge $ \ \n &emsp; &emsp; &emsp; &emsp; &ensp; &ensp; $\\mathtt{Tree}(\\mathsf{pkey}, \\mathsf{ppkey}, \\mathsf{pvalue}) \\wedge $ \ \n &emsp; &emsp; &emsp; &emsp; &ensp; &ensp; $ \\langle \\mathsf{pkey}, \\mathsf{pvalue} \\rangle \\in \\mathtt{Desc}(1) \\big\\rbrace $ \n \n </span> \n \n ",
 
         cardcont_ch03_sqldql0247_07:
		"## CTE与递归查询 \n \n <span style='font-size: 100%;'> \n \n 例 \n \n </span> \n \n <span style='font-size: 110%;'> \n \n ```\n WITH RECURSIVE Desc(key, value) AS \n ( SELECT key, value \n   FROM Tree \n   WHERE pkey = 1 ) \n UNION \n ( SELECT Tree.key, Tree.value \n   FROM Desc, Tree \n   WHERE Desc.key = Tree.pkey ) \n SELECT * FROM Desc;  \n``` \n \n </span> \n \n", 

         cardcont_ch03_sqldql0248:
		"## SQL语句的能力 \n 非过程性语言(non-procedural language) \n \n <span style='font-size: 100%;'> \n \n - 指明要做什么, 而不必说明怎么做 \n - 各语句之间不存在需要程序员考虑的隐含顺序 \n - 便于临时处理即席查询(ad hoc query) \n \n </span> \n \n ",
 
         cardcont_ch03_sqldql0249:
		"## SQL语句的能力 \n 非过程性语言(non-procedural language) \n \n <span style='font-size: 100%;'> \n \n 例 求选修了'C2'号课程的学生姓名 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT Student.sno \n FROM Student, SelCourse \n WHERE Student.sno = SelCourse.sno AND \n       SelCourse.cno = 'C2'; \n``` \n \n </span> \n \n <span style='font-size: 80%;'> \n \n 等价关系代数表达式 \n \n $ \\Pi_{\\mathrm{sname}} \\big( \\sigma_{\\mathrm{student.sno} = \\text{selcourse.sno} \\wedge \\text{selcourse.cno} = \\text{'C2'}} (\\mathrm{student} \\times \\mathrm{selcourse}) \\big)$ \n $ \\Pi_{\\mathrm{sname}} \\big( \\sigma_{\\mathrm{selcourse.cno} = \\text{'C2'}} (\\mathrm{student} \\Join \\mathrm{selcourse}) \\big) $ \n $ \\Pi_{\\mathrm{sname}} \\big( \\mathrm{student} \\Join \\sigma_{\\mathrm{selcourse.cno} = \\text{'C2'}} (\\mathrm{selcourse}) \\big) $ \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0250:
		"## SQL语句的能力 \n 非过程性语言(non-procedural language) \n \n <span style='font-size: 100%;'> \n \n - 非过程性语言不可能具备图灵能力 \n     - 图灵能力(Turing power), 能执行有限长度的简单过程性程序的机器可以执行任何算法的计算过程 \n - 将SQL与过程性语言相结合(嵌入式SQL), 提供图灵能力 \n \n </span> \n \n ",

         cardcont_ch03_sqldql0251:
		"## SQL语句的能力 \n 不允许聚合函数嵌套 \n \n <span style='font-size: 100%;'> \n \n 例 求学生成绩表中成绩的中值(median) \n \n 例 求学生总学分的平均学分 \n \n </span> \n \n <span style='font-size: 130%;'> \n \n ```\n SELECT AVG( \n  SELECT SUM(CC) \n  FROM SelCourse, Course \n  WHERE SelCourse.cno = Course.cno \n  GROUP BY sno \n ); \n``` \n \n </span> \n \n <span style='font-size: 90%;'> \n \n - 基本SQL不允许子查询出现在聚合函数内部 \n \n </span> \n \n",
 
         cardcont_ch03_sqldql0252:
		"## SQL语句的能力 \n 基本SQL不能创建的报表 \n \n <span style='font-size: 100%;'> \n \n 例 求学生的平均成绩, 并按照平均成绩低于60分、60-79、80-100分类统计学生人数 \n - 不可能由基本SQL语句产生 \n - 可以结合过程性编程语言产生 \n \n </span> \n \n ",
 
         cardcont_ch03_sqldql0253:
		"## SQL语句的能力 \n 不能实现传递闭包(transitive closure) \n \n <span style='font-size: 100%;'> \n \n 例 求课程'C3'的所有必须先修的课程 \ \n &emsp; C3 $\\rightarrow$ C1 $\\rightarrow$ C5 $\\rightarrow$ C7 $\\rightarrow$ C6  \n \n </span> \n \n ",

         cardcont_ch03_sqldql0254:
		"## SQL语句的能力 \n 布尔条件的有限能力 \n \n <span style='font-size: 100%;'> \n \n 例 查询平均成绩排名前20位的学生的学号 \n \n </span> \n \n ",

        cardcont_ch03_procfunsynax:
		"## SQL过程与函数 \n 语法 \n \n <span style='font-size: 92%;'> \n \n ```\n CREATE PROCEDURE ProcName ([[IN|OUT|INOUT] paramName type[, ...]]) \n  routine_body \n``` \n ```\n CREATE FUNCTION FuncName ([[IN|OUT|INOUT] paramName type[, ...]]) \n RETURNS type \n  routine_body \n``` \n ```\n DROP {PROCEDURE|FUNCTION} PFName; \n``` \n \n </span> \n \n", 

        cardcont_ch03_procexample:
		"## SQL过程 \n 举例 \n \n <span style='font-size: 92%;'> \n \n ```\n delimiter // \n CREATE PROCDURE ProcEmp(IN id INT, OUT num INT, INOUT salCount INT) \n BEGIN \n  DELETE FROM emp WHERE empno = id; \n  SELECT MAX(sal) FROM emp INTO num; \n  SELECT COUNT(*) INTO salCount FROM emp WHERE sal > salCount; \n END // \n delimiter ; \n SET @salCount = 1250; \n CALL ProcEmp(7369, @num, @salCount); \n SELECT @num, @salCount; \n``` \n \n </span> \n \n", 

        cardcont_ch03_funcexample:
		"## SQL函数 \n 举例 \n \n <span style='font-size: 92%;'> \n \n ```\n delimiter // \n CREATE FUNCTION GetSal(id INT) \n RETUNS INT \n BEGIN \n  RETURN (SELECT sal FROM emp WHERE empno = id); \n END // \n delimiter ; \n SELECT GetSal(7698); \n``` \n \n </span> \n \n", 

      } // end of return 
    }, // end of data(){

    head: {
      // link tags
      link: [
        { rel: 'apple-touch-icon-precomposed', href: require( '../assets/db/dm/apple-touch-icon-114x114.png'), sizes: '114x114', type: 'image/png' }, 
        // ...
      ],
    }, 

    created() {
      const _this = this;
    },

    mounted() {

      // polyfill
      if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    return this.substr(position || 0, searchString.length) === searchString;
	  };
      }
      if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (search, this_len) {
	    if (this_len === undefined || this_len > this.length) {
	      this_len = this.length;
	    }
	    return this.substring(this_len - search.length, this_len) === search;
	  };
      }

      marked.use(mangle());
      const options = {
	 prefix: "my-prefix-",
      };
      marked.use(gfmHeadingId(options));

      let app = document.getElementById("app");
      if ( app.className != 'reveal' ) {
        app.className = "reveal";
	
        this.Reveal = new Reveal({ 
          center: true,
          hash: true,
          slideNumber: 'c/t',
          // autoSlide: 5000,
          // loop: true,
          // logo: true,
          // showNotes: true,        
          showNotes: 'separate-page', 
          controls: true,
          progress: true,
	  history: true,
          transition: 'slide',

          plugins: [ RevealMath ],
          // plugins: [ RevealMath.KaTex ],
          // plugins: [ RevealSearch ],

          menu: {
		  numbers: 'c',
		  openSlideNumber: true,
                  hideMissingTitles: true,
		  themes: false,
		  themesPath: 'dist/theme/',
		  transitions: true,
		  custom: [
		    {
		      title: 'Custom',
		      icon: '<i class="fa fa-bookmark">',
		      src: "links.html",
		    },
		  ],
          },

	  chalkboard: { 
	     // src: this.chalkboard_src,
	     storage: "chalkboard-session-storage",
	  },

	  seminar: { 
		server: "http://172.28.6.107:6090/",
		port: 6090,
		// server: "https://fajiangyu.net:8090/",
		// port: 8090,
		hash: '$2a$05$hhgakVn1DWBfgfSwMihABeYToIBEiQGJ.ONa.HWEiNGNI6mxFCy8S', // for password '123456'
		room: 'tc',
		autoJoin: true, 
	  },

	  chart: {
		defaults: {
			color: 'lightgray', // color of labels
			scale: { 
				beginAtZero: true, 
				ticks: { stepSize: 1 },
				grid: { color: "lightgray" } , // color of grid lines
			},
		},
		bar: { backgroundColor: [ "rgba(20,220,220,.8)" , "rgba(220,120,120,.8)", "rgba(20,120,220,.8)" ]},
		pie: { backgroundColor: [ ["rgba(20,220,220,.8)" , "rgba(220,120,120,.8)", "rgba(20,120,220,.8)"] ]},
	  },
        });
	
        this.g_deck = this.Reveal;
        this.Reveal.initialize();

        var room = this.getParameterByName("room") || this.generateToken(32);
        // console.log("seminar room: ", room);
        var link = this.addParam(window.location.href, "room", room );
        document.getElementById("room").innerHTML = link;
        document.getElementById("room").href = link;
        var qrcode = new QRious({ element: document.getElementById('qrcode'), level: 'H', padding: 25, size: 500, value: link });
        document.getElementById("div_seminar_host").style.visibility = 'visible';
        document.getElementById("div_seminar_room").style.visibility = 'hidden';
        document.getElementById("div_seminar_close").style.visibility = 'hidden';

        this.initRevealMarkdownSlides(this.Reveal);

        /*
        let myTheme = EditorView.theme({
         // "&": {
         //    border: "1px solid #c0c0c0",
         // },
         "&.cm-editor.cm-focused": {
            outline: "none",
         },
        }, {dark: false})

        let edView01 = new EditorView({
         state: EditorState.create({
            doc: this.cardcont_dm_python04_code,
            extensions: [
               EditorState.readOnly.of(true),
               // lineNumbers(),
               EditorView.lineWrapping,
               highlightActiveLine(),
               bracketMatching(),
               syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
               python(),
               sql(),
               myTheme, 
               bbedit, 
            ],
          }),
          parent: document.querySelector("#editor01")
        });
         */

        this.initRevealMenu(this.Reveal);

        this.initTitleFooter("");
        
        if ( !this.isiOs() ) {
	   this.initScreenfull();
	} 

        this.initRevealToolbar(this.Reveal);

        if ( !this.isMobile() ) {
           this.initSpeakerView(this.Reveal);
        }
 
        this.initRevealZoom(this.Reveal);
        RevealZoom.zoom_in();
      
        this.initChalkboard(this.Reveal);

        this.initSeminar(this.Reveal);

        document.querySelector("#host").addEventListener('click', function(e) {
		e.preventDefault();
		RevealSeminar.open_or_join_room(document.getElementById('password').value);
        });
        document.querySelector("#close").addEventListener('click', function(e) {
		e.preventDefault();
		RevealSeminar.close_room(document.getElementById('password').value);
        });

        this.initChart(this.Reveal);	

        this.initPoll(this.Reveal);

        this.initQnA(this.Reveal);

        this.initSearch(this.Reveal);
      }

    }, // end of mounted  

    computed: {

      filtered_chapter_title: function() {
        let that = this;
        return (chapter_counter) => chapter_counter + '. ' + that.chapter_titles.slice(chapter_counter, chapter_counter + 1);
        // return (chapter_counter) => that.chapter_titles.slice(chapter_counter, chapter_counter + 1);
      },

      filtered_chapter_id: function() {
        let that = this;
        return (chapter_counter) => that.chapter_ids.slice(chapter_counter, chapter_counter + 1);
      },

      filtered_section_title: function() {
        let that = this;
         return (chapter_counter, section_counter) => chapter_counter + '.' + section_counter + ' ' +
                that.sections_titles[chapter_counter].slice(section_counter - 1, section_counter);
        // return (chapter_counter, section_counter) => section_counter + '. ' +
               that.sections_titles[chapter_counter].slice(section_counter - 1, section_counter);
      },

      filtered_section_id: function() {
        let that = this;
        return (chapter_counter, section_counter) => 
               that.sections_ids[chapter_counter].slice(section_counter - 1, section_counter);
      },

      filtered_section_title_thanks: function() {
        let that = this;
        return (chapter_counter, section_counter) =>
               that.sections_titles[chapter_counter].slice(section_counter - 1, section_counter);
      },

    }, // end of computed   

    methods: {
       isMobile() {
	   if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	     return true
	   } else {
	     return false
	   }
       },

       /*	
       isMobileExciPad() {
	   if(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	     return true
	   } else {
	     return false
	   }
       },
        */

       isiOs() {
	   if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
	     return true
	   } else {
	     return false
	   }
       },

       copy_code: function(code_text='') {
          try {
             return navigator.clipboard
                .writeText(code_text)
                .then( () => {
                   ElMessage({
                      showClose: true,
                      message: 'copy code succeed',
                      type: 'success',
                      offset: 800,
                   });
                   return Promise.resolve()
                })
                .catch( err => {
                   console.error('copy failed:', err)
                   ElMessage({
                      showClose: true,
                      message: 'copy code failed',
                      type: 'error',
                      offset: 800,
                   });
                   return Promise.reject(err)
                })
          } catch (e) {
             // console.log('copy_code: not support navigator.clipboard.writeText')
             const copy_data = code_text
             let copy_text_area = document.createElement('textarea') 
             copy_text_area.style.position = 'fixed'
             copy_text_area.style.top = '-10000px'
             copy_text_area.style.zIndex = '-999'
             document.body.appendChild(copy_text_area)
             // console.log('copy_text_area', copy_text_area)
             copy_text_area.value = copy_data
             // console.log(copy_text_area.value)
             copy_text_area.focus()
             copy_text_area.select()
             try { 
                let result = document.execCommand('Copy') 
                // copy_text_area.remove()
                document.body.removeChild(copy_text_area)
                if (!result || result === 'unsuccessful') {
                   ElMessage({
                      showClose: true,
                      message: 'copy code failed',
                      type: 'error',
                      offset: 800,
                   });
                   return Promise.reject('copy code failed')
                } else {
                   ElMessage({
                      showClose: true,
                      message: 'copy code succeed',
                      type: 'success',
                      offset: 800,
                   });
                   return Promise.resolve()
                }
             } catch (e) {
                document.body.removeChild(copy_text_area)
                ElMessage({
                   showClose: true,
                   message: 'copy code failed',
                   type: 'error',
                   offset: 800,
                });
                return Promise.reject('this browser does not support document.execCommand Copy')
             }
          }
       },

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*!
	 * The reveal.js markdown plugin. Handles parsing of
	 * markdown inside of presentations as well as loading
	 * of external markdown documents.
	 */

	/**
	 * Starts processing and converting Markdown within the
	 * current reveal.js deck.
	 */
	initRevealMarkdownSlides: function( deck ) {
		let that = this;

		const DEFAULT_SLIDE_SEPARATOR = '\r?\n---\r?\n',
		// const DEFAULT_SLIDE_SEPARATOR = '---',
			  DEFAULT_NOTES_SEPARATOR = 'notes?:',
			  DEFAULT_ELEMENT_ATTRIBUTES_SEPARATOR = '\\\.element\\\s*?(.+?)$',
			  DEFAULT_SLIDE_ATTRIBUTES_SEPARATOR = '\\\.slide:\\\s*?(\\\S.+?)$';

		const SCRIPT_END_PLACEHOLDER = '__SCRIPT_END__';

		const CODE_LINE_NUMBER_REGEX = /\[([\s\d,|-]*)\]/;

		const HTML_ESCAPE_MAP = {
		  '&': '&amp;',
		  '<': '&lt;',
		  '>': '&gt;',
		  '"': '&quot;',
		  "'": '&#39;'
		};

		let { renderer, animateLists, ...markedOptions } = deck.getConfig().markdown || {};

		if( !renderer ) {
			renderer = new marked.Renderer();

			renderer.code = ( code, language ) => {

				// Off by default
				let lineNumbers = '';

				// Users can opt in to show line numbers and highlight
				// specific lines.
				// ```javascript []        show line numbers
				// ```javascript [1,4-8]   highlights lines 1 and 4-8
				if( CODE_LINE_NUMBER_REGEX.test( language ) ) {
					lineNumbers = language.match( CODE_LINE_NUMBER_REGEX )[1].trim();
					lineNumbers = `data-line-numbers="${lineNumbers}"`;
					language = language.replace( CODE_LINE_NUMBER_REGEX, '' ).trim();
				}

				// Escape before this gets injected into the DOM to
				// avoid having the HTML parser alter our code before
				// highlight.js is able to read it
				code = escapeForHTML( code );

				return `<pre><code ${lineNumbers} class="${language}">${code}<\/code><\/pre>`;
			};
		}

		if( animateLists === true ) {
			renderer.listitem = text => `<li class="fragment">${text}<\/li>`;
		}

		marked.setOptions( {
			renderer,
			...markedOptions
		} );

		// return processSlides( deck.getRevealElement() ).then( convertSlides );
		processSlides( deck.getRevealElement() ).then( convertSlides );

		/**
		 * Retrieves the markdown contents of a slide section
		 * element. Normalizes leading tabs/whitespace.
		 */
		function getMarkdownFromSlide ( section ) {
			// look for a <script> or <textarea data-template> wrapper
			var template = section.querySelector( '[data-template]' ) || section.querySelector( 'script' );

			// strip leading whitespace so it isn't evaluated as code
			var text = ( template || section ).textContent;

			// restore script end tags
			text = text.replace( new RegExp( SCRIPT_END_PLACEHOLDER, 'g' ), '<\/script>' );

			var leadingWs = text.match( /^\n?(\s*)/ )[1].length,
				leadingTabs = text.match( /^\n?(\t*)/ )[1].length;

			if( leadingTabs > 0 ) {
				text = text.replace( new RegExp('\\n?\\t{' + leadingTabs + '}(.*)','g'), function(m, p1) { return '\n' + p1 ; } );
			}
			else if( leadingWs > 1 ) {
				text = text.replace( new RegExp('\\n? {' + leadingWs + '}(.*)', 'g'), function(m, p1) { return '\n' + p1 ; } );
			}

			return text;
		}

		/**
		 * Retrieves the markdown contents of a slide section
		 * element. Normalizes leading tabs/whitespace.
		 */
		function getMarkdownFromFile ( section ) {
			/*
			// look for a <script> or <textarea data-template> wrapper
			var template = section.querySelector( '[data-template]' ) || section.querySelector( 'script' );

			// strip leading whitespace so it isn't evaluated as code
			var text = ( template || section ).textContent;
			 */

			var text = section.getAttribute( 'data-markdown' );
			// console.log("getMarkdownFromFile data-markdown text: ", text);

			// restore script end tags
			text = text.replace( new RegExp( SCRIPT_END_PLACEHOLDER, 'g' ), '<\/script>' );

			var leadingWs = text.match( /^\n?(\s*)/ )[1].length,
				leadingTabs = text.match( /^\n?(\t*)/ )[1].length;

			if( leadingTabs > 0 ) {
				text = text.replace( new RegExp('\\n?\\t{' + leadingTabs + '}(.*)','g'), function(m, p1) { return '\n' + p1 ; } );
			}
			else if( leadingWs > 1 ) {
				text = text.replace( new RegExp('\\n? {' + leadingWs + '}(.*)', 'g'), function(m, p1) { return '\n' + p1 ; } );
			}

			return text;
		}

		/**
		 * Given a markdown slide section element, this will
		 * return all arguments that aren't related to markdown
		 * parsing. Used to forward any other user-defined arguments
		 * to the output markdown slide.
		 */
		function getForwardedAttributes ( section ) {
			var attributes = section.attributes;
			var result = [];

			for( var i = 0, len = attributes.length; i < len; i++ ) {
				var name = attributes[i].name,
					value = attributes[i].value;

				// disregard attributes that are used for markdown loading/parsing
				if( /data\-(markdown|separator|vertical|notes)/gi.test( name ) ) continue;

				if( value ) {
					result.push( name + '="' + value + '"' );
				}
				else {
					result.push( name );
				}
			}

			return result.join( ' ' );

		} 

		/**
		 * Inspects the given options and fills out default
		 * values for what's not defined.
		 */
		function getSlidifyOptions ( options ) {
			options = options || {};
			options.separator = options.separator || DEFAULT_SLIDE_SEPARATOR;
			options.notesSeparator = options.notesSeparator || DEFAULT_NOTES_SEPARATOR;
			options.attributes = options.attributes || '';

			return options;

		}

		/**
		 * Helper function for constructing a markdown slide.
		 */
		function createMarkdownSlide ( content, options ) {
			options = getSlidifyOptions( options );

			var notesMatch = content.split( new RegExp( options.notesSeparator, 'mgi' ) );

			if( notesMatch.length === 2 ) {
				content = notesMatch[0] + '<aside class="notes">' + marked(notesMatch[1].trim()) + '<\/aside>';
			}

			// prevent script end tags in the content from interfering
			// with parsing
			content = content.replace( /<\/script>/g, SCRIPT_END_PLACEHOLDER );

			// return '<script type="text\/template">' + content + '<\/script>';
			return '<textarea data-template>' + content + '<\/textarea>';

		}
 
		/**
		 * Parses a data string into multiple slides based
		 * on the passed in separator arguments.
		 */
		function slidify ( markdown, options ) {
			options = getSlidifyOptions( options );

			var separatorRegex = new RegExp( options.separator 
                                             + ( options.verticalSeparator ? '|' + options.verticalSeparator : '' ), 'mg' ),
				horizontalSeparatorRegex = new RegExp( options.separator );

			var matches,
				lastIndex = 0,
				isHorizontal,
				wasHorizontal = true,
				content,
				sectionStack = [];

			// iterate until all blocks between separators are stacked up
			while( matches = separatorRegex.exec( markdown ) ) {
				var notes = null;

				// determine direction (horizontal by default)
				isHorizontal = horizontalSeparatorRegex.test( matches[0] );

				if( !isHorizontal && wasHorizontal ) {
					// create vertical stack
					sectionStack.push( [] );
				}

				// pluck slide content from markdown input
				content = markdown.substring( lastIndex, matches.index );

				if( isHorizontal && wasHorizontal ) {
					// add to horizontal stack
					sectionStack.push( content );
				}
				else {
					// add to vertical stack
					sectionStack[sectionStack.length-1].push( content );
				}

				lastIndex = separatorRegex.lastIndex;
				wasHorizontal = isHorizontal;
			}

			// add the remaining slide
			( wasHorizontal ? sectionStack : sectionStack[sectionStack.length-1] ).push( markdown.substring( lastIndex ) );

			var markdownSections = '';

			// flatten the hierarchical stack, and insert <section data-markdown> tags
			for( var i = 0, len = sectionStack.length; i < len; i++ ) {
				// vertical
				if( sectionStack[i] instanceof Array ) {
					markdownSections += '<section '+ options.attributes +'>';

					sectionStack[i].forEach( function( child ) {
						markdownSections += '<section data-markdown>' + createMarkdownSlide( child, options ) + '<\/section>';
					} );

					markdownSections += '<\/section>';
				}
				else {
					markdownSections += '<section '+ options.attributes +' data-markdown>' 
                                                            + createMarkdownSlide( sectionStack[i], options ) + '<\/section>';
				}
			}

			return markdownSections;

		}

		/**
		 * Parses any current data-markdown slides, splits
		 * multi-slide markdown into separate sections and
		 * handles loading of external markdown.
		 */
		function processSlides ( scope ) {
			return new Promise( function( resolve ) {

				var externalPromises = [];

				[].slice.call( scope.querySelectorAll( 'section[data-markdown]:not([data-markdown-parsed])') ).forEach( 
				  function( section, i ) {

					if( section.getAttribute( 'data-markdown' ).length ) {
							
						/*
						externalPromises.push( loadExternalMarkdown( section ).then(

							// Finished loading external file
							function( xhr, url ) {
								section.outerHTML = slidify( xhr.responseText, {
									separator: section.getAttribute( 'data-separator' ),
									verticalSeparator: section.getAttribute( 'data-separator-vertical' ),
									notesSeparator: section.getAttribute( 'data-separator-notes' ),
									attributes: getForwardedAttributes( section )
								});
							},

							// Failed to load markdown
							function( xhr, url ) {
								section.outerHTML = '<section data-state="alert">' +
									'ERROR: The attempt to fetch ' + url + ' failed with HTTP status ' + 
									xhr.status + '.' +
									'Check your browser\'s JavaScript console for more details.' +
									'<p>Remember that you need to serve the presentation HTML from a ' + 
									'HTTP server.<\/p>' +
									'<\/section>';
							}

						) );
						*/	

						section.outerHTML = slidify( getMarkdownFromFile( section ), {
							separator: section.getAttribute( 'data-separator' ),
							verticalSeparator: section.getAttribute( 'data-separator-vertical' ),
							notesSeparator: section.getAttribute( 'data-separator-notes' ),
							attributes: getForwardedAttributes( section )
						});

					}
					else {

						section.outerHTML = slidify( getMarkdownFromSlide( section ), {
							separator: section.getAttribute( 'data-separator' ),
							verticalSeparator: section.getAttribute( 'data-separator-vertical' ),
							notesSeparator: section.getAttribute( 'data-separator-notes' ),
							attributes: getForwardedAttributes( section )
						});

					}

				});

				Promise.all( externalPromises ).then( resolve );

			} );

		} 

		function loadExternalMarkdown ( section ) {
			return new Promise( function( resolve, reject ) {

				var xhr = new XMLHttpRequest(),
					url = section.getAttribute( 'data-markdown' );

				var datacharset = section.getAttribute( 'data-charset' );

				// see https://developer.mozilla.org/en-US/docs/Web/API/element.getAttribute#Notes
				if( datacharset != null && datacharset != '' ) {
					xhr.overrideMimeType( 'text\/html; charset=' + datacharset );
				}

				xhr.onreadystatechange = function( section, xhr ) {
					if( xhr.readyState === 4 ) {
						// file protocol yields status code 0 (useful for local debug, mobile applications etc.)
						if ( ( xhr.status >= 200 && xhr.status < 300 ) || xhr.status === 0 ) {

							resolve( xhr, url );

						}
						else {

							reject( xhr, url );

						}
					}
				}.bind( this, section, xhr );

				xhr.open( 'GET', url, true );

				try {
					xhr.send();
				}
				catch ( e ) {
					console.warn( 'Failed to get the Markdown file ' + url + 
					   '. Make sure that the presentation and the file are served by ' + 
					   'a HTTP server and the file can be found there. ' + e );
					resolve( xhr, url );
				}

			} );

		}

		/**
		 * Check if a node value has the attributes pattern.
		 * If yes, extract it and add that value as one or several attributes
		 * to the target element.
		 *
		 * You need Cache Killer on Chrome to see the effect on any FOM transformation
		 * directly on refresh (F5)
		 * http://stackoverflow.com/questions/5690269/disabling-chrome-cache-for-website-development/7000899#answer-11786277
		 */
		function addAttributeInElement ( node, elementTarget, separator ) {
			var mardownClassesInElementsRegex = new RegExp( separator, 'mg' );
			var mardownClassRegex = new RegExp( "([^\"= ]+?)=\"([^\"]+?)\"|(data-[^\"= ]+?)(?=[\" ])", 'mg' );
			var nodeValue = node.nodeValue;
			var matches,
				matchesClass;
			if( matches = mardownClassesInElementsRegex.exec( nodeValue ) ) {

				var classes = matches[1];
				nodeValue = nodeValue.substring( 0, matches.index ) + nodeValue.substring( mardownClassesInElementsRegex.lastIndex );
				node.nodeValue = nodeValue;
				while( matchesClass = mardownClassRegex.exec( classes ) ) {
					if( matchesClass[2] ) {
						elementTarget.setAttribute( matchesClass[1], matchesClass[2] );
					} else {
						elementTarget.setAttribute( matchesClass[3], "" );
					}
				}
				return true;
			}
			return false;
		}
 
		/**
		 * Add attributes to the parent element of a text node,
		 * or the element of an attribute node.
		 */
		function addAttributes ( section, element, previousElement, separatorElementAttributes, separatorSectionAttributes ) {
			if ( element != null && element.childNodes != undefined && element.childNodes.length > 0 ) {
				var previousParentElement = element;
				for( var i = 0; i < element.childNodes.length; i++ ) {
					var childElement = element.childNodes[i];
					if ( i > 0 ) {
						var j = i - 1;
						while ( j >= 0 ) {
							var aPreviousChildElement = element.childNodes[j];
							if ( typeof aPreviousChildElement.setAttribute == 'function' && 
							     aPreviousChildElement.tagName != "BR" ) {
								previousParentElement = aPreviousChildElement;
								break;
							}
							j = j - 1;
						}
					}
					var parentSection = section;
					if( childElement.nodeName ==  "section" ) {
						parentSection = childElement ;
						previousParentElement = childElement ;
					}
					if ( typeof childElement.setAttribute == 'function' || childElement.nodeType == Node.COMMENT_NODE ) {
						addAttributes( parentSection, childElement, previousParentElement, 
						               separatorElementAttributes, separatorSectionAttributes );
					}
				}
			}

			if ( element.nodeType == Node.COMMENT_NODE ) {
				if ( addAttributeInElement( element, previousElement, separatorElementAttributes ) == false ) {
					addAttributeInElement( element, section, separatorSectionAttributes );
				}
			}
		}

		/**
		 * Converts any current data-markdown slides in the
		 * DOM to HTML.
		 */
		function convertSlides () {
			var sections = deck.getRevealElement().querySelectorAll( '[data-markdown]:not([data-markdown-parsed])');

			[].slice.call( sections ).forEach( function( section ) {

				section.setAttribute( 'data-markdown-parsed', true )

				var notes = section.querySelector( 'aside.notes' );
				var markdown = getMarkdownFromSlide( section );

				section.innerHTML = marked( markdown );
				addAttributes( 	section, section, null, section.getAttribute( 'data-element-attributes' ) ||
								section.parentNode.getAttribute( 'data-element-attributes' ) ||
								DEFAULT_ELEMENT_ATTRIBUTES_SEPARATOR,
								section.getAttribute( 'data-attributes' ) ||
								section.parentNode.getAttribute( 'data-attributes' ) ||
								DEFAULT_SLIDE_ATTRIBUTES_SEPARATOR);

				// If there were notes, we need to re-add them after
				// having overwritten the section's HTML
				if( notes ) {
					section.appendChild( notes );
				}

			} );

			return Promise.resolve();

		}

		function escapeForHTML ( input ) {

		  return input.replace( /([&<>'"])/g, char => HTML_ESCAPE_MAP[char] );

		}

		window.RevealMarkdown = window.RevealMarkdown || {
			id: 'markdown',

			init: function( deck ) {
			  return initRevealMarkdownSlides( deck );
			},

			processSlides: processSlides,
			convertSlides: convertSlides,
			slidify: slidify,
			marked: marked
		};

		return this;   
	},

	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*
	 * Reveal.js menu plugin
	 * MIT licensed
	 * (c) Greg Denehy 2020
	 */

	initRevealMenu (deck) {
	       let that = this;

	       const ieVersion = (function () {
		    let browser = /(msie) ([\w.]+)/.exec(
		      window.navigator.userAgent.toLowerCase()
		    );
		    if (browser && browser[1] === 'msie') {
		      return parseFloat(browser[2]);
		    }
		    return null;
	       })();

	       // var deck;
	       var config;
	       var options;
	       var initialised = false;

	       /*
		* Extend object a with the properties of object b.
		* If there's a conflict, object b takes precedence.
		*/
	       function extend(a, b) {
		    for (var i in b) {
		      a[i] = b[i];
		    }
	       } 

	       /* 
		* Dispatches an event of the specified type from the
		* reveal DOM element.
		*/
	       function dispatchEvent (type, args) {
		    var event = document.createEvent('HTMLEvents', 1, 2);
		    event.initEvent(type, true, true);
		    extend(event, args);
		    document.querySelector('.reveal').dispatchEvent(event);

		    // If we're in an iframe, post each reveal.js event to the
		    // parent window. Used by the notes plugin
		    if (deck.getConfig().postMessageEvents && window.parent !== window.self) {
		      window.parent.postMessage(
			JSON.stringify({
			  namespace: 'reveal',
			  eventName: type,
			  state: deck.getState()
			}),
			'*'
		      );
		    }
	       }

	       function select(selector, el) {
		  if (!el) {
		     el = document;
		  }
		  return el.querySelector(selector);
	       }

	       function selectAll(selector, el) {
		    if (!el) {
		      el = document;
		    }
		    return Array.prototype.slice.call(el.querySelectorAll(selector));
	       }

	       function create(tagName, attrs, content) {
		  var el = document.createElement(tagName);
		  if (attrs) {
		     Object.getOwnPropertyNames(attrs).forEach(function (n) {
			el.setAttribute(n, attrs[n]);
		     });
		  }
		  if (content) el.innerHTML = content;
		  return el;
	       }

	       function changeStylesheet (id, href) {
		    /*
		    // take note of the previous theme and remove it, then create a new stylesheet reference and insert it
		    // this is required to force a load event so we can change the menu style to match the new style
		    var stylesheet = select('link#' + id);
		    var parent = stylesheet.parentElement;
		    var sibling = stylesheet.nextElementSibling;
		    stylesheet.remove();

		    var newStylesheet = stylesheet.cloneNode();
		    newStylesheet.setAttribute('href', href);
		    newStylesheet.onload = function () {
		      matchRevealStyle();
		    };
		    parent.insertBefore(newStylesheet, sibling);
		     */

		    // console.log("changeStylesheet id, href: ", id, href);
		    g_reveal_theme = href; 
	       }

	       function openPanel(event, ref) {
		    // console.log("openPanel()");
		    openMmenu(event);
		    var panel = ref;
		    if (typeof ref !== 'string') {
		      panel = event.currentTarget.getAttribute('data-panel');
		    }
		    select('.slide-menu-toolbar > li.active-toolbar-button').classList.remove(
		      'active-toolbar-button'
		    );
		    select('li[data-panel="' + panel + '"]').classList.add(
		      'active-toolbar-button'
		    );
		    select('.slide-menu-panel.active-menu-panel').classList.remove(
		      'active-menu-panel'
		    );
		    select('div[data-panel="' + panel + '"]').classList.add(
		      'active-menu-panel'
		    );
	       }

	       function initOptions(config) {
		    options = config.menu || {};
			
		    /*
		    options.path = options.path || scriptPath() || 'plugin/menu/';
		    if (!options.path.endsWith('/')) {
		      options.path += '/';
		    }
		     */

		    // Set defaults
		    if (options.side === undefined) options.side = 'left';

		    if (options.numbers === undefined) options.numbers = false;

		    if (typeof options.titleSelector !== 'string')
		      options.titleSelector = 'h1, h2, h3, h4, h5';

		    if (options.hideMissingTitles === undefined)
		      options.hideMissingTitles = false;

		    if (options.useTextContentForMissingTitles === undefined)
		      options.useTextContentForMissingTitles = false;

		    if (options.markers === undefined) options.markers = true;

		    if (typeof options.themesPath !== 'string')
		      options.themesPath = 'dist/theme/';
		    if (!options.themesPath.endsWith('/')) options.themesPath += '/';

		    // if (!select('link#theme')) options.themes = false;
		    if (options.themes === true) {
		      options.themes = [
			/*
			{ name: 'Black', theme: options.themesPath + 'black.css' },
			{ name: 'White', theme: options.themesPath + 'white.css' },
			{ name: 'League', theme: options.themesPath + 'league.css' },
			{ name: 'Sky', theme: options.themesPath + 'sky.css' },
			{ name: 'Beige', theme: options.themesPath + 'beige.css' },
			{ name: 'Simple', theme: options.themesPath + 'simple.css' },
			{ name: 'Serif', theme: options.themesPath + 'serif.css' },
			{ name: 'Blood', theme: options.themesPath + 'blood.css' },
			{ name: 'Night', theme: options.themesPath + 'night.css' },
			{ name: 'Moon', theme: options.themesPath + 'moon.css' },
			{ name: 'Solarized', theme: options.themesPath + 'solarized.css' }
			 */
			{ name: 'Black', theme: 'black' },
			{ name: 'White', theme: 'white' },
			{ name: 'League', theme: 'league' },
			{ name: 'Sky', theme: 'sky' },
			{ name: 'Beige', theme: 'beige' },
			{ name: 'Simple', theme: 'simple' },
			{ name: 'Serif', theme: 'serif' },
			{ name: 'Blood', theme: 'blood' },
			{ name: 'Night', theme: 'night' },
			{ name: 'Moon', theme: 'moon' },
			{ name: 'Solarized', theme: 'solarized' }
		      ];
		    } else if (!Array.isArray(options.themes)) {
		      options.themes = false;
		    }
		    // console.log("options.themes: ", options.themes);

		    if (options.transitions === undefined) options.transitions = false;
		    if (options.transitions === true) {
		      options.transitions = [
			'None',
			'Fade',
			'Slide',
			'Convex',
			'Concave',
			'Zoom'
		      ];
		    } else if (
		      options.transitions !== false &&
		      (!Array.isArray(options.transitions) ||
			!options.transitions.every(function (e) {
			  return typeof e === 'string';
			}))
		    ) {
		      console.error(
			"reveal.js-menu error: transitions config value must be 'true' or an array of strings, eg ['None', 'Fade', 'Slide')"
		      );
		      options.transitions = false;
		    }
		    if (ieVersion && ieVersion <= 9) {
		      // transitions aren't support in IE9 anyway, so no point in showing them
		      options.transitions = false;
		    }

		    if (typeof options.openButton === 'undefined') options.openButton = true;

		    if (typeof options.openSlideNumber === 'undefined')
		      options.openSlideNumber = false;

		    if (typeof options.keyboard === 'undefined') options.keyboard = true;

		    if (typeof options.sticky === 'undefined') options.sticky = false;

		    if (typeof options.autoOpen === 'undefined') options.autoOpen = true;

		    if (typeof options.delayInit === 'undefined') options.delayInit = false;

		    if (typeof options.openOnInit === 'undefined') options.openOnInit = false;

		    // console.log("options: ", options);
	       }

	       function matchRevealStyle() {
		    var revealStyle = window.getComputedStyle(select('.reveal'));
		    var element = select('.slide-menu');
		    element.style.fontFamily = revealStyle.fontFamily;
		    //XXX could adjust the complete menu style to match the theme, ie colors, etc
	       }

	       function openItem(item, force) {
		    var h = parseInt(item.getAttribute('data-slide-h'));
		    var v = parseInt(item.getAttribute('data-slide-v'));
		    var theme = item.getAttribute('data-theme');
		    var highlightTheme = item.getAttribute('data-highlight-theme');
		    var transition = item.getAttribute('data-transition');

		    if (!isNaN(h) && !isNaN(v)) {
		      deck.slide(h, v);
		    }
		     
		    // console.log("theme: ", theme);
		    if (theme) {
		      changeStylesheet('theme', theme);
		    }

		    if (highlightTheme) {
		      changeStylesheet('highlight-theme', highlightTheme);
		    }

		    if (transition) {
		      deck.configure({ transition: transition });
		    }

		    var link = select('a', item);
		    if (link) {
		      if (
			force ||
			!options.sticky ||
			(options.autoOpen && link.href.startsWith('#')) ||
			link.href.startsWith(
			  window.location.origin + window.location.pathname + '#'
			)
		      ) {
			link.click();
		      }
		    }

		    closeMenu();
	       }

	       function clicked(event) {
		    // console.log("clicked()");
		    if (event.target.nodeName !== 'A') {
		      event.preventDefault();
		    }
		    openItem(event.currentTarget);
	       }

	       function highlightCurrentSlide() {
		    var cur_id = deck.getCurrentSlide().getAttribute('id');
		    // console.log("slide change, current slide id: ", cur_id);
		    if (cur_id != null) {
		       that.g_slide_id = cur_id;	
		    }
		    // console.log("slide change, g_slide_id: ", that.g_slide_id);
	  
		    var state = deck.getState();
		    selectAll('li.slide-menu-item, li.slide-menu-item-vertical').forEach(
		      function (item) {
			item.classList.remove('past');
			item.classList.remove('active');
			item.classList.remove('future');

			var h = parseInt(item.getAttribute('data-slide-h'));
			var v = parseInt(item.getAttribute('data-slide-v'));
			if (h < state.indexh || (h === state.indexh && v < state.indexv)) {
			  item.classList.add('past');
			} else if (h === state.indexh && v === state.indexv) {
			  item.classList.add('active');
			} else {
			  item.classList.add('future');
			}
		      }
		    );

		    if (isOpen()) {
		       closeMenu();
		       openMenu();	
		    }		
	       }

  	       var mouseSelectionEnabled = true;
	       function disableMouseSelection () {
		    mouseSelectionEnabled = false;
	       } 

	       function reenableMouseSelection() {
		    // wait until the mouse has moved before re-enabling mouse selection
		    // to avoid selections on scroll
		    select('nav.slide-menu').addEventListener('mousemove', function fn(e) {
		      select('nav.slide-menu').removeEventListener('mousemove', fn);
		      //XXX this should select the item under the mouse
		      mouseSelectionEnabled = true;
		    });
	       }

	       // Keyboard handling
	       //
	       function getOffset (el) {
		    var _x = 0;
		    var _y = 0;
		    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
		      _x += el.offsetLeft - el.scrollLeft;
		      _y += el.offsetTop - el.scrollTop;
		      el = el.offsetParent;
		    }
		    return { top: _y, left: _x };
	       }

	       function visibleOffset (el) {
		    var offsetFromTop = getOffset(el).top - el.offsetParent.offsetTop;
		    if (offsetFromTop < 0) return -offsetFromTop;
		    var offsetFromBottom =
		      el.offsetParent.offsetHeight -
		      (el.offsetTop - el.offsetParent.scrollTop + el.offsetHeight);
		    if (offsetFromBottom < 0) return offsetFromBottom;
		    return 0;
	       }

	       function keepVisible(el) {
		    var offset = visibleOffset(el);
		    if (offset) {
		      disableMouseSelection();
		      el.scrollIntoView(offset > 0);
		      reenableMouseSelection();
		    }
	       }

	       function scrollItemToTop (el) {
		    disableMouseSelection();
		    el.offsetParent.scrollTop = el.offsetTop;
		    reenableMouseSelection();
	       }

	       function scrollItemToBottom (el) {
		    disableMouseSelection();
		    el.offsetParent.scrollTop =
		      el.offsetTop - el.offsetParent.offsetHeight + el.offsetHeight;
		    reenableMouseSelection();
	       } 

	       function selectItem (el) {
		    el.classList.add('selected');
		    keepVisible(el);
		    if (options.sticky && options.autoOpen) openItem(el);
	       }

	       function onDocumentKeyDown (event) {
		    // opening menu is handled by registering key binding with Reveal below
		    if (isOpen()) {
		      event.stopImmediatePropagation();
		      switch (event.keyCode) {
			// case 77:
			// 	closeMenu();
			// 	break;
			// h, left - change panel
			case 72:
			case 37:
			  prevPanel();
			  break;
			// l, right - change panel
			case 76:
			case 39:
			  nextPanel();
			  break;
			// k, up
			case 75:
			case 38:
			  var currItem =
			    select('.active-menu-panel .slide-menu-items li.selected') ||
			    select('.active-menu-panel .slide-menu-items li.active');
			  if (currItem) {
			    selectAll('.active-menu-panel .slide-menu-items li').forEach(
			      function (item) {
				item.classList.remove('selected');
			      }
			    );
			    var nextItem =
			      select(
				'.active-menu-panel .slide-menu-items li[data-item="' +
				  (parseInt(currItem.getAttribute('data-item')) - 1) +
				  '"]'
			      ) || currItem;
			    selectItem(nextItem);
			  } else {
			    var item = select(
			      '.active-menu-panel .slide-menu-items li.slide-menu-item'
			    );
			    if (item) selectItem(item);
			  }
			  break;
			// j, down
			case 74:
			case 40:
			  var currItem =
			    select('.active-menu-panel .slide-menu-items li.selected') ||
			    select('.active-menu-panel .slide-menu-items li.active');
			  if (currItem) {
			    selectAll('.active-menu-panel .slide-menu-items li').forEach(
			      function (item) {
				item.classList.remove('selected');
			      }
			    );
			    var nextItem =
			      select(
				'.active-menu-panel .slide-menu-items li[data-item="' +
				  (parseInt(currItem.getAttribute('data-item')) + 1) +
				  '"]'
			      ) || currItem;
			    selectItem(nextItem);
			  } else {
			    var item = select(
			      '.active-menu-panel .slide-menu-items li.slide-menu-item'
			    );
			    if (item) selectItem(item);
			  }
			  break;
			// pageup, u
			case 33:
			case 85:
			  var itemsAbove = selectAll(
			    '.active-menu-panel .slide-menu-items li'
			  ).filter(function (item) {
			    return visibleOffset(item) > 0;
			  });
			  var visibleItems = selectAll(
			    '.active-menu-panel .slide-menu-items li'
			  ).filter(function (item) {
			    return visibleOffset(item) == 0;
			  });

			  var firstVisible =
			    itemsAbove.length > 0 &&
			    Math.abs(visibleOffset(itemsAbove[itemsAbove.length - 1])) <
			      itemsAbove[itemsAbove.length - 1].clientHeight
			      ? itemsAbove[itemsAbove.length - 1]
			      : visibleItems[0];
			  if (firstVisible) {
			    if (
			      firstVisible.classList.contains('selected') &&
			      itemsAbove.length > 0
			    ) {
			      // at top of viewport already, page scroll (if not at start)
			      // ...move selected item to bottom, and change selection to last fully visible item at top
			      scrollItemToBottom(firstVisible);
			      visibleItems = selectAll(
				'.active-menu-panel .slide-menu-items li'
			      ).filter(function (item) {
				return visibleOffset(item) == 0;
			      });
			      if (visibleItems[0] == firstVisible) {
				// prev item is still beyond the viewport (for custom panels)
				firstVisible = itemsAbove[itemsAbove.length - 1];
			      } else {
				firstVisible = visibleItems[0];
			      }
			    }
			    selectAll('.active-menu-panel .slide-menu-items li').forEach(
			      function (item) {
				item.classList.remove('selected');
			      }
			    );
			    selectItem(firstVisible);
			    // ensure selected item is positioned at the top of the viewport
			    scrollItemToTop(firstVisible);
			  }
			  break;
			// pagedown, d
			case 34:
			case 68:
			  var visibleItems = selectAll(
			    '.active-menu-panel .slide-menu-items li'
			  ).filter(function (item) {
			    return visibleOffset(item) == 0;
			  });
			  var itemsBelow = selectAll(
			    '.active-menu-panel .slide-menu-items li'
			  ).filter(function (item) {
			    return visibleOffset(item) < 0;
			  });

			  var lastVisible =
			    itemsBelow.length > 0 &&
			    Math.abs(visibleOffset(itemsBelow[0])) < itemsBelow[0].clientHeight
			      ? itemsBelow[0]
			      : visibleItems[visibleItems.length - 1];
			  if (lastVisible) {
			    if (
			      lastVisible.classList.contains('selected') &&
			      itemsBelow.length > 0
			    ) {
			      // at bottom of viewport already, page scroll (if not at end)
			      // ...move selected item to top, and change selection to last fully visible item at bottom
			      scrollItemToTop(lastVisible);
			      visibleItems = selectAll(
				'.active-menu-panel .slide-menu-items li'
			      ).filter(function (item) {
				return visibleOffset(item) == 0;
			      });
			      if (visibleItems[visibleItems.length - 1] == lastVisible) {
				// next item is still beyond the viewport (for custom panels)
				lastVisible = itemsBelow[0];
			      } else {
				lastVisible = visibleItems[visibleItems.length - 1];
			      }
			    }
			    selectAll('.active-menu-panel .slide-menu-items li').forEach(
			      function (item) {
				item.classList.remove('selected');
			      }
			    );
			    selectItem(lastVisible);
			    // ensure selected item is positioned at the bottom of the viewport
			    scrollItemToBottom(lastVisible);
			  }
			  break;
			// home
			case 36:
			  selectAll('.active-menu-panel .slide-menu-items li').forEach(
			    function (item) {
			      item.classList.remove('selected');
			    }
			  );
			  var item = select(
			    '.active-menu-panel .slide-menu-items li:first-of-type'
			  );
			  if (item) {
			    item.classList.add('selected');
			    keepVisible(item);
			  }
			  break;
			// end
			case 35:
			  selectAll('.active-menu-panel .slide-menu-items li').forEach(
			    function (item) {
			      item.classList.remove('selected');
			    }
			  );
			  var item = select(
			    '.active-menu-panel .slide-menu-items:last-of-type li:last-of-type'
			  );
			  if (item) {
			    item.classList.add('selected');
			    keepVisible(item);
			  }
			  break;
			// space, return
			case 32:
			case 13:
			  var currItem = select(
			    '.active-menu-panel .slide-menu-items li.selected'
			  );
			  if (currItem) {
			    openItem(currItem, true);
			  }
			  break;
			// esc
			case 27:
			  closeMenu(null, true);
			  break;
		      }
		    }
	       }

	       function openMenu(event) {
		    // console.log("options: ", options);

		    if (event) event.preventDefault();
		    if (!isOpen()) {
		      select('body').classList.add('slide-menu-active');
		      select('.reveal').classList.add(
			'has-' + options.effect + '-' + options.side
		      );
		      select('.slide-menu').classList.add('active');
		      select('.slide-menu-overlay').classList.add('active');

		      // identify active theme
		      if (options.themes) {
			selectAll('div[data-panel="Themes"] li').forEach(function (i) {
			  // console.log("i.classList: ", i.classList);
			  i.classList.remove('active');
			});
			selectAll(
			  // 'li[data-theme="' + select('link#theme').getAttribute('href') + '"]'
			  // 'li[data-theme="dist/theme/white.css"]'
			  'li[data-theme="white"]'
			).forEach(function (i) {
			  i.classList.add('active');
			});
		      }

		      // identify active transition
		      if (options.transitions) {
			selectAll('div[data-panel="Transitions"] li').forEach(function (i) {
			  i.classList.remove('active');
			});
			// selectAll('li[data-transition="' + config.transition + '"]').forEach(
			selectAll('li[data-transition="' + deck.getConfig().transition + '"]').forEach(
			  function (i) {
			    i.classList.add('active');
			  }
			);
		      }
		      
		      if (options.custom) {
			 // var state = deck.getState();
			 // if (state.indexh != undefined) {
			    var slide_id;	
			    selectAll('div[data-panel="Custom0"] li').forEach(function (i) {
			       slide_id = i.firstChild.getAttribute('href').slice(2);
			       // console.log("custom panel list link a.href id: ", slide_id);
			       if (slide_id === that.g_slide_id) {
				  i.classList.add('active');
			       } else {
				  i.classList.remove('active');
			       } 
			    });
			 // }
		      }

		      // set item selections to match active items
		      var items = selectAll('.slide-menu-panel li.active');
		      items.forEach(function (i) {
			i.classList.add('selected');
			keepVisible(i);
		      });
		    }
	       }
 
	       function closeMenu (event, force) {
		    // console.log("options: ", options);

		    if (event) event.preventDefault();
		    if (!options.sticky || force) {
		      select('body').classList.remove('slide-menu-active');
		      select('.reveal').classList.remove(
			'has-' + options.effect + '-' + options.side
		      );
		      select('.slide-menu').classList.remove('active');
		      select('.slide-menu-overlay').classList.remove('active');
		      selectAll('.slide-menu-panel li.selected').forEach(function (i) {
			i.classList.remove('selected');
		      });
		    }
	       }

	       function toggleMenu (event) {
		    let menu_opened = isOpen();
		    // console.log("toggle menu menu_opened: ", menu_opened);
		    if (menu_opened) {
		      closeMenu(event, true);
		    } else {
		      openMenu(event);
		    }
	       }

	       function isOpen () {
		  // console.log("isOpen() select('body').classList.contains('slide-menu-active')", 
                  //             select('body').classList.contains('slide-menu-active'));
		  return select('body').classList.contains('slide-menu-active');
	       }

	       function openPanel (event, ref) {
		    // console.log("openPanel(), ref: ", ref); 
		    openMenu(event);
		    var panel = ref;
		    if (typeof ref !== 'string') {
		      panel = event.currentTarget.getAttribute('data-panel');
		    }
		    // console.log("openPanel(), panel: ", panel); 
		     
		    if (select('.slide-menu-toolbar > li.active-toolbar-button') != null ) {
		       select('.slide-menu-toolbar > li.active-toolbar-button').classList.remove(
			  'active-toolbar-button'
		       );
		    }

		    select('li[data-panel="' + panel + '"]').classList.add(
		      'active-toolbar-button'
		    );

		    if (select('.slide-menu-panel.active-menu-panel') != null) { 
			    select('.slide-menu-panel.active-menu-panel').classList.remove(
			      'active-menu-panel'
			    );
		    }
		    if ( select('div[data-panel="' + panel + '"]') != null ) {
			    select('div[data-panel="' + panel + '"]').classList.add(
			      'active-menu-panel'
			    );
		    }
	       }

	       function nextPanel () {
		    var next =
		      (parseInt(select('.active-toolbar-button').getAttribute('data-button')) +
			1) %
		      buttons;
		    openPanel(
		      null,
		      select('.toolbar-panel-button[data-button="' + next + '"]').getAttribute(
			'data-panel'
		      )
		    );
	       }

	       function prevPanel() {
		    var next =
		      parseInt(select('.active-toolbar-button').getAttribute('data-button')) -
		      1;
		    if (next < 0) {
		      next = buttons - 1;
		    }
		    openPanel(
		      null,
		      select('.toolbar-panel-button[data-button="' + next + '"]').getAttribute(
			'data-panel'
		      )
		    );
	       }

	       var buttons = 0;
	       function initMenu() {
		   if (!initialised) {
		      var parent = select('.reveal').parentElement;
		      var top = create('div', { class: 'slide-menu-wrapper' });
		      parent.appendChild(top);
		      // console.log("initMenu top:", top);
		      var panels = create('nav', {
			class: 'slide-menu slide-menu--' + options.side
		      });
		      if (typeof options.width === 'string') {
			if (
			  ['normal', 'wide', 'third', 'half', 'full'].indexOf(options.width) !=
			  -1
			) {
			  panels.classList.add('slide-menu--' + options.width);
			} else {
			  panels.classList.add('slide-menu--custom');
			  panels.style.width = options.width;
			}
		      }
		      top.appendChild(panels);
		      // console.log("initMenu top panels:", panels);
		      matchRevealStyle();
		      var overlay = create('div', { class: 'slide-menu-overlay' });
		      top.appendChild(overlay);
		      // console.log("initMenu top overlay:", overlay);
		      overlay.onclick = function () {
			closeMenu(null, true);
		      };

		      var toolbar = create('ol', { class: 'slide-menu-toolbar' });
		      select('.slide-menu').appendChild(toolbar);

		      function addToolbarButton(title, ref, icon, style, fn, active) {
			var attrs = {
			  'data-button': '' + buttons++,
			  class:
			    'toolbar-panel-button' + (active ? ' active-toolbar-button' : '')
			};
			if (ref) {
			  attrs['data-panel'] = ref;
			}
			var button = create('li', attrs);

			if (icon.startsWith('fa-')) {
			  button.appendChild(create('i', { class: style + ' ' + icon }));
			} else {
			  button.innerHTML = icon + '</i>';
			}
			button.appendChild(create('br'), select('i', button));
			button.appendChild(
			  create('span', { class: 'slide-menu-toolbar-label' }, title),
			  select('i', button)
			);
			button.onclick = fn;
			toolbar.appendChild(button);
			// console.log("addToolbarButton button: ", button);
			return button;
		      }

		      // addToolbarButton('Slides', 'Slides', 'fa-images', 'fas', openPanel, true);

		      if (options.custom) {
			options.custom.forEach(function (element, index, array) {
			  addToolbarButton(
			    element.title,
			    'Custom' + index,
			    element.icon,
			    null,
			    openPanel
			  );
			});
		      }

		      if (options.themes) {
			addToolbarButton('Themes', 'Themes', 'fa-adjust', 'fas', openPanel);
		      }
		      if (options.transitions) {
			addToolbarButton(
			  'Transitions',
			  'Transitions',
			  'fa-sticky-note',
			  'fas',
			  openPanel
			);
		      }
		      var button = create('li', {
			id: 'close',
			class: 'toolbar-panel-button'
		      });
		      button.appendChild(create('i', { class: 'fas fa-times' }));
		      button.appendChild(create('br'));
		      button.appendChild(
			create('span', { class: 'slide-menu-toolbar-label' }, 'Close')
		      );
		      button.onclick = function () {
			closeMenu(null, true);
		      };
		      toolbar.appendChild(button);

		      //
		      // Slide links
		      //
		      function generateItem(type, section, i, h, v) {
			var link = '/#/' + h;
			if (typeof v === 'number' && !isNaN(v)) link += '/' + v;

			function text(selector, parent) {
			  if (selector === '') return null;
			  var el = parent ? select(selector, section) : select(selector);
			  if (el) return el.textContent;
			  return null;
			}
			var title =
			  section.getAttribute('data-menu-title') ||
			  text('.menu-title', section) ||
			  text(options.titleSelector, section);

			if (!title && options.useTextContentForMissingTitles) {
			  // attempt to figure out a title based on the text in the slide
			  title = section.textContent.trim();
			  if (title) {
			    title =
			      title
				.split('\n')
				.map(function (t) {
				  return t.trim();
				})
				.join(' ')
				.trim()
				.replace(/^(.{16}[^\s]*).*/, '$1') 
                                // limit to 16 chars plus any consecutive non-whitespace chars (to avoid breaking words)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#039;') + '...';
			  }
			}

			if (!title) {
			  if (options.hideMissingTitles) return '';
			  type += ' no-title';
			  title = 'Slide ' + (i + 1);
			}

			var item = create('li', {
			  class: type,
			  'data-item': i,
			  'data-slide-h': h,
			  'data-slide-v': v === undefined ? 0 : v
			});

			if (options.markers) {
			  item.appendChild(
			    create('i', { class: 'fas fa-check-circle fa-fw past' })
			  );
			  item.appendChild(
			    create('i', {
			      class: 'fas fa-arrow-alt-circle-right fa-fw active'
			    })
			  );
			  item.appendChild(
			    create('i', { class: 'far fa-circle fa-fw future' })
			  );
			}

			if (options.numbers) {
			  // Number formatting taken from reveal.js
			  var value = [];
			  var format = 'h.v';

			  // Check if a custom number format is available
			  if (typeof options.numbers === 'string') {
			    format = options.numbers;
			  } else if (typeof config.slideNumber === 'string') {
			    // Take user defined number format for slides
			    format = config.slideNumber;
			  }

			  switch (format) {
			    case 'c':
			      value.push(i + 1);
			      break;
			    case 'c/t':
			      value.push(i + 1, '/', deck.getTotalSlides());
			      break;
			    case 'h/v':
			      value.push(h + 1);
			      if (typeof v === 'number' && !isNaN(v)) value.push('/', v + 1);
			      break;
			    default:
			      value.push(h + 1);
			      if (typeof v === 'number' && !isNaN(v)) value.push('.', v + 1);
			  }

			  item.appendChild(
			    create(
			      'span',
			      { class: 'slide-menu-item-number' },
			      value.join('') + '. '
			    )
			  );
			}

			item.appendChild(
			  create('span', { class: 'slide-menu-item-title' }, title)
			);

			return item;
		      }

		      function createSlideMenu() {
			if (
			  !document.querySelector(
			    'section[data-markdown]:not([data-markdown-parsed])'
			  )
			) {
			  var panel = create('div', {
			    'data-panel': 'Slides',
			    class: 'slide-menu-panel active-menu-panel'
			  });
			  panel.appendChild(create('ul', { class: 'slide-menu-items' }));
			  panels.appendChild(panel);
			  var items = select(
			    '.slide-menu-panel[data-panel="Slides"] > .slide-menu-items'
			  );
			  var slideCount = 0;
			  selectAll('.slides > section').forEach(function (section, h) {
			    var subsections = selectAll('section', section);
			    if (subsections.length > 0) {
			      subsections.forEach(function (subsection, v) {
				var type =
				  v === 0 ? 'slide-menu-item' : 'slide-menu-item-vertical';
				var item = generateItem(type, subsection, slideCount, h, v);
				if (item) {
				  // console.log("item: ", item);
				  items.appendChild(item);
				}
				slideCount++;
			      });
			    } else {
			      var item = generateItem(
				'slide-menu-item',
				section,
				slideCount,
				h
			      );
			      if (item) {
				// console.log("item: ", item);
				items.appendChild(item);
			      }
			      slideCount++;
			    }
			  });
			  selectAll('.slide-menu-item, .slide-menu-item-vertical').forEach(
			    function (i) {
			      i.onclick = clicked;
			    }
			  );
			  highlightCurrentSlide();
			} else {
			  // wait for markdown to be loaded and parsed
			  setTimeout(createSlideMenu, 100);
			}
		      }

		      //////////////////////////////////////////////////////////////////////////
		      //  if the slides panel is enabled, uncomment the following two lines
		      // createSlideMenu();
		      deck.addEventListener('slidechanged', highlightCurrentSlide);

		      //
		      // Custom menu panels
		      //
		      if (options.custom) {
			function xhrSuccess() {
			  if (this.status >= 200 && this.status < 300) {
			    this.panel.innerHTML = this.responseText;
			    enableCustomLinks(this.panel);
			  } else {
			    showErrorMsg(this);
			  }
			}
			function xhrError() {
			  showErrorMsg(this);
			}
			function loadCustomPanelContent(panel, sURL) {
			  var oReq = new XMLHttpRequest();
			  oReq.panel = panel;
			  oReq.arguments = Array.prototype.slice.call(arguments, 2);
			  oReq.onload = xhrSuccess;
			  oReq.onerror = xhrError;
			  oReq.open('get', sURL, true);
			  oReq.send(null);
			}
			function enableCustomLinks(panel) {
			  selectAll('ul.slide-menu-items li.slide-menu-item', panel).forEach(
			    function (item, i) {
			      item.setAttribute('data-item', i + 1);
			      item.onclick = clicked;
			      item.addEventListener('mouseenter', handleMouseHighlight);

			      item.classList.remove('past');
			      item.classList.remove('active');
			      item.classList.remove('future');
			
			      /*
			      // console.log("enableCustomLinks() item: ", item);	
			      // console.log("current slide Indices: ", deck.getIndices(slide=currentSlide));

			      if (h < state.indexh || (h === state.indexh && v < state.indexv)) {
				 item.classList.add('past');
			      } else if (h === state.indexh && v === state.indexv) {
				item.classList.add('active');
			      } else {
				 item.classList.add('future');
			      }
			      */
			    }
			  );

			}

			function showErrorMsg(response) {
			  var msg =
			    '<p>ERROR: The attempt to fetch ' +
			    response.responseURL +
			    ' failed with HTTP status ' +
			    response.status +
			    ' (' +
			    response.statusText +
			    ').</p>' +
			    '<p>Remember that you need to serve the presentation HTML from a HTTP server.</p>';
			  response.panel.innerHTML = msg;
			}

			options.custom.forEach(function (element, index, array) {
			  var panel = create('div', {
			    'data-panel': 'Custom' + index,
			    class: 'slide-menu-panel slide-menu-custom-panel'
			  });
			  if (element.content) {
			    panel.innerHTML = element.content;
			    enableCustomLinks(panel);
			  } else if (element.src) {
			    // loadCustomPanelContent(panel, element.src);
			    panel.innerHTML = that.links_html;
			    enableCustomLinks(panel);
			  }
			  panels.appendChild(panel);
			});

			//////////////////////////////////////////////////////////////////////////
			//  if the slides panel is enabled, comment the following three lines
			let click_custom_event = new Event('click');
			select('li[data-panel="Custom0"]').dispatchEvent(click_custom_event);
			closeMenu();

		      } // end of if (options.custom) 

		      //
		      // Themes
		      //
		      if (options.themes) {
			var panel = create('div', {
			  class: 'slide-menu-panel',
			  'data-panel': 'Themes'
			});
			panels.appendChild(panel);
			var menu = create('ul', { class: 'slide-menu-items' });
			panel.appendChild(menu);
			options.themes.forEach(function (t, i) {
			  var attrs = {
			    class: 'slide-menu-item',
			    'data-item': '' + (i + 1)
			  };
			  if (t.theme) {
			    attrs['data-theme'] = t.theme;
			  }
			  if (t.highlightTheme) {
			    attrs['data-highlight-theme'] = t.highlightTheme;
			  }
			  var item = create('li', attrs, t.name);
			  menu.appendChild(item);
			  // console.log("menu theme list item: ", item);
			  item.onclick = clicked;
			});
		      }

		      //
		      // Transitions
		      //
		      if (options.transitions) {
			var panel = create('div', {
			  class: 'slide-menu-panel',
			  'data-panel': 'Transitions'
			});
			panels.appendChild(panel);
			var menu = create('ul', { class: 'slide-menu-items' });
			panel.appendChild(menu);
			options.transitions.forEach(function (name, i) {
			  var item = create(
			    'li',
			    {
			      class: 'slide-menu-item',
			      'data-transition': name.toLowerCase(),
			      'data-item': '' + (i + 1)
			    },
			    name
			  );
			  menu.appendChild(item);
			  item.onclick = clicked;
			});
		      }

		      //
		      // Open menu options
		      //
		      if (options.openButton) {
			// add menu button
			var div = create('div', { class: 'slide-menu-button' });
			var link = create('a', { href: '#' });
			link.appendChild(create('i', { class: 'fas fa-bars' }));
			div.appendChild(link);
			select('.reveal').appendChild(div);
			// div.onclick = openMenu;
			div.onclick = toggleMenu;
		      }

		      if (options.openSlideNumber) {
			var slideNumber = select('div.slide-number');
			if (slideNumber != null) {
			   slideNumber.onclick = openMenu;
			}
		      }

		      //
		      // Handle mouse overs
		      //
		      selectAll('.slide-menu-panel .slide-menu-items li').forEach(function (
			item
		      ) {
			item.addEventListener('mouseenter', handleMouseHighlight);
		      });

		      function handleMouseHighlight(event) {
			if (mouseSelectionEnabled) {
			  selectAll('.active-menu-panel .slide-menu-items li.selected').forEach(
			    function (i) {
			      i.classList.remove('selected');
			    }
			  );
			  event.currentTarget.classList.add('selected');
			}
		      }
		    }

		    if (options.keyboard) {
		      //XXX add keyboard option for custom key codes, etc.

		      document.addEventListener('keydown', onDocumentKeyDown, false);

		      // handle key presses within speaker notes
		      window.addEventListener('message', function (event) {
			var data;
			try {
			  data = JSON.parse(event.data);
			} catch (e) {}
			if (data && data.method === 'triggerKey') {
			  onDocumentKeyDown({
			    keyCode: data.args[0],
			    stopImmediatePropagation: function () {}
			  });
			}
		      });

		      /*  
		      // Prevent reveal from processing keyboard events when the menu is open
		      if (
			config.keyboardCondition &&
			typeof config.keyboardCondition === 'function'
		      ) {
			// combine user defined keyboard condition with the menu's own condition
			var userCondition = config.keyboardCondition;
			config.keyboardCondition = function (event) {
			  return userCondition(event) && (!isOpen() || event.keyCode == 77);
			};
		      } else {
			config.keyboardCondition = function (event) {
			  return !isOpen() || event.keyCode == 77;
			};
		      }
		       */

		      deck.addKeyBinding(
			{ keyCode: 77, key: 'M', description: 'Toggle menu' },
			toggleMenu
		      );
		    }

		    if (options.openOnInit) {
		      openMenu();
		    }

		    initialised = true;
		}

		function loadPlugin() {
		    // does not support IE8 or below
		    var supported = !ieVersion || ieVersion >= 9;

		    // do not load the menu in the upcoming slide panel in the speaker notes
		    if (
		      deck.isSpeakerNotes() &&
		      window.location.search.endsWith('controls=false')
		    ) {
		      supported = false;
		    }

		    if (supported) {
		      if (!options.delayInit) initMenu();
		      dispatchEvent('menu-ready');
		    }
		}

		config = deck.getConfig();
		initOptions(config);
		loadPlugin();

		window.RevealMenu = window.RevealMenu || {
		// return {
		    id: 'menu',

		    /*	
		    init: reveal => {
		      deck = reveal;
		      config = deck.getConfig();
		      initOptions(config);
		      loadResource(options.path + 'menu.css', 'stylesheet', function () {
			if (options.loadIcons === undefined || options.loadIcons) {
			  loadResource(
			    options.path + 'font-awesome/css/all.css',
			    'stylesheet',
			    loadPlugin
			  );
			} else {
			  loadPlugin();
			}
		      });
		    },
		     */

		    toggle: toggleMenu,
		    openMenu: openMenu,
		    closeMenu: closeMenu,
		    openPanel: openPanel,
		    isOpen: isOpen,
		    initialiseMenu: initMenu,
		    isMenuInitialised: function () {
		      return initialised;
		    }
		};

		return this;
	},

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

       /*********************************************************
	*                                                       *
	* Javascript for the Title-Footer plugin for Reveal.js  *
	*                                                       *
	* Author: Igor Leturia                                  *
	*                                                       *
	* License: GPL v3                                       *
	* http://www.gnu.org/copyleft/gpl.html        		*
	*                                                       *
	********************************************************/

       initTitleFooter: function(title, background)
       {
               let that = this;

	       function getElementsByTagNames(list, obj)
	       {
		 if (!obj)
		 {
		    var obj=document;
		 };
		 var tagNames=list.split(',');
		 var resultArray=new Array();
		 for (var i=0;i<tagNames.length;i++)
		 { 
			var tags=obj.getElementsByTagName(tagNames[i]);
			for (var j=0;j<tags.length;j++)
			{
				resultArray.push(tags[j]);
			};
		 };
		 var testNode=resultArray[0];
		 if (!testNode)
		 {
			return [];
		 };
		 if (testNode.sourceIndex)
		 {
			resultArray.sort(
				function (a,b)
				{
					return a.sourceIndex-b.sourceIndex;
				}
			);
		 }
		 else if (testNode.compareDocumentPosition)
		 {
			resultArray.sort(
				function (a,b)
				{
					return 3-(a.compareDocumentPosition(b)&6);
				}
			);
		 };
		 return resultArray;
	      }

	// Link to the Title-Footer CSS
        /*        
	var link=document.createElement("link");
	link.href="plugin/title-footer/title-footer.css";
	link.type="text/css";
	link.rel="stylesheet";
	document.getElementsByTagName("head")[0].appendChild(link);
         */

	// Initialize properties according to parameters

	this.background=background || 'rgba(0,0,0,0.1)';
	var title=title || '';
	if (title!='')
	{
		// this.title=title;
	}
	else
	{
		var first_section=document.getElementsByTagName('section')[0];
		if (first_section.getElementsByTagName('section').length>0)
		{
			first_section=first_section.getElementsByTagName('section')[0];
		};
		var title_elements = getElementsByTagNames('h1,h2,h3',first_section);
		if (title_elements.length>0)
		{
			// this.title=title_elements[0].textContent;
			for (var title_elements_index=1;title_elements_index<title_elements.length;title_elements_index++)
			{
				// this.title=this.title+' - '+title_elements[title_elements_index].textContent;
			};
		};
	};

	var div_class_reveal=document.querySelectorAll('.reveal')[0];

        /*	
	// Create the Title-Footer footer
	var title_footer=document.createElement('footer');
	title_footer.setAttribute('id','title-footer');
	title_footer.setAttribute('style','background:'+this.background);
	var title_footer_p=document.createElement('p');
	title_footer.appendChild(title_footer_p);
	var a_element=document.createElement('a');
	a_element.setAttribute('href','#/0');
	a_element.appendChild(document.createTextNode(this.title));
	title_footer_p.appendChild(a_element);
	div_class_reveal.appendChild(title_footer);
         */

        // Create the title header
	var title_header=document.createElement('header');
	title_header.setAttribute('id','title-header');
	title_header.setAttribute('style','background:'+this.background);

        /*
	var title_header_p=document.createElement('p');
	title_header.appendChild(title_header_p);

	var a_element_header=document.createElement('a');
	a_element_header.setAttribute('href','#/0');
	a_element_header.appendChild(document.createTextNode(this.title));
	title_header_p.appendChild(a_element_header);
         */

	var title_header_date = document.createElement('div');
	title_header_date.setAttribute('class','date-header');
	var a_element_date = document.createElement('a');
	a_element_date.setAttribute('href','#');
	a_element_date.appendChild(document.createTextNode(new Date().toISOString().split('T')[0]));
	title_header_date.appendChild(a_element_date);
	// title_header_date.appendChild(document.createTextNode('2023.6.23'));
	// title_header_date.appendChild(document.createTextNode(new Date().toISOString().split('T')[0]));
	title_header.appendChild(title_header_date);

	var title_header_ins = document.createElement('div');
	title_header_ins.setAttribute('class','institute-header');
	var a_element_ins = document.createElement('a');
	a_element_ins.setAttribute('href','#');
	a_element_ins.appendChild(document.createTextNode('SCSE, 武汉大学'));
	title_header_ins.appendChild(a_element_ins);
	title_header.appendChild(title_header_ins);

	var title_header_topic = document.createElement('div');
	title_header_topic.setAttribute('class','topic-header');
	var a_element_topic = document.createElement('a');
	a_element_topic.setAttribute('href','#');
	a_element_topic.appendChild(document.createTextNode('数据库系统'));
	title_header_topic.appendChild(a_element_topic);
	title_header.appendChild(title_header_topic);
	
	div_class_reveal.appendChild(title_header);
        // console.log("title_header: ", title_header);

        var title_header_div_logo = document.createElement('div');
	title_header_div_logo.setAttribute('class', "logo-div");
	// title_header.appendChild(title_header_div_logo);
	var a_element_logo = document.createElement('a');
	a_element_logo.setAttribute('href','https://www.whu.edu.cn');
	a_element_logo.setAttribute('target','_blank');
        var img_element_header = document.createElement('img');
	img_element_header.setAttribute('src', that.whu_logo);
	a_element_logo.appendChild(img_element_header);
        title_header_div_logo.appendChild(a_element_logo);

	div_class_reveal.appendChild(title_header_div_logo);
        // console.log("title_header_div_logo: ", title_header_div_logo);
       },

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	initScreenfull() {
		'use strict';

		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;

		var fn = (function () {
			var val;

			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'

				],
				// Old WebKit
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'

				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];

			var i = 0;
			var l = fnMap.length;
			var ret = {};

			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}

			return false;
		})();

		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};

		var screenfull = {
			request: function (element, options) {
				return new Promise(function (resolve, reject) {
					var onFullScreenEntered = function () {
						this.off('change', onFullScreenEntered);
						resolve();
					}.bind(this);

					this.on('change', onFullScreenEntered);

					element = element || document.documentElement;

					var returnPromise = element[fn.requestFullscreen](options);

					if (returnPromise instanceof Promise) {
						returnPromise.then(onFullScreenEntered).catch(reject);
					}
				}.bind(this));
			},
			exit: function () {
				return new Promise(function (resolve, reject) {
					if (!this.isFullscreen) {
						resolve();
						return;
					}

					var onFullScreenExit = function () {
						this.off('change', onFullScreenExit);
						resolve();
					}.bind(this);

					this.on('change', onFullScreenExit);

					var returnPromise = document[fn.exitFullscreen]();

					if (returnPromise instanceof Promise) {
						returnPromise.then(onFullScreenExit).catch(reject);
					}
				}.bind(this));
			},
			toggle: function (element, options) {
				return this.isFullscreen ? this.exit() : this.request(element, options);
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};

		if (!fn) {
			if (isCommonjs) {
				module.exports = {isEnabled: false};
			} else {
				window.screenfull = {isEnabled: false};
			}

			return;
		}

		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			isEnabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});

		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	},

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

       /*
	* Reveal.js toolbar plugin
	* MIT licensed
	* (c) Greg Denehy 2017
	*/

       initRevealToolbar: function(deck) {
	    let that = this;

	    var ieVersion = (function() {
	      var browser = /(msie) ([\w.]+)/.exec(
		window.navigator.userAgent.toLowerCase()
	      );
	      if (browser && browser[1] === 'msie') {
		return parseFloat(browser[2]);
	      }
	      return null;
	    })();

	    // var config = Reveal.getConfig();
	    config = {
	       postMessageEvents: false,
	    }
	    // var options = config.toolbar || {};
	    var options = 
	       {
			// Specifies where the toolbar will be shown: 'top' or 'bottom'
			position: 'bottom',

			// Add button to toggle fullscreen mode for the presentation
			fullscreen: true,

			// Add button to toggle the overview mode on and off
			overview: true,

			// Add button to pause (hide) the presentation display
			pause: true,

			// Add button to show the speaker notes
			notes: true,

			// Add button to show the help overlay
			help: false,

			// If true, the reveal.js-menu will be moved into the toolbar.
			// Set to false to leave the menu on its own.
			captureMenu: true,

			// If true, the playback control will be moved into the toolbar.
			// This is only relevant if the presentation is configured to autoSlide.
			// Set to false to leave the menu on its own.
			capturePlaybackControl: true,

			// font-awesome library the 'loadIcons' option can be set to false
			// and the menu will not attempt to load the font-awesome library.
			loadIcons: true,
		};
	    // console.log("script path: ", scriptPath()); 
	    options.path = options.path || scriptPath() || 'plugin/toolbar/';
	    if (!options.path.endsWith('/')) {
	      options.path += '/';
	    }
	    var loadIcons = options.loadIcons;
	    if (typeof loadIcons === 'undefined') loadIcons = true;

	    // Cached references to DOM elements
	    var dom = {};

	    /*
	    loadResource(
	      options.path + '/toolbar.css',
	      'stylesheet',
	      'toolbar-defaults',
	      function() {
	     */

		/*
		loadResource(
		  options.path + '/lib/screenfull/screenfull.min.js',
		  'script',
		  null,
		  function() {
		    if (loadIcons) {
		      loadResource(
			options.path +
			  '/font-awesome-5.0.2/css/fontawesome-all.min.css',
			'stylesheet',
			'',
			loadPlugin
		      );
		    } else {
		      loadPlugin();
		    }
		  }
		);
		*/

	    /*
	      }
	    );
	     */
	    
            if (
		 deck.isSpeakerNotes() &&
		 window.location.search.includes('controls=false')
            ) {
            } else {
	       loadPlugin();
	    }

	    function loadPlugin() {
	      // does not support IE8 or below
	      var initialise = !ieVersion || ieVersion >= 9;

	      // does not support IE8 or below
	      if (initialise) {
		function option(opt, def) {
		  if (typeof opt === 'undefined') return def;
		  return opt;
		}

		//
		// Set option defaults
		//
		var position = option(options.position, 'bottom'); // 'top' or 'bottom'
		var showFullscreen = option(options.fullscreen, false);
		// console.log("showFullscreen: ",  showFullscreen);
		var showOverview = option(options.overview, false);
		var showPause = option(options.pause, false);
		var showNotes = option(options.notes, false);
		var showHelp = option(options.help, false);
		var captureMenu = option(options.captureMenu, true);
		var capturePlaybackControl = option(
		  options.capturePlaybackControl,
		  true
		);

		// Cache references to key DOM elements
		dom.reveal = document.querySelector('.reveal');
		dom.toolbar = document.querySelector('.reveal-toolbar');

		// console.log("dom.toolbar: ", dom.toolbar);
		if (!dom.toolbar) {
		  // dom.toolbar = createNode(dom.reveal, 'div', 'reveal-toolbar', null);
		  // dom.toolbar = createNodewithId(dom.reveal, 'div', 'reveal-toolbar', null);
		  dom.toolbar = createNodewithId(dom.reveal, 'div', 'customcontrols', null);
		  // console.log("createNode dom.toolbar");
		} else {
		  // move the existing toolbar after the other Reveal components
		  dom.reveal.appendChild(dom.toolbar);
		  // console.log("appendChild dom.toolbar");
		}

		/*
		dom.toolbar.classList.add(
		  position == 'top' ? 'reveal-toolbar-top' : 'reveal-toolbar-bottom'
		);
		 */	

		var collapseIcon = '<i class="fa fa-chevron-down"></i>';
		var expandIcon = '<i class="fa fa-chevron-up"></i>';
		var tooltip = 'Show/hide controls';

		var toggleButton = document.createElement( 'button' );
		toggleButton.title = tooltip;
		toggleButton.innerHTML = '<span id="collapse-customcontrols">' + collapseIcon + '</span>' 
                                         + '<span id="expand-customcontrols">' + expandIcon + '</span>';

		toggleButton.addEventListener('click', function( event ) {
			// var div = document.querySelector("div#reveal-toolbar");
			var div = document.querySelector("div#customcontrols");
			if ( div.classList.contains('collapsed') ) {
				div.classList.remove('collapsed');
			}
			else {
				div.classList.add('collapsed');
			}
			toggleButton.blur(); // unfocus button
		});

		dom.toolbar.appendChild(toggleButton);

		document.addEventListener( 'resize', function( event ) {
			// expand controls to make sure they are visible
			// var div = document.querySelector("div#reveal-toolbar.collapsed");
			var div = document.querySelector("div#customcontrols.collapsed");
			if ( div ) {
				div.classList.remove('collapsed');
			}
		} );

		var controls = document.createElement( 'ul' );
		dom.toolbar.appendChild( controls );

		function createToolbarButton(icon, cb) {
		  var control_li = createNode(
		    controls,
		    'li',
		    null,
		    null
                  );

		  var button = createNode(
		    // dom.toolbar,
		    control_li,
		    'a',
		    'reveal-toolbar-button',
		    null
		  );
		  // console.log("button: ", button);
		  // console.log("cb: ", cb);
		  button.setAttribute('href', '#');
		  button.onclick = function(event) {
		    event.preventDefault();
		    cb(event);
		  };
		  createNode(button, 'i', ['fa', icon]);
		  return button;
		}

		function createToolbarOutButton(icon, cb) {
		  var control_li = createNode(
		    controls,
		    'li',
		    null,
		    null
                  );
		  
		  /*	
		  var tooltiptext = createNode(
		    control_li,
		    'span',
		    'tooltiptext',
		    'Show Slides in Body'
                  );
		   */

		  var button = createNode(
		    control_li,	
		    'a',
		    'reveal-toolbar-button',
		    null
		  );
		  // console.log("button: ", button);
		  // console.log("cb: ", cb);
		  // button.setAttribute('href', '#');

		  // console.log("current url search: ", window.location.search);
		  button.setAttribute('href', '/slides_iframe_db_chap03?frame=false');
		  button.setAttribute('target', '_blank');
		  // button.setAttribute('target', '_self');
                   
                  /*
		  button.onclick = function(event) {
		    event.preventDefault();
		    cb(event);
		  };
                   */
		  createNode(button, 'i', ['fa', icon]);
		  return button;
		}

		function createToolbarPdfButton(icon, cb) {
		  var control_li = createNode(
		    controls,
		    'li',
		    null,
		    null
                  );
		  var button = createNode(
		    // dom.toolbar,
	            control_li, 		 
		    'a',
		    'reveal-toolbar-button',
		    null
		  );
		  // console.log("button: ", button);
		  // console.log("cb: ", cb);
		  // button.setAttribute('href', '#');

		  // console.log("current url search: ", window.location.search.slice(1));
		  button.setAttribute('href', '/slides_iframe_db_chap03?print-pdf');
                  if (window.location.search.slice(1) === 'frame=false') {
		     button.setAttribute('target', '_self');
		  } else {
		     button.setAttribute('target', '_blank');
		  }
                   
                  /*
		  button.onclick = function(event) {
		    event.preventDefault();
		    cb(event);
		  };
                   */
		  createNode(button, 'i', ['fa', icon]);
		  return button;
		}

		function createToolbarPenButton(icon, cb) {
		  var control_li = createNode(
		    controls,
		    'li',
		    null,
		    null
                  );
		  var button = createNode(
		    // dom.toolbar,
                    control_li, 
		    'a',
		    'reveal-toolbar-button',
		    null
		  );
		  // console.log("button: ", button);
		  // console.log("cb: ", cb);
		  button.setAttribute('href', '#');
		  button.onclick = function(event) {
		    event.preventDefault();
		    cb(event);
		  };
		  createNode(button, 'i', ['fa-solid', icon]);
		  return button;
		}

		if (showOverview) {
		  dom.overviewButton = createToolbarButton(
		    // 'fa-th-large',
		    'fa-th',
		    deck.toggleOverview
		  );
		}

		if (showHelp) {
		  dom.helpButton = createToolbarButton(
		    'fa-question',
		    deck.toggleHelp
		  );
		}

                if ( !that.isMobile() ) {
			// if (showNotes && !window.Reveal.isSpeakerNotes()) {
			  createToolbarButton('fa-list-alt', function() {
			    if (!deck.isSpeakerNotes()) {
			       RevealNotes.openSpeakerWindow();
			    }
			  });
			  // createToolbarButton('fa-list-alt', function() { Reveal.triggerKey(83) });
			// }
		}

		// if ( !that.isMobile() ) {	
		if ( !that.isiOs() ) {	
			if (showFullscreen) {
			  dom.fullscreenButton = createToolbarButton('fa-expand', function() {
			    if (screenfull.isEnabled) {
			      screenfull.toggle(document.documentElement);
			      // let viewport = (deck.getRevealElement()).tagName == "BODY" ? document : deck.getRevealElement();
			      // screenfull.toggle(viewport);
			    }
			  });
			}
			// console.log("createToolbarButton fullscreen done");

			// set fullscreen button icon to match fullscreen state
			// if (screenfull.enabled) {
			  screenfull.on('change', function() {
			    var icon = dom.fullscreenButton.querySelector('i');
			    icon.classList.remove(
			      screenfull.isFullscreen ? 'fa-expand' : 'fa-compress'
			    );
			    icon.classList.add(
			      screenfull.isFullscreen ? 'fa-compress' : 'fa-expand'
			    );
			  });
			// }
		}

                dom.searchButton = createToolbarButton('fa-search', function() {
                   // deck.getPlugin('search').open();
                   // deck.getPlugin('search').toggle();
                   RevealSearch.toggle();
		});

                dom.showNotesButton = createToolbarButton('fa-sticky-note', function() {
                   if ( deck.getConfig().showNotes == false ) {
                      // deck.configure({showNotes: true});
                      deck.configure({showNotes: 'separate-page'});
                   } else {
                      deck.configure({showNotes: false});
                   }         
		});
                 
                dom.pdfButton = createToolbarOutButton('fa-arrow-up-right-from-square', function() {
		});

                dom.pdfButton = createToolbarPdfButton('fa-file-pdf', function() {
		});

                dom.msgButton = createToolbarButton('fa-message', function() {
		   RevealQnA.toggleQnA();	
		});

                dom.playButton = createToolbarButton('fa-play', function() {
		   // console.log("reveal config autoSlide:", deck.getConfig().autoSlide);
		   if (deck.getConfig().autoSlide == 0 || deck.getConfig().autoSlide == undefined) {
		      deck.configure({ autoSlide: 5000 });
		      deck.configure({ loop: true });
		      var icon = dom.playButton.querySelector('i');
		      icon.classList.remove('fa-play');
		      icon.classList.add('fa-pause');
                   } else {
		      deck.configure({ autoSlide: 0 });
		      deck.configure({ loop: false });
		      var icon = dom.playButton.querySelector('i');
		      icon.classList.remove('fa-pause');
		      icon.classList.add('fa-play');
 		   }	
		});

		if (showPause) {
		  dom.pauseButton = createToolbarButton(
		    'fa-eye-slash',
		    deck.togglePause
		  );
		  dom.pauseButton.classList.add('reveal-toolbar-pause-button');
		  deck.addEventListener('paused', function() {
		    var icon = dom.pauseButton.querySelector('i');
		    icon.classList.remove('fa-eye-slash');
		    icon.classList.add('fa-eye');
		  });
		  deck.addEventListener('resumed', function() {
		    var icon = dom.pauseButton.querySelector('i');
		    icon.classList.remove('fa-eye');
		    icon.classList.add('fa-eye-slash');
		  });
		}
		 
                dom.penButton = createToolbarPenButton('fa-pen', function() {
                   RevealChalkboard.toggleNotesCanvas();
		});

                dom.boardButton = createToolbarButton('fa-pen-square', function() {
                   RevealChalkboard.toggleChalkboard();
		});

                /*
		if (captureMenu) {
		  // handle async loading of plugins
		  var id_menu = setInterval(function() {
		      // if (RevealMenu && RevealMenu.isMenuInitialised()) {
		      dom.menu = document.querySelector('div.slide-menu-button');
		      if (dom.menu) {
			// console.log('Moving menu button');
			dom.toolbar.insertBefore(dom.menu, dom.toolbar.firstChild);
			dom.menu.classList.add('reveal-toolbar-button');
		      }
		      clearInterval(id_menu);
		    // }
		  }, 50);
		}
		//  console.log("cpatureMenu done");
                 */

		if (capturePlaybackControl) {
		  dom.playback = document.querySelector('canvas.playback');
		  if (dom.playback) {
		    console.log('Moving playback control');
		    dom.toolbar.appendChild(dom.playback);
		  }
		}
		// console.log("capturePlaybackControl done");

		// place default footer stylesheet before first footer stylesheet to ensure footer styles override defaults
		var defaultStylesheet = document.querySelector('#toolbar-defaults');
		var themeStylesheet = document.querySelector('.toolbar-theme');
		if (themeStylesheet) {
		  themeStylesheet.parentElement.insertBefore(
		    defaultStylesheet,
		    themeStylesheet
		  );
		}

		/**
		 * Extend object a with the properties of object b.
		 * If there's a conflict, object b takes precedence.
		 */
		function extend(a, b) {
		  for (var i in b) {
		    a[i] = b[i];
		  }
		}

		/**
		 * Dispatches an event of the specified type from the
		 * reveal DOM element.
		 */
		function dispatchEvent(type, args) {
		  var event = document.createEvent('HTMLEvents', 1, 2);
		  event.initEvent(type, true, true);
		  extend(event, args);
		  document.querySelector('.reveal').dispatchEvent(event);

		  // If we're in an iframe, post each reveal.js event to the
		  // parent window. Used by the notes plugin
		  if (config.postMessageEvents && window.parent !== window.self) {
		    window.parent.postMessage(
		      JSON.stringify({
			namespace: 'reveal',
			eventName: type,
			state: getState()
		      }),
		      '*'
		    );
		  }
		}

		dispatchEvent('toolbar-ready');
	      }
	    }

	    // modified from math plugin
	    function loadResource(url, type, id, callback) {
	      var head = document.querySelector('head');
	      var resource;

	      if (type === 'script') {
		resource = document.createElement('script');
		resource.type = 'text/javascript';
		resource.src = url;
		if (id) resource.id = id;
	      } else if (type === 'stylesheet') {
		resource = document.createElement('link');
		resource.rel = 'stylesheet';
		resource.href = url;
		if (id) resource.id = id;
	      }

	      // Wrapper for callback to make sure it only fires once
	      var finish = function() {
		if (typeof callback === 'function') {
		  callback.call();
		  callback = null;
		}
	      };

	      resource.onload = finish;

	      // IE
	      resource.onreadystatechange = function() {
		if (this.readyState === 'loaded') {
		  finish();
		}
	      };

	      // Normal browsers
	      head.appendChild(resource);
	    }

	    function scriptPath() {
	      // obtain plugin path from the script element
	      var path;
	      if (document.currentScript) {
		path = document.currentScript.src.slice(0, -10);
	      } else {
		var sel = document.querySelector('script[src$="toolbar.js"]');
		if (sel) {
		  path = sel.src.slice(0, -10);
		}
	      }
	      return path;
	    }

	    // polyfill
	    if (!String.prototype.startsWith) {
	      String.prototype.startsWith = function(searchString, position) {
		return this.substr(position || 0, searchString.length) === searchString;
	      };
	    }
	    if (!String.prototype.endsWith) {
	      String.prototype.endsWith = function(search, this_len) {
		if (this_len === undefined || this_len > this.length) {
		  this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	      };
	    }

	    /**
	     * Creates an HTML element and returns a reference to it.
	     *
	     * @param {HTMLElement} container
	     * @param {string} tagname
	     * @param {string} classname
	     * @param {string} innerHTML
	     *
	     * @return {HTMLElement}
	     */
	    function createNode(container, tagname, classname, innerHTML) {
	      var node = document.createElement(tagname);
	      if (classname) {
		if (Array.isArray(classname)) {
		  classname.forEach(function(c) {
		    node.classList.add(c);
		  });
		} else {
		  node.classList.add(classname);
		}
	      }
	      if (typeof innerHTML === 'string') {
		node.innerHTML = innerHTML;
	      }
	      container.appendChild(node);
	      // console.log("createNode container: ", container);
	      // console.log("createNode node: ", node);

	      return node;
	    }

	    function createNodewithId(container, tagname, id, innerHTML) {
	      var node = document.createElement(tagname);
	      if (id) {
		node.setAttribute('id', id);
	      }
	      if (typeof innerHTML === 'string') {
		node.innerHTML = innerHTML;
	      }
	      container.appendChild(node);
	      // console.log("createNode container: ", container);
	      // console.log("createNode node: ", node);

	      return node;
	    }

            // console.log("dom.toolbar: ", dom.toolbar);

	    return {}; 
        },

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*
	 * Handles opening of and synchronization with the reveal.js
	 * notes window.
	 *
	 * Handshake process:
	 * 1. This window posts 'connect' to notes window
	 *    - Includes URL of presentation to show
	 * 2. Notes window responds with 'connected' when it is available
	 * 3. This window proceeds to send the current presentation state
	 *    to the notes window
	 */

	initSpeakerView: function( deck ) {
   		let that = this;

        	let connectInterval;
        	let speakerWindow = null;

		function openSpeakerWindow () {
			// If a window is already open, focus it
			if( speakerWindow && !speakerWindow.closed ) {
				speakerWindow.focus();
			}
			else {
				speakerWindow = window.open( 'about:blank', 'reveal.js - Notes', 'width=1100, height=700' );
				speakerWindow.marked = marked;
				speakerWindow.document.write( speakerViewHTML );

				if( !speakerWindow ) {
					alert( 'Speaker view popup failed to open. Please make sure popups are allowed and reopen the speaker view.' );
					return;
				}

				connect();
			}

		}

		/*
		 * Reconnect with an existing speaker view window.
		 */
		function reconnectSpeakerWindow( reconnectWindow ) {

			if( speakerWindow && !speakerWindow.closed ) {
				speakerWindow.focus();
			}
			else {
				speakerWindow = reconnectWindow;
				window.addEventListener( 'message', onPostMessage );
				onConnected();
			}

		}

		/*
		 * Connect to the notes window through a postmessage handshake.
		 * Using postmessage enables us to work in situations where the
		 * origins differ, such as a presentation being opened from the
		 * file system.
		 */
		function connect() {
			const presentationURL = deck.getConfig().url;

			const url = typeof presentationURL === 'string' ? presentationURL :
				window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;

			// Keep trying to connect until we get a 'connected' message back
			connectInterval = setInterval( function() {
				speakerWindow.postMessage( JSON.stringify( {
					namespace: 'reveal-notes',
					type: 'connect',
					state: deck.getState(),
					url
				} ), '*' );
			}, 500 );

			window.addEventListener( 'message', onPostMessage );

		}

		/**
		 * Calls the specified Reveal.js method with the provided argument
		 * and then pushes the result to the notes frame.
		 */
		function callRevealApi ( methodName, methodArguments, callId ) {
			let result = deck[methodName].apply( deck, methodArguments );
			speakerWindow.postMessage( JSON.stringify( {
				namespace: 'reveal-notes',
				type: 'return',
				result,
				callId
			} ), '*' );

		}

		/**
		 * Posts the current slide data to the notes window.
		 */
		function post ( event ) {
			let slideElement = deck.getCurrentSlide(),
				notesElements = slideElement.querySelectorAll( 'aside.notes' ),
				fragmentElement = slideElement.querySelector( '.current-fragment' );

			let messageData = {
				namespace: 'reveal-notes',
				type: 'state',
				notes: '',
				markdown: false,
				whitespace: 'normal',
				state: deck.getState()
			};

			// Look for notes defined in a slide attribute
			if( slideElement.hasAttribute( 'data-notes' ) ) {
				messageData.notes = slideElement.getAttribute( 'data-notes' );
				messageData.whitespace = 'pre-wrap';
			}

			// Look for notes defined in a fragment
			if( fragmentElement ) {
				let fragmentNotes = fragmentElement.querySelector( 'aside.notes' );
				if( fragmentNotes ) {
					messageData.notes = fragmentNotes.innerHTML;
					messageData.markdown = typeof fragmentNotes.getAttribute( 'data-markdown' ) === 'string';

					// Ignore other slide notes
					notesElements = null;
				}
				else if( fragmentElement.hasAttribute( 'data-notes' ) ) {
					messageData.notes = fragmentElement.getAttribute( 'data-notes' );
					messageData.whitespace = 'pre-wrap';

					// In case there are slide notes
					notesElements = null;
				}
			}

			// Look for notes defined in an aside element
			if( notesElements ) {
				messageData.notes = Array.from(notesElements).map( notesElement => notesElement.innerHTML ).join( '\n' );
				messageData.markdown = notesElements[0] && typeof notesElements[0].getAttribute( 'data-markdown' ) === 'string';
			}

			speakerWindow.postMessage( JSON.stringify( messageData ), '*' );

		}

		/**
		 * Check if the given event is from the same origin as the
		 * current window.
		 */
		function isSameOriginEvent ( event ) {

			try {
				return window.location.origin === event.source.location.origin;
			}
			catch ( error ) {
				return false;
			}

		}

		function onPostMessage ( event ) {
			// Only allow same-origin messages
			// (added 12/5/22 as a XSS safeguard)
			if( isSameOriginEvent( event ) ) {
				// console.log("event.data: ", event.data);
				let data = JSON.parse( event.data );
				// console.log("data: ", data);
				if( data && data.namespace === 'reveal-notes' && data.type === 'connected' ) {
					clearInterval( connectInterval );
					onConnected();
				}
				else if( data && data.namespace === 'reveal-notes' && data.type === 'call' ) {
					callRevealApi( data.methodName, data.arguments, data.callId );
				}

			}

		}

		/**
		 * Called once we have established a connection to the notes
		 * window.
		 */
		function onConnected () {
			// Monitor events that trigger a change in state
			deck.on( 'slidechanged', post );
			deck.on( 'fragmentshown', post );
			deck.on( 'fragmenthidden', post );
			deck.on( 'overviewhidden', post );
			deck.on( 'overviewshown', post );
			deck.on( 'paused', post );
			deck.on( 'resumed', post );

			// Post the initial state
			post();
		}

		if( !/receiver/i.test( window.location.search ) ) {

			// If the there's a 'notes' query set, open directly
			if( window.location.search.match( /(\?|\&)notes/gi ) !== null ) {
				openSpeakerWindow();
			}
			else {
				// Keep listening for speaker view hearbeats. If we receive a
				// heartbeat from an orphaned window, reconnect it. This ensures
				// that we remain connected to the notes even if the presentation
				// is reloaded.
				window.addEventListener( 'message', event => {

					if( !speakerWindow && typeof event.data === 'string' ) {
						let data;

						try {
							data = JSON.parse( event.data );
						}
						catch( error ) {}

						if( data && data.namespace === 'reveal-notes' && data.type === 'heartbeat' ) {
							reconnectSpeakerWindow( event.source );
						}
					}
				});
			}

			// Open the notes when the 's' key is hit
			deck.addKeyBinding({keyCode: 83, key: 'S', description: 'Speaker notes view'}, function() {
				openSpeakerWindow();
			} );

		}

		window.RevealNotes = window.RevealNotes || {
		    id: 'notes',
		    init: function(deck) {
			initSpeakerView(deck);
		    },
		    openSpeakerWindow: function() { return openSpeakerWindow(); },
		};

		this.openSpeakerWindow = openSpeakerWindow;

		return this;
	},

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*!
	 * reveal.js Zoom plugin
	 */

	/*!
	 * zoom.js 0.3 (modified for use with reveal.js)
	 * http://lab.hakim.se/zoom-js
	 * MIT licensed
	 *
	 * Copyright (C) 2011-2014 Hakim El Hattab, http://hakim.se
	 */
        initRevealZoom: function(deck) {
		let that = this;

		// The current zoom level (scale)
		var level = 1;

		// The current mouse position, used for panning
		var mouseX = 0,
			mouseY = 0;

		// Timeout before pan is activated
		var panEngageTimeout = -1,
			panUpdateInterval = -1;

		// Check for transform support so that we can fallback otherwise
		var supportsTransforms = 'transform' in document.body.style;

		if( supportsTransforms ) {
			// The easing that will be applied when we zoom in/out
			document.body.style.transition = 'transform 0.8s ease';
		}

		// Zoom out if the user hits escape
		document.addEventListener( 'keyup', function( event ) {
			if( level !== 1 && event.keyCode === 27 ) {
				out();
			}
		} );

		// Monitor mouse movement for panning
		document.addEventListener( 'mousemove', function( event ) {
			if( level !== 1 ) {
				mouseX = event.clientX;
				mouseY = event.clientY;
			}
		} );

		/**
		 * Applies the CSS required to zoom in, prefers the use of CSS3
		 * transforms but falls back on zoom for IE.
		 *
		 * @param {Object} rect
		 * @param {Number} scale
		 */
		function magnify ( rect, scale ) {
			var scrollOffset = getScrollOffset();

			// Ensure a width/height is set
			rect.width = rect.width || 1;
			rect.height = rect.height || 1;

			// Center the rect within the zoomed viewport
			rect.x -= ( window.innerWidth - ( rect.width * scale ) ) / 2;
			rect.y -= ( window.innerHeight - ( rect.height * scale ) ) / 2;

			if( supportsTransforms ) {
				// Reset
				if( scale === 1 ) {
					document.body.style.transform = '';
				}
				// Scale
				else {
					var origin = scrollOffset.x +'px '+ scrollOffset.y +'px',
						transform = 'translate('+ -rect.x +'px,'+ -rect.y +'px) scale('+ scale +')';

					document.body.style.transformOrigin = origin;
					document.body.style.transform = transform;
				}
			}
			else {
				// Reset
				if( scale === 1 ) {
					document.body.style.position = '';
					document.body.style.left = '';
					document.body.style.top = '';
					document.body.style.width = '';
					document.body.style.height = '';
					document.body.style.zoom = '';
				}
				// Scale
				else {
					document.body.style.position = 'relative';
					document.body.style.left = ( - ( scrollOffset.x + rect.x ) / scale ) + 'px';
					document.body.style.top = ( - ( scrollOffset.y + rect.y ) / scale ) + 'px';
					document.body.style.width = ( scale * 100 ) + '%';
					document.body.style.height = ( scale * 100 ) + '%';
					document.body.style.zoom = scale;
				}
			}

			level = scale;

			if( document.documentElement.classList ) {
				if( level !== 1 ) {
					document.documentElement.classList.add( 'zoomed' );
				}
				else {
					document.documentElement.classList.remove( 'zoomed' );
				}
			}
		}

		function zoom_in () {
			deck.getRevealElement().addEventListener( 'mousedown', function( event ) {
				// var defaultModifier = /Linux/.test( window.navigator.platform ) ? 'ctrl' : 'alt';
				var defaultModifier = 'alt';
				var outModifier = 'shiftKey';

				var modifier = ( deck.getConfig().zoomKey ? deck.getConfig().zoomKey : defaultModifier ) + 'Key';
				// var zoomLevel = ( deck.getConfig().zoomLevel ? deck.getConfig().zoomLevel : 2 );
				var zoomLevel = level + 1;

				if( event[ outModifier ] && !deck.isOverview() ) {
					event.preventDefault();
					out();
				} 
				else if( event[ modifier ] && !deck.isOverview() ) {
					event.preventDefault();

					to({
						x: event.clientX,
						y: event.clientY,
						scale: zoomLevel,
						pan: false
					});
				}
			} );
		}

		/**
		 * Pan the document when the mosue cursor approaches the edges
		 * of the window.
		 */
		function pan () {
			var range = 0.12,
				rangeX = window.innerWidth * range,
				rangeY = window.innerHeight * range,
				scrollOffset = getScrollOffset();

			// Up
			if( mouseY < rangeY ) {
				window.scroll( scrollOffset.x, scrollOffset.y - ( 1 - ( mouseY / rangeY ) ) * ( 14 / level ) );
			}
			// Down
			else if( mouseY > window.innerHeight - rangeY ) {
				window.scroll( scrollOffset.x, scrollOffset.y + ( 1 - ( window.innerHeight - mouseY ) / rangeY ) * ( 14 / level ) );
			}

			// Left
			if( mouseX < rangeX ) {
				window.scroll( scrollOffset.x - ( 1 - ( mouseX / rangeX ) ) * ( 14 / level ), scrollOffset.y );
			}
			// Right
			else if( mouseX > window.innerWidth - rangeX ) {
				window.scroll( scrollOffset.x + ( 1 - ( window.innerWidth - mouseX ) / rangeX ) * ( 14 / level ), scrollOffset.y );
			}
		}

		function getScrollOffset () {
			return {
				x: window.scrollX !== undefined ? window.scrollX : window.pageXOffset,
				y: window.scrollY !== undefined ? window.scrollY : window.pageYOffset
			}
		}

		/**
		 * Zooms in on either a rectangle or HTML element.
		 *
		 * @param {Object} options
		 *   - element: HTML element to zoom in on
		 *   OR
		 *   - x/y: coordinates in non-transformed space to zoom in on
		 *   - width/height: the portion of the screen to zoom in on
		 *   - scale: can be used instead of width/height to explicitly set scale
		 */
		function to ( options ) {
			// Due to an implementation limitation we can't zoom in
			// to another element without zooming out first
			/*
			if( level !== 1 ) {
				out();
			}
			else 
			 */
			{
				options.x = options.x || 0;
				options.y = options.y || 0;

				// If an element is set, that takes precedence
				if( !!options.element ) {
					// Space around the zoomed in element to leave on screen
					var padding = 20;
					var bounds = options.element.getBoundingClientRect();

					options.x = bounds.left - padding;
					options.y = bounds.top - padding;
					options.width = bounds.width + ( padding * 2 );
					options.height = bounds.height + ( padding * 2 );
				}

				// If width/height values are set, calculate scale from those values
				if( options.width !== undefined && options.height !== undefined ) {
					options.scale = Math.max( Math.min( window.innerWidth / options.width, window.innerHeight / options.height ), 1 );
				}

				if( options.scale > 1 ) {
					options.x *= options.scale;
					options.y *= options.scale;

					magnify( options, options.scale );

					if( options.pan !== false ) {

						// Wait with engaging panning as it may conflict with the
						// zoom transition
						panEngageTimeout = setTimeout( function() {
							panUpdateInterval = setInterval( pan, 1000 / 60 );
						}, 800 );

					}
				}
			}
		}

		/**
		 * Resets the document zoom state to its default.
		 */
		function out () {
			clearTimeout( panEngageTimeout );
			clearInterval( panUpdateInterval );

			magnify( { x: 0, y: 0 }, 1 );

			level = 1;
		}

		window.RevealZoom = window.RevealZoom || {
			id: 'zoom',
			init: function( deck ) {
			   return initRevealZoom(deck);
			},

			to: function( options ) {
			   return to (options);	
			},

			zoom_in: function() {
			   return zoom_in ();
 			}, 

			out: function() {
			   return out ();
 			}, 

			magnify: function( options ) { to( options ) },

			reset: function() { out() },

			zoomLevel: function() {
			   return level;
			},

			destroy: () => {
			   out();
			},
		};

		return this;
        }, 


        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	 ** Author: Asvin Goel, goel@telematique.eu
	 **
	 ** A plugin for reveal.js adding a chalkboard.
	 **
	 ** Version: 2.1.0
	 **
	 ** License: MIT license (see LICENSE.md)
	 **
	 ** Credits:
	 ** Chalkboard effect by Mohamed Moustafa https://github.com/mmoustafa/Chalkboard
	 ** Multi color support initially added by Kurt Rinnert https://github.com/rinnert
	 ** Compatibility with reveal.js v4 by Hakim El Hattab https://github.com/hakimel
	 ******************************************************************/

	/*
	function scriptPath() {
		// obtain plugin path from the script element
		var src;
		if ( document.currentScript ) {
			src = document.currentScript.src;
		} else {
			var sel = document.querySelector( 'script[src$="/chalkboard/plugin.js"]' )
			if ( sel ) {
				src = sel.src;
			}
		}
		var path = ( src === undefined ) ? "" : src.slice( 0, src.lastIndexOf( "/" ) + 1 );
	        //console.log("Path: " + path);
		return path;
	}
	var path = scriptPath();
	*/


	initChalkboard: function ( Reveal ) {
		let that = this;

		//console.warn(path);
		/* Feature detection for passive event handling*/
		var passiveSupported = false;

		try {
			window.addEventListener( 'test', null, Object.defineProperty( {}, 'passive', {
				get: function () {
					passiveSupported = true;
				}
			} ) );
		} catch ( err ) {}


		/*****************************************************************
		 ** Configuration
		 ******************************************************************/
		var background, pens, draw, color;
		var grid = false;
		var boardmarkerWidth = 3;
		var chalkWidth = 7;
		var chalkEffect = 1.0;
		var rememberColor = [ true, false ];
                var path = '../assets/imgs/chalkboard/';
		var eraser = {
			// src: require(path + 'sponge.png'),
			src: that.eraser_src,
			radius: 20
		};
		var boardmarkers = [ {
				color: 'rgba(100,100,100,1)',
				// cursor: 'url(' + path + 'img/boardmarker-black.png), auto'
				cursor: 'url(' + that.boardmarker_black + '), auto'
			},
			{
				color: 'rgba(30,144,255, 1)',
				// cursor: 'url(' + path + 'img/boardmarker-blue.png), auto'
				cursor: 'url(' + that.boardmarker_blue + '), auto'
			},
			{
				color: 'rgba(220,20,60,1)',
				// cursor: 'url(' + path + 'img/boardmarker-red.png), auto'
				cursor: 'url(' + that.boardmarker_red + '), auto'
			},
			{
				color: 'rgba(50,205,50,1)',
				// cursor: 'url(' + path + 'img/boardmarker-green.png), auto'
				cursor: 'url(' + that.boardmarker_green + '), auto'
			},
			{
				color: 'rgba(255,140,0,1)',
				// cursor: 'url(' + path + 'img/boardmarker-orange.png), auto'
				cursor: 'url(' + that.boardmarker_orange + '), auto'
			},
			{
				color: 'rgba(150,0,20150,1)',
				// cursor: 'url(' + path + 'img/boardmarker-purple.png), auto'
				cursor: 'url(' + that.boardmarker_purple + '), auto'
			},
			{
				color: 'rgba(255,220,0,1)',
				// cursor: 'url(' + path + 'img/boardmarker-yellow.png), auto'
				cursor: 'url(' + that.boardmarker_yellow + '), auto'
			}
		];
		var chalks = [ {
				color: 'rgba(255,255,255,0.5)',
				// cursor: 'url(' + path + 'img/chalk-white.png), auto'
				cursor: 'url(' + that.chalk_white + '), auto'
			},
			{
				color: 'rgba(96, 154, 244, 0.5)',
				// cursor: 'url(' + path + 'img/chalk-blue.png), auto'
				cursor: 'url(' + that.chalk_blue + '), auto'
			},
			{
				color: 'rgba(237, 20, 28, 0.5)',
				// cursor: 'url(' + path + 'img/chalk-red.png), auto'
				cursor: 'url(' + that.chalk_red + '), auto'
			},
			{
				color: 'rgba(20, 237, 28, 0.5)',
				// cursor: 'url(' + path + 'img/chalk-green.png), auto'
				cursor: 'url(' + that.chalk_green + '), auto'
			},
			{
				color: 'rgba(220, 133, 41, 0.5)',
				// cursor: 'url(' + path + 'img/chalk-orange.png), auto'
				cursor: 'url(' + that.chalk_orange + '), auto'
			},
			{
				color: 'rgba(220,0,220,0.5)',
				// cursor: 'url(' + path + 'img/chalk-purple.png), auto'
				cursor: 'url(' + that.chalk_purple + '), auto'
			},
			{
				color: 'rgba(255,220,0,0.5)',
				// cursor: 'url(' + path + 'img/chalk-yellow.png), auto'
				cursor: 'url(' + that.chalk_yellow + '), auto'
			}
		];
		var keyBindings = {
			toggleNotesCanvas: {
				keyCode: 67,
				key: 'C',
				description: 'Toggle notes canvas'
			},
			toggleChalkboard: {
				keyCode: 66,
				key: 'B',
				description: 'Toggle chalkboard'
			},
			clear: {
				keyCode: 46,
				key: 'DEL',
				description: 'Clear drawings on slide'
			},
			/*
			reset: {
				keyCode: 173,
				key: '-',
				description: 'Reset drawings on slide'
			},
			 */
			resetAll: {
				keyCode: 8,
				key: 'BACKSPACE',
				description: 'Reset all drawings'
			},
			colorNext: {
				keyCode: 88,
				key: 'X',
				description: 'Next color'
			},
			colorPrev: {
				keyCode: 89,
				key: 'Y',
				description: 'Previous color'
			},
			download: {
				keyCode: 68,
				key: 'D',
				description: 'Download drawings'
			}
		};

		var theme = 'chalkboard';
		var color = [ 0, 0 ];
		var toggleChalkboardButton = false;
		var toggleNotesButton = false;
		var colorButtons = true;
		var boardHandle = true;
		var transition = 800;

		var readOnly = false;
		var messageType = 'broadcast';

		var config = configure( Reveal.getConfig().chalkboard || {} );
		if ( config.keyBindings ) {
			for ( var key in config.keyBindings ) {
				keyBindings[ key ] = config.keyBindings[ key ];
			};
		}

		function configure( config ) {
			if ( config.boardmarkerWidth || config.penWidth ) boardmarkerWidth = config.boardmarkerWidth || config.penWidth;
			if ( config.chalkWidth ) chalkWidth = config.chalkWidth;
			if ( config.chalkEffect ) chalkEffect = config.chalkEffect;
			if ( config.rememberColor ) rememberColor = config.rememberColor;
			if ( config.eraser ) eraser = config.eraser;
			if ( config.boardmarkers ) boardmarkers = config.boardmarkers;
			if ( config.chalks ) chalks = config.chalks;

			if ( config.theme ) theme = config.theme;
			theme = 'whiteboard';
			switch ( theme ) {
			case 'chalkboard':
				// background = [ 'rgba(127,127,127,.1)', path + 'img/blackboard.png' ];
				background = [ 'rgba(127,127,127,.1)', that.blackboard_png ];
				draw = [ drawWithBoardmarker, drawWithChalk ];
				pens = [ boardmarkers, chalks ];
                                // console.log("chalkboard pens: ", pens); 
				grid = {
					color: 'rgb(50,50,10,0.5)',
					distance: 80,
					width: 2
				};
				break;
			case 'whiteboard':
			default:
				// background = [ 'rgba(127,127,127,.1)', path + 'img/whiteboard.png' ];
				background = [ 'rgba(127,127,127,.1)', that.whiteboard_png ];
				draw = [ drawWithBoardmarker, drawWithBoardmarker ];
				pens = [ boardmarkers, boardmarkers ];
				grid = {
					color: 'rgb(127,127,255,0.1)',
					distance: 40,
					width: 2
				};
			}

			if ( config.background ) background = config.background;
			if ( config.grid != undefined ) grid = config.grid;

			if ( config.toggleChalkboardButton != undefined ) toggleChalkboardButton = config.toggleChalkboardButton;
			if ( config.toggleNotesButton != undefined ) toggleNotesButton = config.toggleNotesButton;
			if ( config.colorButtons != undefined ) colorButtons = config.colorButtons;
			if ( config.boardHandle != undefined ) boardHandle = config.boardHandle;
			if ( config.transition ) transition = config.transition;

			if ( config.readOnly != undefined ) readOnly = config.readOnly;
			if ( config.messageType ) messageType = config.messageType;

			if ( drawingCanvas && ( config.theme || config.background || config.grid ) ) {
				var canvas = document.getElementById( drawingCanvas[ 1 ].id );
				canvas.style.background = 'url("' + background[ 1 ] + '") repeat';
				clearCanvas( 1 );
				drawGrid();
			}

			return config;
		}

		/*****************************************************************
		 ** Setup
		 ******************************************************************/
		function whenReady( callback ) {
			// wait for markdown to be parsed and code to be highlighted
			if ( !document.querySelector( 'section[data-markdown]:not([data-markdown-parsed])' ) 
			     && !document.querySelector( 'code[data-line-numbers*="|"]') 	
			) {
				callback();
			} else {
				console.log( "Wait for markdown to be parsed and code to be highlighted" );
				setTimeout( whenReady, 500, callback )
			}
		}

		function whenLoaded( callback ) {
			// wait for drawings to be loaded and markdown to be parsed
			if ( loaded !== null ) {
				callback();
			} else {
				console.log( "Wait for drawings to be loaded" );
				setTimeout( whenLoaded, 500, callback )
			}
		}

		if ( toggleChalkboardButton ) {
			console.warn( "toggleChalkboardButton is deprecated, use customcontrols plugin instead!" );
			// console.log("toggleChalkboardButton")
			var button = document.createElement( 'div' );
			button.className = "chalkboard-button";
			button.id = "toggle-chalkboard";
			button.style.visibility = "visible";
			button.style.position = "absolute";
			button.style.zIndex = 30;
			button.style.fontSize = "24px";

			button.style.left = toggleChalkboardButton.left || "30px";
			button.style.bottom = toggleChalkboardButton.bottom || "30px";
			button.style.top = toggleChalkboardButton.top || "auto";
			button.style.right = toggleChalkboardButton.right || "auto";

			button.innerHTML = '<a href="#" title="Toggle chalkboard (' + 
						keyBindings.toggleChalkboard.key 
				+ ')" onclick="RevealChalkboard.toggleChalkboard(); return false;"><i class="fa fa-pen-square"></i></a>'
			document.querySelector( ".reveal" ).appendChild( button );
		}
		if ( toggleNotesButton ) {
			console.warn( "toggleNotesButton is deprecated, use customcontrols plugin instead!" );
			//console.log("toggleNotesButton")
			var button = document.createElement( 'div' );
			button.className = "chalkboard-button";
			button.id = "toggle-notes";
			button.style.position = "absolute";
			button.style.zIndex = 30;
			button.style.fontSize = "24px";

			button.style.left = toggleNotesButton.left || "70px";
			button.style.bottom = toggleNotesButton.bottom || "30px";
			button.style.top = toggleNotesButton.top || "auto";
			button.style.right = toggleNotesButton.right || "auto";

			button.innerHTML = '<a href="#" title="Toggle slide annotation (' + 
				keyBindings.toggleNotesCanvas.key + 
				')" onclick="RevealChalkboard.toggleNotesCanvas(); return false;"><i class="fa fa-pen"></i></a>'
			document.querySelector( ".reveal" ).appendChild( button );
		}

		var drawingCanvas = [ {
			id: 'notescanvas'
		}, {
			id: 'chalkboard'
		} ];
		setupDrawingCanvas( 0 );
		setupDrawingCanvas( 1 );

		var mode = 0; // 0: notes canvas, 1: chalkboard
		var board = 0; // board index (only for chalkboard)

		var mouseX = 0;
		var mouseY = 0;
		var lastX = null;
		var lastY = null;

		var drawing = false;
		var erasing = false;

		var slideStart = Date.now();
		var slideIndices = {
			h: 0,
			v: 0
		};

		var timeouts = [
			[],
			[]
		];
		var touchTimeout = null;
		var slidechangeTimeout = null;
		var updateStorageTimeout = null;
		var playback = false;

		function createPalette( colors, length ) {
			if ( length === true || length > colors.length ) {
				length = colors.length;
			}
			var palette = document.createElement( 'div' );
		        // palette.style.zIndex = 9997;
			palette.classList.add( 'palette' );
			var list = document.createElement( 'ul' );
		        // list.style.zIndex = 9998;
			// color pickers
			for ( var i = 0; i < length; i++ ) {
				var colorButton = document.createElement( 'li' );
				colorButton.setAttribute( 'data-color', i );
				colorButton.classList.add('chalkboard_color_button');
				colorButton.style.backgroundColor = colors[ i ].color;
				colorButton.style.width = '6vh';
				colorButton.style.height = '3vh';
				colorButton.addEventListener( 'click', function ( e ) {
					// e.preventDefault();
					// console.log("color button clicked");
					var element = e.target;
					while ( !element.hasAttribute( 'data-color' ) ) {
						element = element.parentElement;
					}
					colorIndex( parseInt( element.getAttribute( 'data-color' ) ) );
				} );

				colorButton.addEventListener( 'touchstart', function ( e ) {
					var element = e.target;
					while ( !element.hasAttribute( 'data-color' ) ) {
						element = element.parentElement;
					}
					colorIndex( parseInt( element.getAttribute( 'data-color' ) ) );
				} );
                                // console.log("colorButton: ", colorButton);
				list.appendChild( colorButton );
			}
			palette.appendChild( list );
			return palette;
		};

		function switchBoard( boardIdx ) {
			selectBoard( boardIdx, true );
			// broadcast
			var message = new CustomEvent( messageType );
				message.content = {
				sender: 'chalkboard-plugin',
				type: 'selectboard',
				timestamp: Date.now() - slideStart,
				mode,
				board
			};
			document.dispatchEvent( message );	
		}

		function setupDrawingCanvas( id ) {
			var container = document.createElement( 'div' );
			container.id = drawingCanvas[ id ].id;
			container.classList.add( 'overlay' );
			container.setAttribute( 'data-prevent-swipe', 'true' );
			container.oncontextmenu = function () {
				return false;
			}
			container.style.cursor = pens[ id ][ color[ id ] ].cursor;
			// console.log("setupDrawingCanvas pens[ id ][ color[ id ] ].cursor: ", pens[ id ][ color[ id ] ].cursor);
			// console.log("setupDrawingCanvas container.style.cursor: ", container.style.cursor);

			drawingCanvas[ id ].width = window.innerWidth;
			drawingCanvas[ id ].height = window.innerHeight;
			drawingCanvas[ id ].scale = 1;
			drawingCanvas[ id ].xOffset = 0;
			drawingCanvas[ id ].yOffset = 0;

			if ( id == "0" ) {
				container.style.background = 'rgba(0,0,0,0)';
				container.style.zIndex = 24;
				container.style.opacity = 1;
				container.style.visibility = 'visible';
				container.style.pointerEvents = 'none';

				var slides = document.querySelector( '.slides' );
				var aspectRatio = Reveal.getConfig().width / Reveal.getConfig().height;
				if ( drawingCanvas[ id ].width > drawingCanvas[ id ].height * aspectRatio ) {
					drawingCanvas[ id ].xOffset = ( drawingCanvas[ id ].width - drawingCanvas[ id ].height * aspectRatio ) / 2;
				} else if ( drawingCanvas[ id ].height > drawingCanvas[ id ].width / aspectRatio ) {
					drawingCanvas[ id ].yOffset = ( drawingCanvas[ id ].height - drawingCanvas[ id ].width / aspectRatio ) / 2;
				}

				if ( colorButtons ) {
					var palette = createPalette( boardmarkers, colorButtons );
					palette.style.visibility = 'hidden'; // only show palette in drawing mode
					container.appendChild( palette );
				}
			} else {
				container.style.background = 'url("' + background[ id ] + '") repeat';
				container.style.zIndex = 26;
				container.style.opacity = 0;
				container.style.visibility = 'hidden';

				if ( colorButtons ) {
					var palette = createPalette( chalks, colorButtons );
					container.appendChild( palette );
				}
				if ( boardHandle ) {
					var handle = document.createElement( 'div' );
					handle.classList.add( 'boardhandle' );
					handle.innerHTML = '<ul><li><a id="previousboard" href="#" title="Previous board">' + 
						'<i class="fas fa-chevron-up"></i></a></li>'+
						'<li><a id="nextboard" href="#" title="Next board"><i class="fas fa-chevron-down"></i></a></li></ul>';
					handle.querySelector( '#previousboard' ).addEventListener( 'click', function ( e ) {
						e.preventDefault();
						switchBoard( board - 1 );
					} );
					handle.querySelector( '#nextboard' ).addEventListener( 'click', function ( e ) {
						e.preventDefault();
						switchBoard( board + 1 );
					} );
					handle.querySelector( '#previousboard' ).addEventListener( 'touchstart', function ( e ) {
						e.preventDefault();
						switchBoard( board - 1 );
					} );
					handle.querySelector( '#nextboard' ).addEventListener( 'touchstart', function ( e ) {
						e.preventDefault();
						switchBoard( board + 1 );
					} );

					container.appendChild( handle );
				}
			}


			var sponge = document.createElement( 'img' );
			sponge.src = eraser.src;
			sponge.id = 'sponge';
			sponge.style.visibility = 'hidden';
			sponge.style.position = 'absolute';
			container.appendChild( sponge );
			drawingCanvas[ id ].sponge = sponge;

			var canvas = document.createElement( 'canvas' );
			canvas.width = drawingCanvas[ id ].width;
			canvas.height = drawingCanvas[ id ].height;
			canvas.setAttribute( 'data-chalkboard', id );
			canvas.style.cursor = pens[ id ][ color[ id ] ].cursor;
			// console.log("setupDrawingCanvas pens[ id ][ color[ id ] ].cursor: ", pens[ id ][ color[ id ] ].cursor);
			// console.log("setupDrawingCanvas canvas.style.cursor: ", canvas.style.cursor);
			container.appendChild( canvas );
			drawingCanvas[ id ].canvas = canvas;

			drawingCanvas[ id ].context = canvas.getContext( '2d' );

			setupCanvasEvents( container );

			document.querySelector( '.reveal' ).appendChild( container );
			drawingCanvas[ id ].container = container;
		}

		/*****************************************************************
		 ** Storage
		 ******************************************************************/
		var storage = [ {
				width: Reveal.getConfig().width,
				height: Reveal.getConfig().height,
				data: []
			},
			{
				width: Reveal.getConfig().width,
				height: Reveal.getConfig().height,
				data: []
			}
		];

		var loaded = null;

		if ( config.storage ) {
			// Get chalkboard drawings from session storage
			loaded = initStorage( sessionStorage.getItem( config.storage ) );
		}

		if ( !loaded && config.src != null ) {
			// Get chalkboard drawings from the given file
			loadData( config.src );
		}

		/**
		 * Initialize storage.
		 */
		function initStorage( json ) {
			var success = false;
			try {
				var data = JSON.parse( json );
				for ( var id = 0; id < data.length; id++ ) {
					if ( drawingCanvas[ id ].width != data[ id ].width || drawingCanvas[ id ].height != data[ id ].height ) {
						drawingCanvas[ id ].scale = Math.min( drawingCanvas[ id ].width / data[ id ].width, 
										drawingCanvas[ id ].height / data[ id ].height );
						drawingCanvas[ id ].xOffset = ( drawingCanvas[ id ].width - 
										data[ id ].width * drawingCanvas[ id ].scale ) / 2;
						drawingCanvas[ id ].yOffset = ( drawingCanvas[ id ].height - 
										data[ id ].height * drawingCanvas[ id ].scale ) / 2;
					}
					if ( config.readOnly ) {
						drawingCanvas[ id ].container.style.cursor = 'default';
						drawingCanvas[ id ].canvas.style.cursor = 'default';
					}
				}
				success = true;
				storage = data;
			} catch ( err ) {
				// console.warn( "Cannot initialise storage!" );
			}
			return success;
		}


		/**
		 * Load data.
		 */
		function loadData( filename ) {
			var xhr = new XMLHttpRequest();
			xhr.onload = function () {
				if ( xhr.readyState === 4 && xhr.status != 404 ) {
					loaded = initStorage( xhr.responseText );
					updateStorage();
					console.log( "Drawings loaded from file" );
				} else {
					config.readOnly = undefined;
					readOnly = undefined;
					console.warn( 'Failed to get file ' + filename + '. ReadyState: ' + 
							xhr.readyState + ', Status: ' + xhr.status );
					loaded = false;
				}
			};

			xhr.open( 'GET', filename, true );
			try {
				xhr.send();
			} catch ( error ) {
				config.readOnly = undefined;
				readOnly = undefined;
				console.warn( 'Failed to get file ' + filename 
                        + '. Make sure that the presentation and the file are served by a HTTP server and the file can be found there. ' + error );
				loaded = false;
			}
		}


		function storageChanged( now ) {
			if ( !now ) {
				// create or update timer
				if ( updateStorageTimeout ) {
					clearTimeout( updateStorageTimeout );
				}
				updateStorageTimeout = setTimeout( storageChanged, 1000, true);
			}
			else {
				// console.log("Update storage", updateStorageTimeout,  Date.now());
				updateStorage();
				updateStorageTimeout = null;
			}
		}

		function updateStorage() {
			var json = JSON.stringify( storage )
			if ( config.storage ) {
				sessionStorage.setItem( config.storage, json )
			}
			return json;
		}

		function recordEvent( event ) {
			// console.log(event);
			event.time = Date.now() - slideStart;
			if ( mode == 1 ) event.board = board;
			var slideData = getSlideData();
			var i = slideData.events.length;
			while ( i > 0 && event.time < slideData.events[ i - 1 ].time ) {
				i--;
			}
			slideData.events.splice( i, 0, event );
			slideData.duration = Math.max( slideData.duration, Date.now() - slideStart ) + 1;

			storageChanged();
		}

		/**
		 * Get data as json string.
		 */
		function getData() {
			// cleanup slide data without events
			for ( var id = 0; id < 2; id++ ) {
				for ( var i = storage[ id ].data.length - 1; i >= 0; i-- ) {
					if ( storage[ id ].data[ i ].events.length == 0 ) {
						storage[ id ].data.splice( i, 1 );
					}
				}
			}

			return updateStorage();
		}

		/**
		 * Download data.
		 */
		function downloadData() {
			var a = document.createElement( 'a' );
			document.body.appendChild( a );
			try {
				a.download = 'chalkboard.json';
				var blob = new Blob( [ getData() ], {
					type: 'application/json'
				} );
				a.href = window.URL.createObjectURL( blob );
			} catch ( error ) {
				a.innerHTML += ' (' + error + ')';
			}
			a.click();
			document.body.removeChild( a );
		}

		/**
		 * Returns data object for the slide with the given indices.
		 */
		function getSlideData( indices, id ) {
			if ( id == undefined ) id = mode;
			if ( !indices ) indices = slideIndices;
			var data;
			for ( var i = 0; i < storage[ id ].data.length; i++ ) {
				if ( storage[ id ].data[ i ].slide.h === 
					indices.h && storage[ id ].data[ i ].slide.v === 
					indices.v && storage[ id ].data[ i ].slide.f === indices.f ) {
					data = storage[ id ].data[ i ];
					return data;
				}
			}
			var page = Number( Reveal.getCurrentSlide().getAttribute('data-pdf-page-number') ); 
			// console.log( indices, Reveal.getCurrentSlide() );
			storage[ id ].data.push( {
				slide: indices,
				page,
				events: [],
				duration: 0
			} );
			data = storage[ id ].data[ storage[ id ].data.length - 1 ];
			return data;
		}

		/**
		 * Returns maximum duration of slide playback for both modes
		 */
		function getSlideDuration( indices ) {
			if ( !indices ) indices = slideIndices;
			var duration = 0;
			for ( var id = 0; id < 2; id++ ) {
				for ( var i = 0; i < storage[ id ].data.length; i++ ) {
					if ( storage[ id ].data[ i ].slide.h === 
						indices.h && storage[ id ].data[ i ].slide.v === 
						indices.v && storage[ id ].data[ i ].slide.f === indices.f ) {
						duration = Math.max( duration, storage[ id ].data[ i ].duration );
						break;
					}
				}
			}
			// console.log( duration );
			return duration;
		}

		/*****************************************************************
		 ** Print
		 ******************************************************************/
		var printMode = ( /print-pdf/gi ).test( window.location.search );
		// console.log("createPrintout" + printMode)

		function addPageNumbers() {
			// determine page number for printouts with fragments serialised
			var slides = Reveal.getSlides();
			var page = 0;
			for ( var i=0; i < slides.length; i++) {
				slides[i].setAttribute('data-pdf-page-number',page.toString());
				// add number of fragments without fragment indices
				var count = slides[i].querySelectorAll('.fragment:not([data-fragment-index])').length;
				var fragments = slides[i].querySelectorAll('.fragment[data-fragment-index]');
				for ( var j=0; j < fragments.length; j++) {
					// increasenumber of fragments by highest fragment index (which start at 0)
					if ( Number(fragments[j].getAttribute('data-fragment-index')) + 1 > count ) {
						count = Number(fragments[j].getAttribute('data-fragment-index')) + 1;
					}
				}
				// console.log(count,fragments.length,( slides[i].querySelector('h1,h2,h3,h4')||{}).innerHTML, page); 
				page += count + 1;
			}
		}

		function createPrintout() {
			//console.warn(Reveal.getTotalSlides(),Reveal.getSlidesElement());
			if ( storage[ 1 ].data.length == 0 ) return;
			console.log( 'Create printout(s) for ' + storage[ 1 ].data.length + " slides" );
			drawingCanvas[ 0 ].container.style.opacity = 0; // do not print notes canvas
			drawingCanvas[ 0 ].container.style.visibility = 'hidden';

			var patImg = new Image();
			patImg.onload = function () {
				var slides = Reveal.getSlides();
				//console.log(slides);
				for ( var i = storage[ 1 ].data.length - 1; i >= 0; i-- ) {
					// console.log( 'Create printout for slide ' + storage[ 1 ].data[ i ].slide.h 
                                        //                + '.' + storage[ 1 ].data[ i ].slide.v );
					var slideData = getSlideData( storage[ 1 ].data[ i ].slide, 1 );
					var drawings = createDrawings( slideData, patImg );
					// console.log("Page:", storage[ 1 ].data[ i ].page );
					// console.log("Slide:", slides[storage[ 1 ].data[ i ].page] );
					addDrawings( slides[storage[ 1 ].data[ i ].page], drawings );

				}
				// Reveal.sync();
			};
			patImg.src = background[ 1 ];
		}

		function cloneCanvas( oldCanvas ) {
			//create a new canvas
			var newCanvas = document.createElement( 'canvas' );
			var context = newCanvas.getContext( '2d' );
			//set dimensions
			newCanvas.width = oldCanvas.width;
			newCanvas.height = oldCanvas.height;
			//apply the old canvas to the new one
			context.drawImage( oldCanvas, 0, 0 );
			//return the new canvas
			return newCanvas;
		}

		function getCanvas( template, container, board ) {
			var idx = container.findIndex( element => element.board === board );
			if ( idx === -1 ) {
				var canvas = cloneCanvas( template );
				if ( !container.length ) {
					idx = 0;
					container.push( {
						board,
						canvas
					} );
				} else if ( board < container[ 0 ].board ) {
					idx = 0;
					container.unshift( {
						board,
						canvas
					} );
				} else if ( board > container[ container.length - 1 ].board ) {
					idx = container.length;
					container.push( {
						board,
						canvas
					} );
				}
			}

			return container[ idx ].canvas;
		}

		function createDrawings( slideData, patImg ) {
			var width = Reveal.getConfig().width;
			var height = Reveal.getConfig().height;
			var scale = 1;
			var xOffset = 0;
			var yOffset = 0;
			if ( width != storage[ 1 ].width || height != storage[ 1 ].height ) {
				scale = Math.min( width / storage[ 1 ].width, height / storage[ 1 ].height );
				xOffset = ( width - storage[ 1 ].width * scale ) / 2;
				yOffset = ( height - storage[ 1 ].height * scale ) / 2;
			}
			mode = 1;
			board = 0;
			// console.log( 'Create printout(s) for slide ', slideData );

			var drawings = [];
			var template = document.createElement( 'canvas' );
			template.width = width;
			template.height = height;

			var imgCtx = template.getContext( '2d' );
			imgCtx.fillStyle = imgCtx.createPattern( patImg, 'repeat' );
			imgCtx.rect( 0, 0, width, height );
			imgCtx.fill();

			for ( var j = 0; j < slideData.events.length; j++ ) {
				switch ( slideData.events[ j ].type ) {
				case 'draw':
					draw[ 1 ]( getCanvas( template, drawings, board ).getContext( '2d' ),
						xOffset + slideData.events[ j ].x1 * scale,
						yOffset + slideData.events[ j ].y1 * scale,
						xOffset + slideData.events[ j ].x2 * scale,
						yOffset + slideData.events[ j ].y2 * scale,
						yOffset + slideData.events[ j ].color
					);
					break;
				case 'erase':
					eraseWithSponge( getCanvas( template, drawings, board ).getContext( '2d' ),
						xOffset + slideData.events[ j ].x * scale,
						yOffset + slideData.events[ j ].y * scale
					);
					break;
				case 'selectboard':
					selectBoard( slideData.events[ j ].board );
					break;
				case 'clear':
					getCanvas( template, drawings, board ).getContext( '2d' ).clearRect( 0, 0, width, height );
					getCanvas( template, drawings, board ).getContext( '2d' ).fill();
					break;
				default:
					break;
				}
			}

			drawings = drawings.sort( ( a, b ) => a.board > b.board && 1 || -1 );

			mode = 0;

			return drawings;
		}

		function addDrawings( slide, drawings ) {
			var parent = slide.parentElement.parentElement;
			var nextSlide = slide.parentElement.nextElementSibling;

			for ( var i = 0; i < drawings.length; i++ ) {
				var newPDFPage = document.createElement( 'div' );
				newPDFPage.classList.add( 'pdf-page' );
				newPDFPage.style.height = Reveal.getConfig().height;
				newPDFPage.append( drawings[ i ].canvas );
	//console.log("Add drawing", newPDFPage);
				if ( nextSlide != null ) {
					parent.insertBefore( newPDFPage, nextSlide );
				} else {
					parent.append( newPDFPage );
				}
			}
		}

		/*****************************************************************
		 ** Drawings
		 ******************************************************************/

		function drawWithBoardmarker( context, fromX, fromY, toX, toY, colorIdx ) {
			if ( colorIdx == undefined ) colorIdx = color[ mode ];
			context.lineWidth = boardmarkerWidth;
			context.lineCap = 'round';
			context.strokeStyle = boardmarkers[ colorIdx ].color;
			context.beginPath();
			context.moveTo( fromX, fromY );
			context.lineTo( toX, toY );
			context.stroke();
		}

		function drawWithChalk( context, fromX, fromY, toX, toY, colorIdx ) {
			if ( colorIdx == undefined ) colorIdx = color[ mode ];
			var brushDiameter = chalkWidth;
			context.lineWidth = brushDiameter;
			context.lineCap = 'round';
			context.fillStyle = chalks[ colorIdx ].color; // 'rgba(255,255,255,0.5)';
			context.strokeStyle = chalks[ colorIdx ].color;
			/*var opacity = Math.min(0.8, Math.max(0,color[1].replace(/^.*,(.+)\)/,'$1') - 0.1)) + Math.random()*0.2;*/
			var opacity = 1.0;
			context.strokeStyle = context.strokeStyle.replace( /[\d\.]+\)$/g, opacity + ')' );
			context.beginPath();
			context.moveTo( fromX, fromY );
			context.lineTo( toX, toY );
			context.stroke();
			// Chalk Effect
			var length = Math.round( Math.sqrt( Math.pow( toX - fromX, 2 ) + Math.pow( toY - fromY, 2 ) ) / ( 5 / brushDiameter ) );
			var xUnit = ( toX - fromX ) / length;
			var yUnit = ( toY - fromY ) / length;
			for ( var i = 0; i < length; i++ ) {
				if ( chalkEffect > ( Math.random() * 0.9 ) ) {
					var xCurrent = fromX + ( i * xUnit );
					var yCurrent = fromY + ( i * yUnit );
					var xRandom = xCurrent + ( Math.random() - 0.5 ) * brushDiameter * 1.2;
					var yRandom = yCurrent + ( Math.random() - 0.5 ) * brushDiameter * 1.2;
					context.clearRect( xRandom, yRandom, Math.random() * 2 + 2, Math.random() + 1 );
				}
			}
		}
	 
		function eraseWithSponge( context, x, y ) {
			context.save();
			context.beginPath();
			context.arc( x, y, eraser.radius, 0, 2 * Math.PI, false );
			context.clip();
			context.clearRect( x - eraser.radius - 1, y - eraser.radius - 1, eraser.radius * 2 + 2, eraser.radius * 2 + 2 );
			context.restore();
			if ( mode == 1 && grid ) {
				redrawGrid( x, y, eraser.radius );
			}
		}


		/**
		 * Show an overlay for the chalkboard.
		 */
		function showChalkboard() {
	//console.log("showChalkboard");
			clearTimeout( touchTimeout );
			touchTimeout = null;
			drawingCanvas[ 0 ].sponge.style.visibility = 'hidden'; // make sure that the sponge from touch events is hidden
			drawingCanvas[ 1 ].sponge.style.visibility = 'hidden'; // make sure that the sponge from touch events is hidden
			drawingCanvas[ 1 ].container.style.opacity = 1;
			drawingCanvas[ 1 ].container.style.visibility = 'visible';
			mode = 1;
		}


		/**
		 * Closes open chalkboard.
		 */
		function closeChalkboard() {
			clearTimeout( touchTimeout );
			touchTimeout = null;
			drawingCanvas[ 0 ].sponge.style.visibility = 'hidden'; // make sure that the sponge from touch events is hidden
			drawingCanvas[ 1 ].sponge.style.visibility = 'hidden'; // make sure that the sponge from touch events is hidden
			drawingCanvas[ 1 ].container.style.opacity = 0;
			drawingCanvas[ 1 ].container.style.visibility = 'hidden';
			lastX = null;
			lastY = null;
			mode = 0;
		}

		/**
		 * Clear current canvas.
		 */
		function clearCanvas( id ) {
			if ( id == 0 ) clearTimeout( slidechangeTimeout );
			drawingCanvas[ id ].context.clearRect( 0, 0, drawingCanvas[ id ].width, drawingCanvas[ id ].height );
			if ( id == 1 && grid ) drawGrid();
		}

		/**
		 * Draw grid on background
		 */
		function drawGrid() {
			var context = drawingCanvas[ 1 ].context;

			drawingCanvas[ 1 ].scale = Math.min( drawingCanvas[ 1 ].width / storage[ 1 ].width, 
								drawingCanvas[ 1 ].height / storage[ 1 ].height );
			drawingCanvas[ 1 ].xOffset = ( drawingCanvas[ 1 ].width - storage[ 1 ].width * drawingCanvas[ 1 ].scale ) / 2;
			drawingCanvas[ 1 ].yOffset = ( drawingCanvas[ 1 ].height - storage[ 1 ].height * drawingCanvas[ 1 ].scale ) / 2;

			var scale = drawingCanvas[ 1 ].scale;
			var xOffset = drawingCanvas[ 1 ].xOffset;
			var yOffset = drawingCanvas[ 1 ].yOffset;

			var distance = grid.distance * scale;

			var fromX = drawingCanvas[ 1 ].width / 2 - distance / 2 - 
					Math.floor( ( drawingCanvas[ 1 ].width - distance ) / 2 / distance ) * distance;
			for ( var x = fromX; x < drawingCanvas[ 1 ].width; x += distance ) {
				context.beginPath();
				context.lineWidth = grid.width * scale;
				context.lineCap = 'round';
				context.fillStyle = grid.color;
				context.strokeStyle = grid.color;
				context.moveTo( x, 0 );
				context.lineTo( x, drawingCanvas[ 1 ].height );
				context.stroke();
			}
			var fromY = drawingCanvas[ 1 ].height / 2 - distance / 2 - 
					Math.floor( ( drawingCanvas[ 1 ].height - distance ) / 2 / distance ) * distance;

			for ( var y = fromY; y < drawingCanvas[ 1 ].height; y += distance ) {
				context.beginPath();
				context.lineWidth = grid.width * scale;
				context.lineCap = 'round';
				context.fillStyle = grid.color;
				context.strokeStyle = grid.color;
				context.moveTo( 0, y );
				context.lineTo( drawingCanvas[ 1 ].width, y );
				context.stroke();
			}
		}

		function redrawGrid( centerX, centerY, diameter ) {
			var context = drawingCanvas[ 1 ].context;

			drawingCanvas[ 1 ].scale = Math.min( drawingCanvas[ 1 ].width / storage[ 1 ].width, 
							drawingCanvas[ 1 ].height / storage[ 1 ].height );
			drawingCanvas[ 1 ].xOffset = ( drawingCanvas[ 1 ].width - storage[ 1 ].width * drawingCanvas[ 1 ].scale ) / 2;
			drawingCanvas[ 1 ].yOffset = ( drawingCanvas[ 1 ].height - storage[ 1 ].height * drawingCanvas[ 1 ].scale ) / 2;

			var scale = drawingCanvas[ 1 ].scale;
			var xOffset = drawingCanvas[ 1 ].xOffset;
			var yOffset = drawingCanvas[ 1 ].yOffset;

			var distance = grid.distance * scale;

			var fromX = drawingCanvas[ 1 ].width / 2 - distance / 2 - 
					Math.floor( ( drawingCanvas[ 1 ].width - distance ) / 2 / distance ) * distance;

			for ( var x = fromX + distance * Math.ceil( ( centerX - diameter - fromX ) / distance ); 
				x <= fromX + distance * Math.floor( ( centerX + diameter - fromX ) / distance ); x += distance ) {
				context.beginPath();
				context.lineWidth = grid.width * scale;
				context.lineCap = 'round';
				context.fillStyle = grid.color;
				context.strokeStyle = grid.color;
				context.moveTo( x, centerY - Math.sqrt( diameter * diameter - ( centerX - x ) * ( centerX - x ) ) );
				context.lineTo( x, centerY + Math.sqrt( diameter * diameter - ( centerX - x ) * ( centerX - x ) ) );
				context.stroke();
			}
			var fromY = drawingCanvas[ 1 ].height / 2 - distance / 2 - 
					Math.floor( ( drawingCanvas[ 1 ].height - distance ) / 2 / distance ) * distance;
			for ( var y = fromY + distance * Math.ceil( ( centerY - diameter - fromY ) / distance ); 
				y <= fromY + distance * Math.floor( ( centerY + diameter - fromY ) / distance ); y += distance ) {
				context.beginPath();
				context.lineWidth = grid.width * scale;
				context.lineCap = 'round';
				context.fillStyle = grid.color;
				context.strokeStyle = grid.color;
				context.moveTo( centerX - Math.sqrt( diameter * diameter - ( centerY - y ) * ( centerY - y ) ), y );
				context.lineTo( centerX + Math.sqrt( diameter * diameter - ( centerY - y ) * ( centerY - y ) ), y );
				context.stroke();
			}
		}

		/**
		 * Set the  color
		 */
		function setColor( index, record ) {
			// protect against out of bounds (this could happen when
			// replaying events recorded with different color settings).
			if ( index >= pens[ mode ].length ) index = 0;
			color[ mode ] = index;
			drawingCanvas[ mode ].canvas.style.cursor = pens[ mode ][ color[ mode ] ].cursor;
		}

		/**
		 * Set the  board
		 */
		function selectBoard( boardIdx, record ) {
	//console.log("Set board",boardIdx);
			if ( board == boardIdx ) return;

			board = boardIdx;
			redrawChalkboard( boardIdx );
			if ( record ) {
				recordEvent( { type: 'selectboard' } );
			}
		}

		function redrawChalkboard( boardIdx ) {
			clearCanvas( 1 );
			var slideData = getSlideData( slideIndices, 1 );
			var index = 0;
			var play = ( boardIdx == 0 );
			while ( index < slideData.events.length && slideData.events[ index ].time < Date.now() - slideStart ) {
				if ( boardIdx == slideData.events[ index ].board ) {
					playEvent( 1, slideData.events[ index ], Date.now() - slideStart );
				}

				index++;
			}
		}

		/**
		 * Forward cycle color
		 */
		function cycleColorNext() {
			color[ mode ] = ( color[ mode ] + 1 ) % pens[ mode ].length;
			return color[ mode ];
		}

		/**
		 * Backward cycle color
		 */
		function cycleColorPrev() {
			color[ mode ] = ( color[ mode ] + ( pens[ mode ].length - 1 ) ) % pens[ mode ].length;
			return color[ mode ];
		}

		/*****************************************************************
		 ** Broadcast
		 ******************************************************************/
		var eventQueue = [];

		document.addEventListener( 'received', function ( message ) {
			if ( message.content && message.content.sender == 'chalkboard-plugin' ) {
				// add message to queue
				eventQueue.push( message );
				// console.log( JSON.stringify( message ) );
			}
			if ( eventQueue.length == 1 ) processQueue();
		} );

		function processQueue() {
			// take first message from queue
			var message = eventQueue.shift();

			// synchronize time with seminar host
			slideStart = Date.now() - message.content.timestamp;
			// set status
			if ( mode < message.content.mode ) {
				// open chalkboard
				showChalkboard();
			} else if ( mode > message.content.mode ) {
				// close chalkboard
				closeChalkboard();
			}
			if ( board != message.content.board ) {
				board = message.content.board;
				redrawChalkboard( board );
			};

			switch ( message.content.type ) {
			case 'showChalkboard':
				showChalkboard();
				break;
			case 'closeChalkboard':
				closeChalkboard();
				break;
			case 'erase':
				erasePoint( message.content.x, message.content.y );
				break;
			case 'draw':
				drawSegment( message.content.fromX, message.content.fromY, message.content.toX, 
						message.content.toY, message.content.color );
				break;
			case 'clear':
				clearSlide();
				break;
			case 'selectboard':
				selectBoard( message.content.board, true );
				break;
			case 'resetSlide':
				resetSlideDrawings();
				break;
			case 'init':
				storage = message.content.storage;
				for ( var id = 0; id < 2; id++ ) {
					drawingCanvas[ id ].scale = Math.min( drawingCanvas[ id ].width / storage[ id ].width, 
									drawingCanvas[ id ].height / storage[ id ].height );
					drawingCanvas[ id ].xOffset = ( drawingCanvas[ id ].width - 
									storage[ id ].width * drawingCanvas[ id ].scale ) / 2;
					drawingCanvas[ id ].yOffset = ( drawingCanvas[ id ].height - 
									storage[ id ].height * drawingCanvas[ id ].scale ) / 2;
				}
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( !playback ) {
					slidechangeTimeout = setTimeout( startPlayback, transition, getSlideDuration(), 0 );
				}
				if ( mode == 1 && message.content.mode == 0 ) {
					setTimeout( closeChalkboard, transition + 50 );
				}
				if ( mode == 0 && message.content.mode == 1 ) {
					setTimeout( showChalkboard, transition + 50 );
				}
				mode = message.content.mode;
				board = message.content.board;
				break;
			default:
				break;
			}

			// continue with next message if queued
			if ( eventQueue.length > 0 ) {
				processQueue();
			} else {
				storageChanged();
			}
		}

		document.addEventListener( 'welcome', function ( user ) {
			// broadcast storage
			var message = new CustomEvent( messageType );
			message.content = {
				sender: 'chalkboard-plugin',
				recipient: user.id,
				type: 'init',
				timestamp: Date.now() - slideStart,
				storage: storage,
				mode,
				board
			};
			document.dispatchEvent( message );
		} );

		/*****************************************************************
		 ** Playback
		 ******************************************************************/
		document.addEventListener( 'seekplayback', function ( event ) {
	//console.log('event seekplayback ' + event.timestamp);
			stopPlayback();
			if ( !playback || event.timestamp == 0 ) {
				// in other cases startplayback fires after seeked
				startPlayback( event.timestamp );
			}
			//console.log('seeked');
		} );


		document.addEventListener( 'startplayback', function ( event ) {
	//console.log('event startplayback ' + event.timestamp);
			stopPlayback();
			playback = true;
			startPlayback( event.timestamp );
		} );

		document.addEventListener( 'stopplayback', function ( event ) {
	//console.log('event stopplayback ' + (Date.now() - slideStart) );
			playback = false;
			stopPlayback();
		} );

		document.addEventListener( 'startrecording', function ( event ) {
	//console.log('event startrecording ' + event.timestamp);
			startRecording();
		} );


		function startRecording() {
			resetSlide( true );
			slideStart = Date.now();
		}

		function startPlayback( timestamp, finalMode ) {
	//console.log("playback " + timestamp );
			slideStart = Date.now() - timestamp;
			closeChalkboard();
			mode = 0;
			board = 0;
			for ( var id = 0; id < 2; id++ ) {
				clearCanvas( id );
				var slideData = getSlideData( slideIndices, id );
	//console.log( timestamp +" / " + JSON.stringify(slideData));
				var index = 0;
				while ( index < slideData.events.length && slideData.events[ index ].time < ( Date.now() - slideStart ) ) {
					playEvent( id, slideData.events[ index ], timestamp );
					index++;
				}

				while ( playback && index < slideData.events.length ) {
					timeouts[ id ].push( setTimeout( playEvent, 
									slideData.events[ index ].time - ( Date.now() - slideStart ), 
									id, slideData.events[ index ], timestamp ) );
					index++;
				}
			}
	//console.log("Mode: " + finalMode + "/" + mode );
			if ( finalMode != undefined ) {
				mode = finalMode;
			}
			if ( mode == 1 ) showChalkboard();
	//console.log("playback (ok)");

		};

		function stopPlayback() {
	//console.log("stopPlayback");
	//console.log("Timeouts: " + timeouts[0].length + "/"+ timeouts[1].length);
			for ( var id = 0; id < 2; id++ ) {
				for ( var i = 0; i < timeouts[ id ].length; i++ ) {
					clearTimeout( timeouts[ id ][ i ] );
				}
				timeouts[ id ] = [];
			}
		};

		function playEvent( id, event, timestamp ) {
	//console.log( timestamp +" / " + JSON.stringify(event));
	//console.log( id + ": " + timestamp +" / " +  event.time +" / " + event.type +" / " + mode );
			switch ( event.type ) {
			case 'open':
				if ( timestamp <= event.time ) {
					showChalkboard();
				} else {
					mode = 1;
				}

				break;
			case 'close':
				if ( timestamp < event.time ) {
					closeChalkboard();
				} else {
					mode = 0;
				}
				break;
			case 'clear':
				clearCanvas( id );
				break;
			case 'selectboard':
				selectBoard( event.board );
				break;
			case 'draw':
				drawLine( id, event, timestamp );
				break;
			case 'erase':
				eraseCircle( id, event, timestamp );
				break;
			}
		};

		function drawLine( id, event, timestamp ) {
			var ctx = drawingCanvas[ id ].context;
			var scale = drawingCanvas[ id ].scale;
			var xOffset = drawingCanvas[ id ].xOffset;
			var yOffset = drawingCanvas[ id ].yOffset;
			draw[ id ]( ctx, xOffset + event.x1 * scale, yOffset + event.y1 * scale, 
					xOffset + event.x2 * scale, yOffset + event.y2 * scale, event.color );
		};

		function eraseCircle( id, event, timestamp ) {
			var ctx = drawingCanvas[ id ].context;
			var scale = drawingCanvas[ id ].scale;
			var xOffset = drawingCanvas[ id ].xOffset;
			var yOffset = drawingCanvas[ id ].yOffset;

			eraseWithSponge( ctx, xOffset + event.x * scale, yOffset + event.y * scale );
		};

		function startErasing( x, y ) {
			drawing = false;
			erasing = true;
			drawingCanvas[ mode ].sponge.style.visibility = 'visible';
			erasePoint( x, y );
		}

		function erasePoint( x, y ) {
			var ctx = drawingCanvas[ mode ].context;
			var scale = drawingCanvas[ mode ].scale;
			var xOffset = drawingCanvas[ mode ].xOffset;
			var yOffset = drawingCanvas[ mode ].yOffset;

			// move sponge image
			drawingCanvas[ mode ].sponge.style.left = ( x * scale + xOffset - eraser.radius ) + 'px';
			drawingCanvas[ mode ].sponge.style.top = ( y * scale + yOffset - 2 * eraser.radius ) + 'px';

			recordEvent( {
				type: 'erase',
				x,
				y
			} );

			if (
				x * scale + xOffset > 0 &&
				y * scale + yOffset > 0 &&
				x * scale + xOffset < drawingCanvas[ mode ].width &&
				y * scale + yOffset < drawingCanvas[ mode ].height
			) {
				eraseWithSponge( ctx, x * scale + xOffset, y * scale + yOffset );
			}
		}

		function stopErasing() {
			erasing = false;
			// hide sponge
			drawingCanvas[ mode ].sponge.style.visibility = 'hidden';
		}

		function startDrawing( x, y ) {
			drawing = true;

			var ctx = drawingCanvas[ mode ].context;
			var scale = drawingCanvas[ mode ].scale;
			var xOffset = drawingCanvas[ mode ].xOffset;
			var yOffset = drawingCanvas[ mode ].yOffset;
			lastX = x * scale + xOffset;
			lastY = y * scale + yOffset;
		}

		function drawSegment( fromX, fromY, toX, toY, colorIdx ) {
			var ctx = drawingCanvas[ mode ].context;
			var scale = drawingCanvas[ mode ].scale;
			var xOffset = drawingCanvas[ mode ].xOffset;
			var yOffset = drawingCanvas[ mode ].yOffset;

			recordEvent( {
				type: 'draw',
				color: colorIdx,
				x1: fromX,
				y1: fromY,
				x2: toX,
				y2: toY
			} );

			if (
				fromX * scale + xOffset > 0 &&
				fromY * scale + yOffset > 0 &&
				fromX * scale + xOffset < drawingCanvas[ mode ].width &&
				fromY * scale + yOffset < drawingCanvas[ mode ].height &&
				toX * scale + xOffset > 0 &&
				toY * scale + yOffset > 0 &&
				toX * scale + xOffset < drawingCanvas[ mode ].width &&
				toY * scale + yOffset < drawingCanvas[ mode ].height
			) {
				draw[ mode ]( ctx, fromX * scale + xOffset, fromY * scale + yOffset, 
						toX * scale + xOffset, toY * scale + yOffset, colorIdx );
			}
		}

		function stopDrawing() {
			drawing = false;
		}


		/*****************************************************************
		 ** User interface
		 ******************************************************************/

		function setupCanvasEvents( canvas ) {
			// TODO: check all touchevents
			canvas.addEventListener( 'touchstart', function ( evt ) {
				evt.preventDefault();
				//console.log("Touch start");
				if ( !readOnly && evt.target.getAttribute( 'data-chalkboard' ) == mode ) {
					var scale = drawingCanvas[ mode ].scale;
					var xOffset = drawingCanvas[ mode ].xOffset;
					var yOffset = drawingCanvas[ mode ].yOffset;

					var touch = evt.touches[ 0 ];
					mouseX = touch.pageX;
					mouseY = touch.pageY;
					startDrawing( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
					touchTimeout = setTimeout( startErasing, 500,  ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
				}
			}, passiveSupported ? {
				passive: false
			} : false );

			canvas.addEventListener( 'touchmove', function ( evt ) {
				evt.preventDefault();
				//console.log("Touch move");
				clearTimeout( touchTimeout );
				touchTimeout = null;
				if ( drawing || erasing ) {
					var scale = drawingCanvas[ mode ].scale;
					var xOffset = drawingCanvas[ mode ].xOffset;
					var yOffset = drawingCanvas[ mode ].yOffset;

					var touch = evt.touches[ 0 ];
					mouseX = touch.pageX;
					mouseY = touch.pageY;
					if ( mouseY < drawingCanvas[ mode ].height && mouseX < drawingCanvas[ mode ].width ) {
						// move sponge
						if ( event.type == 'erase' ) {
							drawingCanvas[ mode ].sponge.style.left = ( mouseX - eraser.radius ) + 'px';
							drawingCanvas[ mode ].sponge.style.top = ( mouseY - eraser.radius ) + 'px';
						}
					}

					if ( drawing ) {
						drawSegment( ( lastX - xOffset ) / scale, ( lastY - yOffset ) / scale, 
								( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale, color[ mode ] );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'draw',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							fromX: ( lastX - xOffset ) / scale,
							fromY: ( lastY - yOffset ) / scale,
							toX: ( mouseX - xOffset ) / scale,
							toY: ( mouseY - yOffset ) / scale,
							color: color[ mode ]
						};
						document.dispatchEvent( message );

						lastX = mouseX;
						lastY = mouseY;
					} else {
						erasePoint( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'erase',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							x: ( mouseX - xOffset ) / scale,
							y: ( mouseY - yOffset ) / scale
						};
						document.dispatchEvent( message );
					}

				}
			}, false );

			canvas.addEventListener( 'touchend', function ( evt ) {
				evt.preventDefault();
				clearTimeout( touchTimeout );
				touchTimeout = null;
				// hide sponge image
				drawingCanvas[ mode ].sponge.style.visibility = 'hidden';
				stopDrawing();
			}, false );

			canvas.addEventListener( 'mousedown', function ( evt ) {
				evt.preventDefault();
				if ( !readOnly && evt.target.getAttribute( 'data-chalkboard' ) == mode ) {
					// console.log( "mousedown: " + evt.button );
					var scale = drawingCanvas[ mode ].scale;
					var xOffset = drawingCanvas[ mode ].xOffset;
					var yOffset = drawingCanvas[ mode ].yOffset;

					mouseX = evt.pageX;
					mouseY = evt.pageY;

					if ( evt.button == 2 || evt.button == 1 ) {
						startErasing( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'erase',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							x: ( mouseX - xOffset ) / scale,
							y: ( mouseY - yOffset ) / scale
						};
						document.dispatchEvent( message );
					} else {
						startDrawing( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
					}
				}
			} );

			canvas.addEventListener( 'mousemove', function ( evt ) {
				evt.preventDefault();
				//console.log("Mouse move");
				if ( drawing || erasing ) {
					var scale = drawingCanvas[ mode ].scale;
					var xOffset = drawingCanvas[ mode ].xOffset;
					var yOffset = drawingCanvas[ mode ].yOffset;

					mouseX = evt.pageX;
					mouseY = evt.pageY;

					if ( drawing ) {
						drawSegment( ( lastX - xOffset ) / scale, ( lastY - yOffset ) / scale, 
								( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale, color[ mode ] );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'draw',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							fromX: ( lastX - xOffset ) / scale,
							fromY: ( lastY - yOffset ) / scale,
							toX: ( mouseX - xOffset ) / scale,
							toY: ( mouseY - yOffset ) / scale,
							color: color[ mode ]
						};
						document.dispatchEvent( message );

						lastX = mouseX;
						lastY = mouseY;
					} else {
						erasePoint( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'erase',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							x: ( mouseX - xOffset ) / scale,
							y: ( mouseY - yOffset ) / scale
						};
						document.dispatchEvent( message );
					}

				}
			} );

			canvas.addEventListener( 'mouseup', function ( evt ) {
				evt.preventDefault();
				drawingCanvas[ mode ].canvas.style.cursor = pens[ mode ][ color[ mode ] ].cursor;
				if ( drawing || erasing ) {
					stopDrawing();
					stopErasing();
				}
			} );
		}

		function resize() {
			//console.log("resize");
			// Resize the canvas and draw everything again
			var timestamp = Date.now() - slideStart;
			if ( !playback ) {
				timestamp = getSlideDuration();
			}

			//console.log( drawingCanvas[0].scale + "/" + drawingCanvas[0].xOffset + "/" +drawingCanvas[0].yOffset );
			for ( var id = 0; id < 2; id++ ) {
				drawingCanvas[ id ].width = window.innerWidth;
				drawingCanvas[ id ].height = window.innerHeight;
				drawingCanvas[ id ].canvas.width = drawingCanvas[ id ].width;
				drawingCanvas[ id ].canvas.height = drawingCanvas[ id ].height;
				drawingCanvas[ id ].context.canvas.width = drawingCanvas[ id ].width;
				drawingCanvas[ id ].context.canvas.height = drawingCanvas[ id ].height;

				drawingCanvas[ id ].scale = Math.min( drawingCanvas[ id ].width / storage[ id ].width, 
									drawingCanvas[ id ].height / storage[ id ].height );
				drawingCanvas[ id ].xOffset = ( drawingCanvas[ id ].width - storage[ id ].width * drawingCanvas[ id ].scale ) / 2;
				drawingCanvas[ id ].yOffset = ( drawingCanvas[ id ].height - storage[ id ].height * drawingCanvas[ id ].scale ) / 2;
				//console.log( drawingCanvas[id].scale + "/" + drawingCanvas[id].xOffset + "/" +drawingCanvas[id].yOffset );
			}
			//console.log( window.innerWidth + "/" + window.innerHeight);
			startPlayback( timestamp, mode, true );
		}

		Reveal.addEventListener( 'pdf-ready', function ( evt ) {
			//console.log( "Create printouts when ready" );
			whenLoaded( createPrintout );
		});

		Reveal.addEventListener( 'ready', function ( evt ) {
			//console.log('ready');
			if ( !printMode ) {
				window.addEventListener( 'resize', resize );

				slideStart = Date.now() - getSlideDuration();
				slideIndices = Reveal.getIndices();
				if ( !playback ) {
					startPlayback( getSlideDuration(), 0 );
				}
				if ( Reveal.isAutoSliding() ) {
					var event = new CustomEvent( 'startplayback' );
					event.timestamp = 0;
					document.dispatchEvent( event );
				}
				updateStorage();
				whenReady( addPageNumbers );
			}
		} );
		Reveal.addEventListener( 'slidechanged', function ( evt ) {
			//clearTimeout( slidechangeTimeout );
			//console.log('slidechanged');
			if ( !printMode ) {
				slideStart = Date.now() - getSlideDuration();
				slideIndices = Reveal.getIndices();
				closeChalkboard();
				board = 0;
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( !playback ) {
					slidechangeTimeout = setTimeout( startPlayback, transition, getSlideDuration(), 0 );
				}
				if ( Reveal.isAutoSliding() ) {
					var event = new CustomEvent( 'startplayback' );
					event.timestamp = 0;
					document.dispatchEvent( event );
				}
			}
		} );
		Reveal.addEventListener( 'fragmentshown', function ( evt ) {
			//clearTimeout( slidechangeTimeout );
			//console.log('fragmentshown');
			if ( !printMode ) {
				slideStart = Date.now() - getSlideDuration();
				slideIndices = Reveal.getIndices();
				closeChalkboard();
				board = 0;
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( Reveal.isAutoSliding() ) {
					var event = new CustomEvent( 'startplayback' );
					event.timestamp = 0;
					document.dispatchEvent( event );
				} else if ( !playback ) {
					startPlayback( getSlideDuration(), 0 );
					//closeChalkboard();
				}
			}
		} );
		Reveal.addEventListener( 'fragmenthidden', function ( evt ) {
		//clearTimeout( slidechangeTimeout );
		//console.log('fragmenthidden');
			if ( !printMode ) {
				slideStart = Date.now() - getSlideDuration();
				slideIndices = Reveal.getIndices();
				closeChalkboard();
				board = 0;
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( Reveal.isAutoSliding() ) {
					document.dispatchEvent( new CustomEvent( 'stopplayback' ) );
				} else if ( !playback ) {
					startPlayback( getSlideDuration() );
					closeChalkboard();
				}
			}
		} );

		Reveal.addEventListener( 'autoslideresumed', function ( evt ) {
			//console.log('autoslideresumed');
			var event = new CustomEvent( 'startplayback' );
			event.timestamp = 0;
			document.dispatchEvent( event );
		} );
		Reveal.addEventListener( 'autoslidepaused', function ( evt ) {
			//console.log('autoslidepaused');
			document.dispatchEvent( new CustomEvent( 'stopplayback' ) );

			// advance to end of slide
			//closeChalkboard();
			startPlayback( getSlideDuration(), 0 );
		} );

		function toggleNotesCanvas() {
			if ( !readOnly ) {
				if ( mode == 1 ) {
					toggleChalkboard();
					notescanvas.style.background = background[ 0 ]; //'rgba(255,0,0,0.5)';
					notescanvas.style.pointerEvents = 'auto';
				}
				else {
					if ( notescanvas.style.pointerEvents != 'none' ) {
						// hide notes canvas
						if ( colorButtons ) {
							notescanvas.querySelector( '.palette' ).style.visibility = 'hidden';
						}
						notescanvas.style.background = 'rgba(0,0,0,0)';
						notescanvas.style.pointerEvents = 'none';
					}
					else {
						// show notes canvas
						if ( colorButtons ) {
							notescanvas.querySelector( '.palette' ).style.visibility = 'visible';
						}
						notescanvas.style.background = background[ 0 ]; //'rgba(255,0,0,0.5)';
						notescanvas.style.pointerEvents = 'auto';

						var idx = 0;
						if ( color[ mode ] ) {
							idx = color[ mode ];
						}

						setColor( idx, true );
					}
				}
			}
		};

		function toggleChalkboard() {
			//console.log("toggleChalkboard " + mode);
			if ( mode == 1 ) {
				if ( !readOnly ) {
					recordEvent( { type: 'close' } );
				}
				closeChalkboard();

				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'closeChalkboard',
					timestamp: Date.now() - slideStart,
					mode: 0,
					board
				};
				document.dispatchEvent( message );


			} else {
				showChalkboard();
				if ( !readOnly ) {
					recordEvent( { type: 'open' } );
					// broadcast
					var message = new CustomEvent( messageType );
					message.content = {
						sender: 'chalkboard-plugin',
						type: 'showChalkboard',
						timestamp: Date.now() - slideStart,
						mode: 1,
						board
					};
					document.dispatchEvent( message );

					var idx = 0;

					if ( rememberColor[ mode ] ) {
						idx = color[ mode ];
					}

					setColor( idx, true );
				}
			}
		};

		function clearSlide() {
			recordEvent( { type: 'clear' } );
			clearCanvas( mode );
		}

		function clear() {
			if ( !readOnly ) {
				clearSlide();
				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'clear',
					timestamp: Date.now() - slideStart,
					mode,
					board
				};
				document.dispatchEvent( message );
			}
		};

		function colorIndex( idx ) {
			// console.log("colorIndex() idx: ", idx);
			if ( !readOnly ) {
				setColor( idx, true );
			}
		}

		function colorNext() {
			if ( !readOnly ) {
				let idx = cycleColorNext();
				setColor( idx, true );
			}
		}

		function colorPrev() {
			if ( !readOnly ) {
				let idx = cycleColorPrev();
				setColor( idx, true );
			}
		}

		function resetSlideDrawings() {
			slideStart = Date.now();
			closeChalkboard();

			clearCanvas( 0 );
			clearCanvas( 1 );

			mode = 1;
			var slideData = getSlideData();
			slideData.duration = 0;
			slideData.events = [];
			mode = 0;
			var slideData = getSlideData();
			slideData.duration = 0;
			slideData.events = [];

			updateStorage();
		}

		function resetSlide( force ) {
			var ok = force || confirm( "Please confirm to delete chalkboard drawings on this slide!" );
			if ( ok ) {
	//console.log("resetSlide ");
				stopPlayback();
				resetSlideDrawings();
				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'resetSlide',
					timestamp: Date.now() - slideStart,
					mode,
					board
				};
				document.dispatchEvent( message );
			}
		};

		function resetStorage( force ) {
			var ok = force || confirm( "Please confirm to delete all chalkboard drawings!" );
			if ( ok ) {
				stopPlayback();
				slideStart = Date.now();
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( mode == 1 ) {
					closeChalkboard();
				}

				storage = [ {
						width: Reveal.getConfig().width,
						height: Reveal.getConfig().height,
						data: []
					},
					{
						width: Reveal.getConfig().width,
						height: Reveal.getConfig().height,
						data: []
					}
				];

				if ( config.storage ) {
					sessionStorage.setItem( config.storage, null )
				}
				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'init',
					timestamp: Date.now() - slideStart,
					storage,
					mode,
					board
				};
				document.dispatchEvent( message );
			}
		};

		function toggleChalkboard() {
			//console.log("toggleChalkboard " + mode);
			if ( mode == 1 ) {
				if ( !readOnly ) {
					recordEvent( { type: 'close' } );
				}
				closeChalkboard();

				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'closeChalkboard',
					timestamp: Date.now() - slideStart,
					mode: 0,
					board
				};
				document.dispatchEvent( message );


			} else {
				showChalkboard();
				if ( !readOnly ) {
					recordEvent( { type: 'open' } );
					// broadcast
					var message = new CustomEvent( messageType );
					message.content = {
						sender: 'chalkboard-plugin',
						type: 'showChalkboard',
						timestamp: Date.now() - slideStart,
						mode: 1,
						board
					};
					document.dispatchEvent( message );

					var idx = 0;

					if ( rememberColor[ mode ] ) {
						idx = color[ mode ];
					}

					setColor( idx, true );
				}
			}
		};

		this.toggleNotesCanvas = toggleNotesCanvas;
		this.toggleChalkboard = toggleChalkboard;
		this.colorIndex = colorIndex;
		this.colorNext = colorNext;
		this.colorPrev = colorPrev;
		this.clear = clear;
		this.reset = resetSlide;
		this.resetAll = resetStorage;
		this.download = downloadData;
		this.updateStorage = updateStorage;
		this.getData = getData;
		this.configure = configure;

		window.RevealChalkboard = window.RevealChalkboard || {
			id: 'RevealChalkboard',
			init: function ( deck ) {
				initChalkboard.call(this, deck );
			},
			configure: function ( config ) {
				configure( config );
			},
			toggleNotesCanvas: function () {
				toggleNotesCanvas();
			},
			toggleChalkboard: function () {
				toggleChalkboard();
			},
			colorIndex: function () {
				colorIndex();
			},
			colorNext: function () {
				colorNext();
			},
			colorPrev: function () {
				colorPrev();
			},
			clear: function () {
				clear();
			},
			reset: function () {
				reset();
			},
			resetAll: function () {
				resetAll();
			},
			updateStorage: function () {
				updateStorage();
			},
			getData: function () {
				return getData();
			},
			download: function () {
				download();
			},
		};

		for ( var key in keyBindings ) {
			if ( keyBindings[ key ] ) {
				Reveal.addKeyBinding( keyBindings[ key ], RevealChalkboard[ key ] );
			}
		};

		return this;
	}, 

	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	** Author: Asvin Goel, goel@telematique.eu
	**
	** A plugin for reveal.js creating an online seminar.
	**
	** Version: 0.4.4
	**
	** License: MIT license (see LICENSE.md)
	**
	******************************************************************/

	defaultLogger( event ) {
          // console.log( event  );
          // document.getElementById("seminar-status").innerHTML = event;
	},

	initSeminar: function(Reveal) {
		let that = this;

		var printMode = ( /print-pdf/gi ).test( window.location.search );
		if ( printMode ) return;

		var seminar = Reveal.getConfig().seminar || {};
		if ( !seminar.server ) {
			alert("Seminar server not specified!");
			return;
		}
		seminar.url = seminar.url || window.location.host; 
		seminar.room = seminar.room || seminar.url;
		if ( !seminar.hash ) {
			alert("Hash not specified!");
			return;
		}

		const logger = seminar.logger || that.defaultLogger;

		var socket = io.connect( seminar.server, {
			transports: ['websocket'],
			// withCredentials: true
			withCredentials: false
		});
		logger('initSeminar() socket: ', socket);

		if ( seminar.callback )
		   logger('connect to ', seminar.server);
		socket.on('connect', function() {
			logger('connected to ' + seminar.server);
		});

		const STATUS = {"CHECKEDIN": 1, "JOINING": 2, "JOINED": 3, "HOSTING": 4, "CHAIRING": 5};

		var username = null;
		var status = null;

		var receivedState = null;

		function connected() {
			return ( status >= STATUS.JOINED );
		}

		function hosting() {
			return ( status >= STATUS.HOSTING );
		}

		function dispatchStatus() {
			var event = new CustomEvent('seminar');
			event.status = status;
			document.dispatchEvent( event );
		}

		var wakeLock = null; // null -> Wake Lock API not supported

		if ( 'wakeLock' in navigator ) {
			wakeLock = false; 
        //		console.log("Screen Wake Lock API supported");
	//		logger("Screen Wake Lock API supported");
		}

		async function requestWakeLock() {
			if ( wakeLock === false ) {
				try {
					wakeLock = await navigator.wakeLock.request('screen');
	//				console.log('Wake Lock is active!');
					// logger('Wake Lock is active!');
					wakeLock.addEventListener('release', () => {
						// the wake lock has been released
	//					console.log('Wake Lock has been released');
						// logger('Wake Lock has been released');
						wakeLock = false;
					});
				} catch (err) {
					// The Wake Lock request has failed - usually system related, such as battery.
					console.warn(`${err.name}, ${err.message}`);
					wakeLock = false; 
				}
			}
		}

		function releaseWakeLock() {
			if ( wakeLock ) {
				wakeLock.release();
			}
		}

		document.addEventListener('visibilitychange', async () => {
			if ( document.visibilityState === 'visible' && connected() ) {
				requestWakeLock();
			}
		});

		function checkin( name ) {
			if ( status && name && username != name ) {
				// check out if user name changed
				socket.emit('checkout');
				status = null;
			}

			if ( !status ) {
				// use socket id as user name if not user name is not provided
				username = name || username || socket.id;

				// checkin to socket sever
				socket.emit('checkin', username, function( error ){
					if (error) {
						logger( error );
					}
					else {
						status = STATUS.CHECKEDIN;
						dispatchStatus();
						logger( `checked in as ${username}` );
					}
				});
			}
		}

		function open_or_join_room( secret ) {

			if ( status >= STATUS.HOSTING ) {
				// already hosting, ignore request to host
				logger( 'already hosting, ignoring request to host' );
				return;
			}
			if ( status == STATUS.JOINED ) {
				// leave room as participant before entering as host
				leave_room();
			}
			if ( status == STATUS.JOINING ) {
				status = STATUS.CHECKEDIN;
				dispatchStatus();
			}

			// logger( 'open_or_join_room() socket: ', socket );
			// open or join a seminar as host
			socket.emit('host_room', { venue: seminar.url, name: seminar.room, hash: seminar.hash, secret }, function( error ){
			        logger( `socket.emit host room "${seminar.url}|${seminar.room}|${seminar.hash}"` );
				if (error) {
					// console.warn( error );
					// logger( error );
		        		logger( 'host room failed' );
					that.seminar_hosted = false;
                                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
                                        document.getElementById("div_seminar_close").style.visibility = 'hidden';
				}
				else {
					// assume that room is opened and change status later if another host is chair 
					status = Math.max(status, STATUS.HOSTING);
					dispatchStatus();
		        		logger( 'host room succeed' );
					makeHost();
					requestWakeLock();
					that.Reveal.next();
					that.Reveal.right();
					that.seminar_hosted = true;
                                        document.getElementById("div_seminar_host").style.visibility = 'hidden';
                                        document.getElementById("div_seminar_room").style.visibility = 'visible';
                                        document.getElementById("div_seminar_close").style.visibility = 'visible';
				}
			});
		}

		function leave_room() {
			socket.emit('leave_room', { venue: seminar.url, name: seminar.room, hash: seminar.hash }, function( error ){
				if (error) {
					logger( error );
				}
				else {
					status = STATUS.CHECKEDIN;
					dispatchStatus();
					logger( `left room "${seminar.url}|${seminar.room}|${seminar.hash}"` );
					releaseWakeLock();
				}
			});
		}

		function close_room( secret ) {
			socket.emit('close_room', { venue: seminar.url, name: seminar.room, hash: seminar.hash, secret }, function( error ){
				if (error) {
					logger( error );
				}
				else {
					status = STATUS.CHECKEDIN;
					dispatchStatus();
					logger( `room closed "${seminar.url}|${seminar.room}|${seminar.hash}"` );
					releaseWakeLock();
					that.seminar_hosted = false;
                                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
                                        document.getElementById("div_seminar_close").style.visibility = 'hidden';
				}
			});
		}

		function join_room() {
			// join a seminar as regular participant
			socket.emit('join_room', { venue: seminar.url, name: seminar.room, hash: seminar.hash }, function( error ){
				logger(`try to join room "${seminar.url}|${seminar.room}|${seminar.hash}"` );
				if (error) {
					logger( error );
                                        that.seminar_joined = false;   
                                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
					status = STATUS.JOINING;
					dispatchStatus();
					releaseWakeLock();
				}
				else {
					logger( `joined room "${seminar.url}|${seminar.room}|${seminar.hash}" as ${socket.id}` );
                                        that.seminar_joined = true;   
                                        document.getElementById("div_seminar_host").style.visibility = 'hidden';
                                        document.getElementById("div_seminar_room").style.visibility = 'visible';
					subscribe();
					status = STATUS.JOINED;
					dispatchStatus();
					requestWakeLock();
				}
			});
		}
		/*
		function announce( evt, cc ) {
			// make an announcement to everyone (else)
		}

		function send( evt, recipient, cc ) {
			// send a message to recipient
		}
		*/	
		/*
		function receive( message ) {
			// receive and process a message
			if ( message.state ) {
				receivedState = message.state;
				Reveal.setState( message.state );
			}
			if ( message.content ) {
				// forward custom events to other plugins
				var event = new CustomEvent('received');
				event.content = message.content;
				document.dispatchEvent( event );
			}
		}
		*/
		function sendMessage( evt ) {
			// send message w/o copy
			var data = {
				venue: seminar.url, 
				name: seminar.room,
				hash: seminar.hash, 
				recipient: (evt.content || {}).recipient,
				copy: (evt.content || {}).copy, 
				content: evt.content
			};
			if ( data.content ) {
				delete data.content.recipient;
				delete data.content.copy;
			}
			socket.emit( 'message', data );
		};

		function subscribe() {
			document.addEventListener( 'send', function( evt ) { 
				if ( !evt ) return;
				// send custom events which are sent by other plugins
				sendMessage(evt); 
			});
		}

		function broadcastState( evt ) {
			var data = {
				venue: seminar.url, 
				name: seminar.room,
				hash: seminar.hash, 
				recipient: null,
				copy: (evt.content || {}).copy, 
				content: { state: Reveal.getState(), custom: (evt || {}).content }
			};
			if ( data.content ) {
				delete data.content.recipient;
				delete data.content.copy;
			}
			socket.emit( 'announcement', data );
		};

		function stateChange( state ) {
			var current = Reveal.getState();
			return ( !state || !( 
			     current.indexh == state.indexh &&
			     current.indexv == state.indexv &&
			     current.indexf == state.indexf &&
			     current.paused == state.paused &&
			     current.overview == state.overview
			   ));

		}

		function broadcastStateChange( evt ) {
			if ( stateChange( receivedState ) ) {
				// broadcast state change 
				broadcastState( evt );
			}
			else {
				// ignore state change if the state is the same as the last state received 
				receivedState = null;
			}
		}

		function makeHost() {
			// Ignore notes windows
			if ( window.location.search.match( /receiver/gi ) ) return;

			subscribe();
			// Monitor events that trigger a change in state
			Reveal.on( 'slidechanged', broadcastStateChange );
			Reveal.on( 'fragmentshown', broadcastStateChange );
		
			Reveal.on( 'fragmenthidden', broadcastStateChange );
			Reveal.on( 'overviewhidden', broadcastStateChange );
			Reveal.on( 'overviewshown', broadcastStateChange );
			Reveal.on( 'paused', broadcastStateChange );
			Reveal.on( 'resumed', broadcastStateChange );
			document.addEventListener( 'broadcast', function( evt ) { 
				// broadcast custom events w/o recipient which are sent by other plugins
				if ( evt && !evt.recipient ) {
					broadcastState(evt); 
				}
			});
		}

		/*
		socket.on('rooms', ( rooms ) => {
			console.log(rooms);
		});
		*/
		socket.on('room_opened', ( room ) => {
			logger( `room opened "${room.venue}|${room.name}|..."` );

			if ( status == STATUS.JOINING && room.venue == seminar.url && room.name == seminar.room ) {
				// try to join room as regular participant
				join_room();
			}
		});

		socket.on('kicked_out', ( room ) => {
			logger( `kicked out of room "${room.venue}|${room.name}|${room.hash}"` );
			leave_room();
                        that.seminar_joined = false;   
                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
			that.seminar_hosted = false;
                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
                        document.getElementById("div_seminar_close").style.visibility = 'hidden';
			if ( status >= STATUS.JOINED ) {
				// tell other plugins that user is kicked out of the room
				var event = new CustomEvent('kicked_out');
				event.content = room;
				document.dispatchEvent( event );
				status = STATUS.JOINING;
				dispatchStatus();
				releaseWakeLock();
			}
		});

		socket.on('chair', ( room ) => {
			logger( `chairing room "${room.venue}|${room.name}|${room.hash}"` );
			status = STATUS.CHAIRING;
			dispatchStatus();
		});

		socket.on('participants', ({ room, hosts, participants }) => {
			// make sure to only accept messages within same scope (should not be necessary)
			if ( room.venue != seminar.url || room.name != seminar.room || room.hash != seminar.hash ) return; 

			// inform other plugins about participants
			var event = new CustomEvent('participants');
			event.content = { hosts, participants };
			document.dispatchEvent( event );
		});

		socket.on('entered_room', ({ room, user }) => {
			// make sure to only accept messages within same scope (should not be necessary)
			if ( room.venue != seminar.url || room.name != seminar.room || room.hash != seminar.hash ) return; 
			logger(`${user.id} entered room "${room.venue}|${room.name}|${room.hash}"` );

			if ( status == STATUS.CHAIRING ) {
				// send current state to the new participant
				// tell other plugins that they can send a welcome message to the new participant
				var event = new CustomEvent('welcome');
				event.content = { user };
				document.dispatchEvent( event );
			}
		});

		socket.on('announcement', (  { time, room, sender, content } ) => {
			// console.log("Received message: ", content );
			// make sure to only accept messages within same scope (should not be necessary)
			if ( room.venue != seminar.url || room.name != seminar.room || room.hash != seminar.hash ) return; 

			if ( content.state && stateChange( content.state ) ) {
				// change slide if necessary
				receivedState = content.state;
				Reveal.setState(content.state);
			}
			if ( content.custom ) {
				// console.log("Received announcement: ", content.custom.timestamp, content.custom.type );
				// forward custom events to other plugins
				var event = new CustomEvent('received');
				event.content = content.custom;
				document.dispatchEvent( event );
			}
		});

		socket.on('message', (  { time, room, sender, content } ) => {
			// console.log(`received message: ", content );
			// make sure to only accept messages within same scope (should not be necessary)
			if ( room.venue != seminar.url || room.name != seminar.room || room.hash != seminar.hash ) return; 

			if ( content ) {
				// forward custom events to other plugins
				var event = new CustomEvent('received');
				event.content = content;
				document.dispatchEvent( event );
			}
		});
		
		// automatically join room as participant if data is provided
		if ( seminar.autoJoin && seminar.url && seminar.room && seminar.hash ) {
			checkin();

			if ( seminar.secret ) {
				// if secret is provided open or join room as host
				open_or_join_room( seminar.secret );
			}
			else {
				// join existing room as regular participant
				join_room();
			}
		}

		this.checkin = checkin;
		this.open_or_join_room = open_or_join_room;
		this.join_room = join_room;
		this.leave_room = leave_room;
		this.close_room = close_room;
		this.connected = connected;
		this.hosting = hosting;

		window.RevealSeminar = window.RevealSeminar || {
		    id: 'RevealSeminar',
		    init: function(deck) {
			initSeminar(deck);
		    },
		    open_or_join_room: function( secret, username ) { 
			checkin( username );
			open_or_join_room( secret ); 
		    },
		    join_room: function( username ) {
			checkin( username );
			join_room(); 
		    },
		    leave_room: function() { leave_room(); },
		    close_room: function( secret ) { close_room( secret ); },
		    connected: function() { return connected(); },
		    hosting: function() { return hosting(); },
		};

		return this;
	},

	generateToken(length) {
		var token = "";
		while ( token.length < length ) {
			token += (Math.random() * new Date().getTime()).toString(36).replace(/\./g, '');
		}
		return token.substr(0,length);
	},

	getParameterByName(name, url) {
	    if (!url) {
	      url = window.location.href;
	    }
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	},

	addParam(url, param, value) {
		var a = document.createElement('a'), regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
		var match, str = []; a.href = url; param = encodeURIComponent(param);
		while (match = regex.exec(a.search)) {
			if (param != match[1]) str.push(match[1]+(match[2]?"="+match[2]:""));
		}
		str.push(param+(value?"="+ encodeURIComponent(value):""));
		a.search = str.join("&");
		return a.href;
	},

	logger( event ) {
		// console.log( event ); 
		// document.getElementById("seminar-status").innerHTML = event;
	},
 
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	** Author: Asvin Goel, goel@telematique.eu
	**
	** A plugin for reveal.js adding instant polls within an 
	** online seminar.
	**
	** Version: 0.1.1
	**
	** License: MIT license (see LICENSE.md)
	**
	******************************************************************/

	initPoll: function(Reveal) {
		let that = this;

		var config = Reveal.getConfig().poll;

		var polls = [];

		// Get poll index
		function getPollIndex(id) {
			return polls.findIndex(poll => poll.id === id);
		}

		function initializePolls() {
			var pollElements = document.querySelectorAll(".poll");
	//console.log(polls);
			for (var i = 0; i < pollElements.length; i++ ){
				var id = pollElements[i].getAttribute('data-poll')
				var votes = {};
				var buttons = pollElements[i].querySelectorAll("button");
				for (var j = 0; j < buttons.length; j++ ){
					// initialize number of votes for button
					votes[buttons[j].getAttribute('data-value')] = 0; 

					// make button clickable
					buttons[j].addEventListener('click', function(evt){
						if ( !RevealSeminar.connected() ) {
							alert("You are currently not connected to the live poll. Your vote is ignored.");
							return;
						}
						const button = evt.target;
						const poll = button.parentElement;
						var siblings = poll.querySelectorAll("button");
						for (var i = 0; i < siblings.length; i++ ){
							siblings[i].disabled = true;
						}
						vote( poll.getAttribute('data-poll'), button.getAttribute('data-value') );
						button.classList.add("selected"); 
						button.blur();
					});
				}
				polls.push( { id, voters: 0, votes} );
	//console.log(polls);
			}

		}

		function vote( poll, choice ) {
			// send to vote to chair
			var message = new CustomEvent('send');
			message.content = { sender: 'poll-plugin', recipient: true, type: 'vote', poll, choice };
			document.dispatchEvent( message );
		}

		document.addEventListener( 'received', function ( message ) {
			if ( message.content && message.content.sender == 'poll-plugin' ) {
	//console.log("Update: ", message.content);
				if ( message.content.type == 'vote' ) {
					const vote = message.content;
					const poll = polls[getPollIndex(message.content.poll)];
					// increment number of voters
					poll.voters++;
					var message = new CustomEvent('broadcast');
					message.content = { sender: 'poll-plugin', copy: true, type: 'voters', poll: poll.id, voters: poll.voters };
					document.dispatchEvent( message );

					// update results
					poll.votes[vote.choice]++;
	//console.log("Vote '" + vote.choice + "' received for poll ", poll );
					message = new CustomEvent('broadcast');
					message.content = { sender: 'poll-plugin', copy: true, type: 'results', poll: poll.id, votes: poll.votes };
	//console.log("Send results", message );
					document.dispatchEvent( message );
				}
				else if ( message.content.type == 'voters' ) {
	//console.log("voters", message.content )
					var voters = document.querySelectorAll('.voters[data-poll="' + message.content.poll + '"]');
					for (var j = 0; j < voters.length; j++ ){
						voters[j].innerHTML = message.content.voters;
					}

				}
				else if ( message.content.type == 'results' ) {
					// update result elements
					var results = document.querySelectorAll('.results[data-poll="' + message.content.poll + '"]');
	//console.log("Results", results )
					for (var i = 0; i < results.length; i++ ) {
	//console.log("Votes", message.content.votes )
						for (var choice in message.content.votes) {
	//console.log(choice);
							var elements = results[i].querySelectorAll('[data-value="' + choice + '"]');
							for (var j = 0; j < elements.length; j++ ) {
								elements[j].innerHTML = message.content.votes[choice];
							}
						}
					}

					// update result charts
	// console.log("RevealChart: ", RevealChart);

					if ( RevealChart ) {
						var charts = document.querySelectorAll('canvas[data-chart][data-poll="' + message.content.poll + '"]');	
						var data = [];
						for (var choice in message.content.votes) {
							data.push(message.content.votes[choice]);
						}
	// console.log("data: ", data);
						for (var i = 0; i < charts.length; i++ ) {
							RevealChart.update( charts[i], 0, data );
						}
					}

				}
			}
		});

		Reveal.addEventListener('ready', function(){
	//alert("READY");
			initializePolls();
		});
	
		window.RevealPoll = window.RevealPoll || {
	    		id: 'RevealPoll',
	    		init: function(deck) {
				initPoll(deck);
	    		},
		};

		return this;
	},

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	** Author: Asvin Goel, goel@telematique.eu
	** Fixed for Reveal4: kotborealis@awooo.ru
	**
	** A plugin for reveal.js allowing to integrate Chart.js
	**
	** Version: 1.3.1
	**
	** License: MIT license (see LICENSE.md)
	**
	******************************************************************/

	/**
	 * Reveal Plugin
	 * https://revealjs.com/creating-plugins/
	 */

	initChart: function(Reveal) {
		let that = this;

		function parseJSON(str) {
		    var json;
		    try {
			json = JSON.parse(str);
		    } catch (e) {
			return null;
			}
		    return json;
		}

		/*
		* Recursively merge properties of two objects
		*/
		function mergeRecursive(obj1, obj2) {

		  for (var p in obj2) {
		    try {
		      // Property in destination object set; update its value.
		      if ( obj1[p] !== null && typeof obj1[p] === 'object' && typeof obj2[p] === 'object' ) {
			obj1[p] = mergeRecursive(obj1[p], obj2[p]);
		      } 
		      else {
			obj1[p] = obj2[p];
		      }
		    } catch(e) {
		      // Property in destination object not set; create it and set its value.
		      obj1[p] = obj2[p];
		    }
		  }

		  return obj1;
		}

		function createChart(canvas, CSV, comments) {
			canvas.chart = null;
			var ctx = canvas.getContext("2d");
			var chartOptions = { responsive: true, maintainAspectRatio: false };
			var chartData = { labels: null, datasets: []};
			if ( comments !== null ) for (var j = 0; j < comments.length; j++ ){
				comments[j] = comments[j].replace(/<!--/,'');
				comments[j] = comments[j].replace(/-->/,'');
				var config = parseJSON(comments[j]);
				if ( config ) {
					if ( config.data ) {
						mergeRecursive( chartData, config.data);
					}
					if ( config.options ) {
						mergeRecursive( chartOptions, config.options);
					}
				}
			}

			// var lines = CSV.split('\n').filter(function(v){return v!==''});
			var lines = CSV.split(';').filter(function(v){return v!==''});
			// if labels are not defined, get them from first line
			if ( chartData.labels === null && lines.length > 0 ) {
				chartData.labels = lines[0].split(',');
				chartData.labels.shift();
				lines.shift();
			}
			// get data values
			for (var j = 0; j < lines.length; j++ ){
				if (chartData.datasets.length <= j) chartData.datasets[j] = {};
				chartData.datasets[j].data =  lines[j].split(','); //.filter(function(v){return v!==''});
				chartData.datasets[j].label = chartData.datasets[j].data[0];
				chartData.datasets[j].data.shift();
				for (var k = 0; k < chartData.datasets[j].data.length; k++ ){
					chartData.datasets[j].data[k] = Number(chartData.datasets[j].data[k]);
				}
			}

			// add chart options
			var config = chartConfig[canvas.getAttribute("data-chart")];
			if ( config ) {
				for (var j = 0; j < chartData.datasets.length; j++ ){
					for (var attrname in config) {
						if ( !chartData.datasets[j][attrname]  ) {
							chartData.datasets[j][attrname] = config[attrname][j%config[attrname].length];
						}
					}
				}
			}

			canvas.chart = new Chart(ctx, { type: canvas.getAttribute("data-chart"), data: chartData, options: chartOptions });

		}

		function updateChart(canvas, idx, data) {
	
	/*		
	console.log("canvas: ", canvas);
	console.log("idx: ", idx);
	console.log("data: ", data);
	console.log("canvas.chart: ", canvas.chart);
	console.log("canvas.chart.data: ", canvas.chart.data);
	console.log("canvas.chart.data.datasets[idx]: ", canvas.chart.data.datasets[idx]);
	 */
			canvas.chart.data.datasets[idx].data = data;
			recreateChart( canvas );
		}

		var initializeCharts = function(){
			// Get all canvases
			var canvases = document.querySelectorAll("canvas");
			for (var i = 0; i < canvases.length; i++ ){
				// check if canvas has data-chart attribute
				if ( canvases[i].hasAttribute("data-chart") ){
					var CSV = canvases[i].innerHTML.trim();
					var comments = CSV.match(/<!--[\s\S]*?-->/g);
					CSV = CSV.replace(/<!--[\s\S]*?-->/g,'').replace(/^\s*\n/gm, "")
					if ( ! canvases[i].hasAttribute("data-chart-src") ) {
						createChart(canvases[i], CSV, comments);
					}
					else {
						var canvas = canvases[i];
						var xhr = new XMLHttpRequest();
						xhr.onload = function() {
							if (xhr.readyState === 4) {
								createChart(canvas, xhr.responseText, comments);
							}
							else {
								console.warn( 'Failed to get file ' + canvas.getAttribute("data-chart-src") + 
										". ReadyState: " + xhr.readyState + ", Status: " + xhr.status);
							}
						};

						xhr.open( 'GET', canvas.getAttribute("data-chart-src"), false );
						try {
							xhr.send();
						}
						catch ( error ) {
							console.warn( 'Failed to get file ' + canvas.getAttribute("data-chart-src") + 
									'. Make sure that the presentation and the file are served by ' + 
									'a HTTP server and the file can be found there. ' + error );
						}
					}

				}
			}
		}

		function recreateChart(canvas) {
			// clear data to redraw animation
			var data = canvas.chart.data.datasets;
			canvas.chart.data.datasets = []; 
			canvas.chart.update();
			canvas.style.visibility = "hidden";
			setTimeout( function(canvas, data) { 
				canvas.chart.data.datasets = data; 
				canvas.style.visibility = "visible"; 
				canvas.chart.update(); 
			}, 500, canvas, data); // wait for slide transition to re-add data and animation
	/*
			var config = canvas.chart.config;
			canvas.chart.destroy();
			setTimeout( function() { canvas.chart = new Chart(canvas, config);}, 500); // wait for slide transition
	*/
		}

		// check if chart option is given or not
		var chartConfig = Reveal.getConfig().chart || {};

		// set global chart options
		var config = chartConfig.defaults;
		if ( config ) {
			mergeRecursive(Chart.defaults, config);
		}

		Reveal.addEventListener('ready', function(){
			initializeCharts();
			Reveal.addEventListener('slidechanged', function(){
				var canvases = Reveal.getCurrentSlide().querySelectorAll("canvas[data-chart]");
				for (var i = 0; i < canvases.length; i++ ){
					if ( canvases[i].chart  && canvases[i].chart.config.options.animation !== false ) {
						recreateChart( canvases[i] );
					}
				}

			});
		});

		this.update = updateChart;

		window.RevealChart = window.RevealChart || {
		    id: 'RevealChart',
		    init: function(deck) {
			initChart(deck);
		    },
		    update: function(canvas, idx, data) { updateChart(canvas, idx, data); },
		};

		return this;
	},

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	** Author: Asvin Goel, goel@telematique.eu
	**
	** A plugin for reveal.js adding a Q&A to an online seminar.
	**
	** Version: 0.1.2
	**
	** License: MIT license (see LICENSE.md)
	**
	******************************************************************/

	initQnA: function(Reveal) {
		let that = this;

		var config = Reveal.getConfig().questions || {};
		const STATUS = {"JOINED": 3, "HOSTING": 4};
		var connected = false;
		var questions = 0;
		var counter = 0;

		// create Q&A div
		var container = document.createElement("div");
		container.classList.add("qna");
		container.classList.add("dashboard");
		container.classList.add("overlay");
		container.style.visibility = "hidden";
		container.setAttribute( 'data-prevent-swipe', '' );

		container.oncontextmenu = function() { return false; }
		container.style.zIndex = 26;

		container.innerHTML = "<h1> Q&A </h1>";

		// question template
		var questionTemplate = document.createElement('div');
		questionTemplate.classList.add("qna");
		questionTemplate.classList.add("question");
		questionTemplate.innerHTML = 	'<div class="user">Anonymous</div>' +
					'<div class="text">Text</div>' +
					'<div class="votes"><span>-1</span> <i class="fa fa-thumbs-up"></i></div>' +
					'<div class="close"><i class="fa fa-check"></i></div>';

		container.innerHTML = '<div class="qna ask"><input type="text" placeholder="Enter question" required="" autocomplete="off"></input>' + 
					'<button>Ask <i class="fa fa-paper-plane"></button></div>';

		container.querySelector("input").addEventListener('keypress', function( e ) {
			e.stopPropagation(); // consume all key presses and do not allow other to listen to them
			if (e.which === 13) {
				// ask question when hitting enter
				this.nextSibling.click();
			}
		});

		container.querySelector("button").addEventListener('click', function() {
			var inputElement = this.parentElement.firstChild;
			if ( inputElement.value ) {
				ask( inputElement.value );
	//			createQuestion( { id: 0, text: inputElement.value, user: "Anonymous", votes: 0, open: true } );
				inputElement.value = "";
			}
		});

		var questionList = document.createElement("div");
		questionList.classList.add("qna");
		questionList.classList.add("questions");
		container.appendChild(questionList);
		document.querySelector( '.reveal' ).appendChild( container );

		var toggleQnAButton = config.toggleQnAButton || false;

		if ( toggleQnAButton ) {
	console.warn( "toggleQnAButton is deprecated, use customcontrols plugin instead!" );
			var button = document.createElement( 'div' );
			button.className = "toggle-questions";
			button.id = "toggle-questions";
			button.style.visibility = "hidden";
			button.style.position = "absolute";
			button.style.zIndex = 30;
			button.style.fontSize = "24px";

			button.style.left = toggleQnAButton.left || "30px";
			button.style.bottom = toggleQnAButton.bottom ||  "30px";
			button.style.top = toggleQnAButton.top ||  "auto";
			button.style.right = toggleQnAButton.right ||  "auto";

			button.innerHTML = '<a href="#" title="Toggle Q&A dashboard (Q)" onclick="RevealQnA.toggleQnA(); return false;">' +
					'<span class="fa-stack" style="margin: -10px;"><span class="fa fa-comment fa-stack-1x"></span>' + 
					'<strong class="fa-stack-1x fa-inverse qna question-counter" style="font-size:0.5em;"></strong></span>' +
					// <i class="fa fa-comment"></i>
					'</a>';
			document.querySelector(".reveal").appendChild( button );
		}

	/*
		function initializeQnA() {

		}
	*/

		function toggleQnA( show ) {
			if ( show == undefined ) {
				show = document.querySelector('.qna.dashboard').style.visibility == "hidden";
			}

			document.querySelector('.qna.dashboard').style.visibility = show ? "visible" : "hidden";
		}

		function getQuestion( id ) {
			// returns undefined if question is not found
			return document.querySelector(`.qna.question[data-id="${id}"]`);
		}

		function ask( text ) {
			// ask a question
			var message = new CustomEvent('send');
			message.content = { sender: 'questions-plugin', recipient: true, type: 'ask', text, username: 'Anonymous' };
			document.dispatchEvent( message );
		}

		function upvote( questionElement ) {
	//		questionElement.question.votes++;
			var message = new CustomEvent('send');
			message.content = { sender: 'questions-plugin', recipient: true, type: 'upvote', id: questionElement.question.id  };
			document.dispatchEvent( message );
		}

		function close( questionElement ) {
			// close a question (only host)
			var question = Object.assign({}, questionElement.question );
			question.open = false;

			var message = new CustomEvent('broadcast');
			message.content = { sender: 'questions-plugin', copy: true, question };
			document.dispatchEvent( message );
		}

		function bubbleUp ( questionElement ) {
			// bubble question upwards if necessary
			while ( questionElement.previousSibling ) {
				if ( questionElement.question.votes > questionElement.previousSibling.question.votes || 
					questionElement.question.open > questionElement.previousSibling.question.open ) {
					questionElement = questionElement.parentElement.insertBefore( questionElement, questionElement.previousSibling );
				}
				else {
					break;
				}
			}
			return questionElement;
		};

		function bubbleDown ( questionElement ) {
			// bubble question downwards if necessary
			while ( questionElement.nextSibling ) {
				if ( questionElement.nextSibling.question.open > questionElement.question.open || 
					questionElement.nextSibling.question.votes > questionElement.question.votes  ) {
					questionElement = questionElement.parentElement.insertBefore( questionElement, 
								questionElement.nextSibling.nextSibling );
				}
				else {
					break;
				}
			}
			return questionElement;
		};

		function createQuestion( question ) {
			// add new question and show it
			var div = questionTemplate.cloneNode(true);
			div.dataset.id = question.id;

			div.querySelector(".user").innerHTML = question.username;
			div.querySelector(".votes > span").innerHTML = question.votes;
			div.querySelector(".text").innerHTML = question.text;

			div.querySelector(".votes").addEventListener( 'click', function( e ) {
				if ( !this.classList.contains("disabled") && !this.parentElement.classList.contains("closed") ) {
					this.classList.add("disabled");
					upvote( this.parentElement );
				}
			});

			if ( RevealSeminar.hosting() && question.open ) {
				div.querySelector(".close").addEventListener( 'click', function( e ) {
					if ( !this.parentElement.classList.contains("closed") ) {
						close( this.parentElement );
					}
				});
			}
			else {
				div.querySelector(".close").style.visibility = "hidden";
			}

			div.question = question;

			// increment open question counter
			if ( question.open ) {
				counter++;
				var elements = document.querySelectorAll('.qna.question-counter');
				for ( var i=0; i < elements.length; i++ ) {
					elements[i].innerHTML = counter;
				}
			}
			else {
				div.classList.add("closed");	
			}

			return bubbleUp( document.querySelector('.qna > .questions').appendChild(div) );
		}

		document.addEventListener( 'seminar', function ( message ) {
			// update status
	//console.log(message.status);
			var connected = ( message.status >= STATUS.JOINED );
			var buttons = document.querySelectorAll('#toggle-questions');
			for (var i = 0; i < buttons.length; i++) {
				buttons[i].style.display = connected ? "inherit" : "none";
			}
			if ( !connected ) {
				toggleQnA( false ); // close Q&A
				Reveal.removeKeyBinding( 81 );
			}
			else {
				Reveal.addKeyBinding( { keyCode: 81, key: 'Q', description: 'Toggle Q&A' }, () => {
					toggleQnA();
				} )
			}
		});

		document.addEventListener( 'received', function ( message ) {
			if ( message.content && message.content.sender == 'questions-plugin' ) {
	//console.log("Received", message.content);
				switch (message.content.type) {
					case 'ask':
	//if ( !RevealSeminar.hosting() ) alert("I should be host!");
						questions++;
	//console.log("Broadcast", message.content.text);
						var event = new CustomEvent('broadcast');
						event.content = { sender: 'questions-plugin', copy: true, 
								  question: { id: questions, username: message.content.username, 
									      text: message.content.text, votes: 0, open: true} };
						document.dispatchEvent( event );
					break;
					case 'upvote':
	//if ( !RevealSeminar.hosting() ) alert("I should be host!");
						var questionElement = getQuestion(message.content.id);
	//console.log(message.content.id, questionElement);
						var question = Object.assign({}, questionElement.question);
						question.votes++;
						var event = new CustomEvent('broadcast');
						event.content = { sender: 'questions-plugin', copy: true, question };
						document.dispatchEvent( event );
	//					questionElement.question.votes--; // undo increment and do it later again
					break;
					default:
						var questionElement = getQuestion(message.content.question.id);
						if ( !questionElement ) {
							createQuestion( message.content.question );
							break;
						}
					
	//console.log("Update", questionElement.question, message.content.question);
						// update existing question
						if ( questionElement.question.open && !message.content.question.open ) {
	//console.log("Close");
							// decrement open question counter
							counter--;
							var elements = document.querySelectorAll('.qna.question-counter');
							for ( var i=0; i < elements.length; i++ ) {
								elements[i].innerHTML = (counter == 0) ? '' : counter;
							}
		
							// close question
							questionElement.classList.add("closed");	

							// update data
							questionElement.question = message.content.question;
							bubbleDown( questionElement );
						}
						else if ( questionElement.question.votes < message.content.question.votes ) {
	//console.log("Upvoted", questionElement.question.votes , message.content.question.votes);
							// update votes
							var element = questionElement.querySelector('.votes > span');
							if ( element ) {
								element.innerHTML = message.content.question.votes;
							}

							// update data
							questionElement.question = message.content.question;
							bubbleUp( questionElement );
						}

				}
			}
		});

		this.toggleQnA = toggleQnA;

		window.RevealQnA = window.RevealQnA || {
		    id: 'RevealQnA',
		    init: function(deck) {
			initQnA(deck);
		    },
		    toggleQnA: function() { toggleQnA(); },
		};

		return this;
	},

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*!
	 * Handles finding a text string anywhere in the slides and showing the next occurrence to the user
	 * by navigatating to that slide and highlighting it.
	 *
	 * @author Jon Snyder <snyder.jon@gmail.com>, February 2013
	 */

	// const Plugin = () => {
	initSearch: function(Reveal) {
		let that = this;

		// The reveal.js instance this plugin is attached to
		let deck = Reveal;

		let searchElement;
		let searchButton;
		let searchInput;

		let matchedSlides;
		let currentMatchedIndex;
		let searchboxDirty;
		let hilitor;

		function render() {

			searchElement = document.createElement( 'div' );
			searchElement.classList.add( 'searchbox' );
			searchElement.style.position = 'absolute';
			searchElement.style.top = '10px';
			searchElement.style.right = '10px';
			searchElement.style.zIndex = 10;

			//embedded base64 search icon Designed by Sketchdock - http://www.sketchdock.com/:
			searchElement.innerHTML = `<input type="search" class="searchinput" placeholder="Search..." style="vertical-align: top;"/>
			</span>`;

			searchInput = searchElement.querySelector( '.searchinput' );
			searchInput.style.width = '240px';
			searchInput.style.fontSize = '14px';
			searchInput.style.padding = '4px 6px';
			searchInput.style.color = '#000';
			searchInput.style.background = '#fff';
			searchInput.style.borderRadius = '2px';
			searchInput.style.border = '0';
			searchInput.style.outline = '0';
			searchInput.style.boxShadow = '0 2px 18px rgba(0, 0, 0, 0.2)';
			searchInput.style['-webkit-appearance']  = 'none';

			deck.getRevealElement().appendChild( searchElement );

			// searchButton.addEventListener( 'click', function(event) {
			// 	doSearch();
			// }, false );

			searchInput.addEventListener( 'keyup', function( event ) {
				switch (event.keyCode) {
					case 13:
						event.preventDefault();
						doSearch();
						searchboxDirty = false;
						break;
					default:
						searchboxDirty = true;
				}
			}, false );

			closeSearch();

		}

		function openSearch() {
			if( !searchElement ) render();

			searchElement.style.display = 'inline';
			searchInput.focus();
			searchInput.select();
		}

		function closeSearch() {
			if( !searchElement ) render();

			searchElement.style.display = 'none';
			if(hilitor) hilitor.remove();
		}

		function toggleSearch() {
			if( !searchElement ) render();

			if (searchElement.style.display !== 'inline') {
				openSearch();
			}
			else {
				closeSearch();
			}
		}

		function doSearch() {
			//if there's been a change in the search term, perform a new search:
			if (searchboxDirty) {
				var searchstring = searchInput.value;

				if (searchstring === '') {
					if(hilitor) hilitor.remove();
					matchedSlides = null;
				}
				else {
					//find the keyword amongst the slides
					hilitor = new Hilitor("slidecontent");
					matchedSlides = hilitor.apply(searchstring);
					currentMatchedIndex = 0;
				}
			}

			if (matchedSlides) {
				//navigate to the next slide that has the keyword, wrapping to the first if necessary
				if (matchedSlides.length && (matchedSlides.length <= currentMatchedIndex)) {
					currentMatchedIndex = 0;
				}
				if (matchedSlides.length > currentMatchedIndex) {
					deck.slide(matchedSlides[currentMatchedIndex].h, matchedSlides[currentMatchedIndex].v);
					currentMatchedIndex++;
				}
			}
		}

		// Original JavaScript code by Chirp Internet: www.chirp.com.au
		// Please acknowledge use of this code by including this header.
		// 2/2013 jon: modified regex to display any match, not restricted to word boundaries.
		function Hilitor(id, tag) {

			var targetNode = document.getElementById(id) || document.body;
			var hiliteTag = tag || "EM";
			var skipTags = new RegExp("^(?:" + hiliteTag + "|SCRIPT|FORM)$");
			var colors = ["#ff6", "#a0ffff", "#9f9", "#f99", "#f6f"];
			var wordColor = [];
			var colorIdx = 0;
			var matchRegex = "";
			var matchingSlides = [];

			this.setRegex = function(input)
			{
				input = input.replace(/^[^\w]+|[^\w]+$/g, "").replace(/[^\w'-]+/g, "|");
				matchRegex = new RegExp("(" + input + ")","i");
			}

			this.getRegex = function()
			{
				return matchRegex.toString().replace(/^\/\\b\(|\)\\b\/i$/g, "").replace(/\|/g, " ");
			}

			// recursively apply word highlighting
			this.hiliteWords = function(node)
			{
				if(node == undefined || !node) return;
				if(!matchRegex) return;
				if(skipTags.test(node.nodeName)) return;

				if(node.hasChildNodes()) {
					for(var i=0; i < node.childNodes.length; i++)
						this.hiliteWords(node.childNodes[i]);
				}
				if(node.nodeType == 3) { // NODE_TEXT
					var nv, regs;
					if((nv = node.nodeValue) && (regs = matchRegex.exec(nv))) {
						//find the slide's section element and save it in our list of matching slides
						var secnode = node;
						while (secnode != null && secnode.nodeName != 'SECTION') {
							secnode = secnode.parentNode;
						}

						var slideIndex = deck.getIndices(secnode);
						var slidelen = matchingSlides.length;
						var alreadyAdded = false;
						for (var i=0; i < slidelen; i++) {
							if ( (matchingSlides[i].h === slideIndex.h) && (matchingSlides[i].v === slideIndex.v) ) {
								alreadyAdded = true;
							}
						}
						if (! alreadyAdded) {
							matchingSlides.push(slideIndex);
						}

						if(!wordColor[regs[0].toLowerCase()]) {
							wordColor[regs[0].toLowerCase()] = colors[colorIdx++ % colors.length];
						}

						var match = document.createElement(hiliteTag);
						match.appendChild(document.createTextNode(regs[0]));
						match.style.backgroundColor = wordColor[regs[0].toLowerCase()];
						match.style.fontStyle = "inherit";
						match.style.color = "#000";

						var after = node.splitText(regs.index);
						after.nodeValue = after.nodeValue.substring(regs[0].length);
						node.parentNode.insertBefore(match, after);
					}
				}
			};

			// remove highlighting
			this.remove = function()
			{
				var arr = document.getElementsByTagName(hiliteTag);
				var el;
				while(arr.length && (el = arr[0])) {
					el.parentNode.replaceChild(el.firstChild, el);
				}
			};

			// start highlighting at target node
			this.apply = function(input)
			{
				if(input == undefined || !input) return;
				this.remove();
				this.setRegex(input);
				this.hiliteWords(targetNode);
				return matchingSlides;
			};

		}

                /*
		return {

			id: 'search',

			init: reveal => {

				deck = reveal;
				deck.registerKeyboardShortcut( 'CTRL + Shift + F', 'Search' );

				document.addEventListener( 'keydown', function( event ) {
					if( event.key == "F" && (event.ctrlKey || event.metaKey) ) { //Control+Shift+f
						event.preventDefault();
						toggleSearch();
					}
				}, false );

			},

			open: openSearch,
			toggle: toggleSearch,

		}
                 */

		Reveal.registerKeyboardShortcut( 'CTRL + Shift + F', 'Search' );

		document.addEventListener( 'keydown', function( event ) {
			if( event.key == "F" && (event.ctrlKey || event.metaKey) ) { //Control+Shift+f
				event.preventDefault();
				toggleSearch();
			}
		}, false );

		// this.toggleQnA = toggleQnA;

		window.RevealSearch = window.RevealSearch || {
		    id: 'search',
		    init: function(deck) {
			initSearch(deck);
		    },
		    open: function() { openSearch(); },
		    toggle: function() { toggleSearch(); },
		};

		return this;
	}, 

    }, // end of methods 
 
  } // end of export default
</script>


<style scoped>
  @import "reveal.js/dist/reveal.css";
  @import "reveal.js/dist/theme/white.css";
  @import "reveal.js/plugin/highlight/monokai.css";
  @import "@/assets/css/fontawesome-free-6.4.0-web/css/all.css";
  @import "@/assets/css/menu.css";
  @import "@/assets/css/customcontrols.css";
  @import "@/assets/css/title-footer.css";
  @import "@/assets/css/chalkboard.css";
  @import "@/assets/css/poll.css";
  @import "@/assets/css/questions.css";

  @import "@/assets/css/globalslidescn.css";
</style>
